
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3bfdb7183e8721d6$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $cfae44f0dfdf62c0$exports.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
$3bfdb7183e8721d6$exports = $3bfdb7183e8721d6$var$posix;


var $eca075ad100d834d$exports = {};
"use strict";



class $0a5588a683073f93$export$60332b2344f7fe41 {
    constructor(name, imageUrl){
        this.name = name;
        this.imageUrl = imageUrl;
    }
    serialize() {
        const imageNameWithoutQuery = this.imageUrl.split("?")[0];
        const imageName = $3bfdb7183e8721d6$exports.basename(imageNameWithoutQuery); // Get only the file name
        return {
            name: this.name
        };
    }
    static async deserialize(data, directoryPath) {
        const cardName = data.name;
        console.log("Looking for " + cardName);
        const imagePath = await $0a5588a683073f93$export$60332b2344f7fe41.findImagePathRecursive(directoryPath, cardName);
        if (!imagePath) throw new Error(`Image for card "${cardName}" not found in directory: ${directoryPath}`);
        console.log("Found path! " + imagePath + " for card name " + cardName);
        return new $0a5588a683073f93$export$60332b2344f7fe41(cardName, imagePath);
    }
    static async findImagePathRecursive(directoryPath, cardName) {
        console.log("Reading directory for card " + cardName + " in " + directoryPath);
        const files = await $eca075ad100d834d$exports.promises.readdir(directoryPath); // Use the passed directory path
        console.log("Files found in " + directoryPath + ": " + files.length);
        for (const file of files){
            const filePath = $3bfdb7183e8721d6$exports.join(directoryPath, file);
            const stat = await $eca075ad100d834d$exports.promises.stat(filePath);
            if (stat.isDirectory()) {
                // Recursively search in subdirectory
                const found = await $0a5588a683073f93$export$60332b2344f7fe41.findImagePathRecursive(filePath, cardName);
                if (found) return found;
            } else if (stat.isFile()) {
                // Improved matching logic: exact match on file basename
                const baseName = $3bfdb7183e8721d6$exports.basename(file, ".png"); // Strip .png and compare
                if (baseName.toLowerCase() === cardName.toLowerCase()) return filePath;
            }
        }
        // Return null if not found
        return null;
    }
}
class $0a5588a683073f93$export$9b013bad9d0245d0 {
    constructor(){
        this.cards = [];
        /*
        if (cards.length == 0) {
            this.cards = [];
        } else {
            this.cards = cards;
        }
        */ //this.cards = [];
        this.cards = new Array();
    }
    // Function to add a card to the deck
    addCard(card) {
        if (card != undefined) this.cards.push(card);
        else console.warn("adding an undefined card");
    }
    // Function to shuffle the deck
    shuffle() {
        for(let i = this.cards.length - 1; i > 0; i--){
            const j = Math.floor((0, $b4e14b6b8da86996$export$cd94982b18c6332c).random() * (i + 1));
            [this.cards[i], this.cards[j]] = [
                this.cards[j],
                this.cards[i]
            ];
        }
    }
    // Function to get the top card of the deck
    takeTopCard() {
        return this.cards.pop();
    }
    viewTopCard() {
        return this.cards[this.cards.length - 1];
    }
    getCardCount() {
        return this.cards.length;
    }
    listCardNames() {
        return this.cards.map((card)=>card.name);
    }
    serialize() {
        return {
            cards: this.cards.map((card)=>card.serialize())
        };
    }
    static async deserialize(data, directoryPath) {
        // Ensure all card deserialization operations complete using Promise.all
        const cards = await Promise.all(data.cards.map(async (cardData)=>{
            console.log("got card data to deserialize:", cardData);
            return await $0a5588a683073f93$export$60332b2344f7fe41.deserialize(cardData, directoryPath);
        }));
        console.log("got cards", cards);
        return new $0a5588a683073f93$export$9b013bad9d0245d0();
    }
}


var $d9c0525122484bdf$exports = {};
$d9c0525122484bdf$exports = new URL("Objective_v2_S1_Clearer.5a7dabe5.png", import.meta.url).toString();


var $4fa89501a44a0f9f$exports = {};
$4fa89501a44a0f9f$exports = new URL("Objective_v2_S1_Cruncher.66548c8b.png", import.meta.url).toString();


var $b00cb674107b1d1d$exports = {};
$b00cb674107b1d1d$exports = new URL("Objective_v2_S1_Edges.ea623f42.png", import.meta.url).toString();


var $068a78867a901629$exports = {};
$068a78867a901629$exports = new URL("Objective_v2_S1_LeftSampler.a951a709.png", import.meta.url).toString();


var $976330d12e2a3dea$exports = {};
$976330d12e2a3dea$exports = new URL("Objective_v2_S1_Loner.b4724272.png", import.meta.url).toString();


var $22b7d2f010ed5c16$exports = {};
$22b7d2f010ed5c16$exports = new URL("Objective_v2_S1_MetalBonus.4e1c21c9.png", import.meta.url).toString();


var $636c594034620b10$exports = {};
$636c594034620b10$exports = new URL("Objective_v2_S1_Socialite.0024ebe6.png", import.meta.url).toString();


var $b5f7a63ddd7a82be$exports = {};
$b5f7a63ddd7a82be$exports = new URL("Objective_v2_S1_Spacer.6185c060.png", import.meta.url).toString();


var $b21e78937c3f44fd$exports = {};
$b21e78937c3f44fd$exports = new URL("Objective_v2_S1_WideSpacer.86edc316.png", import.meta.url).toString();


var $76bfbebb5650700d$exports = {};
$76bfbebb5650700d$exports = new URL("Objective_v2_S2_AnimalHandler.5a4d31aa.png", import.meta.url).toString();


var $f917eba161e585c1$exports = {};
$f917eba161e585c1$exports = new URL("Objective_v2_S2_Borders.14a6cfa3.png", import.meta.url).toString();


var $6395356e67498a22$exports = {};
$6395356e67498a22$exports = new URL("Objective_v2_S2_CenterSampler.3ef289d3.png", import.meta.url).toString();


var $fd63decc3af03ee6$exports = {};
$fd63decc3af03ee6$exports = new URL("Objective_v2_S2_CrossOver.3a89dd4b.png", import.meta.url).toString();


var $9be49999e38d978e$exports = {};
$9be49999e38d978e$exports = new URL("Objective_v2_S2_MeritEarner.e2e21704.png", import.meta.url).toString();


var $fe98761d4159ba15$exports = {};
$fe98761d4159ba15$exports = new URL("Objective_v2_S2_Minimalist.09829771.png", import.meta.url).toString();


var $92c6c6657785d7ac$exports = {};
$92c6c6657785d7ac$exports = new URL("Objective_v2_S2_Moderate.b47c98c8.png", import.meta.url).toString();


var $c0ed07d672003b66$exports = {};
$c0ed07d672003b66$exports = new URL("Objective_v2_S2_Organizer.6d57d3a1.png", import.meta.url).toString();


var $c7c58162a02e7239$exports = {};
$c7c58162a02e7239$exports = new URL("Objective_v2_S2_Shrimp.06dfaabc.png", import.meta.url).toString();


var $ac30237cd1792c99$exports = {};
$ac30237cd1792c99$exports = new URL("Objective_v2_S3_Biggen.95b26b61.png", import.meta.url).toString();


var $ceb38c0e9f554181$exports = {};
$ceb38c0e9f554181$exports = new URL("Objective_v2_S3_CargoMaster.c9306686.png", import.meta.url).toString();


var $abc6d0ea84008005$exports = {};
$abc6d0ea84008005$exports = new URL("Objective_v2_S3_Centrist.5661234f.png", import.meta.url).toString();


var $4284327e8498de19$exports = {};
$4284327e8498de19$exports = new URL("Objective_v2_S3_Lefty.823e8516.png", import.meta.url).toString();


var $541ace5e44f5a041$exports = {};
$541ace5e44f5a041$exports = new URL("Objective_v2_S3_Packed.65f5bfb7.png", import.meta.url).toString();


var $944d5dfebb8e768b$exports = {};
$944d5dfebb8e768b$exports = new URL("Objective_v2_S3_Righty.78ee2f56.png", import.meta.url).toString();


var $c7cfa03b872b0c3c$exports = {};
$c7cfa03b872b0c3c$exports = new URL("Objective_v2_S3_SeasonedWorker.06d00500.png", import.meta.url).toString();


var $21c82075533a9dd3$exports = {};
$21c82075533a9dd3$exports = new URL("Objective_v2_S3_TrueFriend.40520879.png", import.meta.url).toString();


var $0d4df08da377cab7$exports = {};
$0d4df08da377cab7$exports = new URL("Objective_v2_S3_VarietyPack.1d721ac4.png", import.meta.url).toString();


var $889035cd71309707$exports = {};
$889035cd71309707$exports = new URL("Starter_Chopping.be785d1b.png", import.meta.url).toString();


var $95acfbaeb3705ac2$exports = {};
$95acfbaeb3705ac2$exports = new URL("Starter_Chopping_2.be785d1b.png", import.meta.url).toString();


var $6966e8f3ea3c9fa2$exports = {};
$6966e8f3ea3c9fa2$exports = new URL("Starter_Fishing.e4f92f12.png", import.meta.url).toString();


var $85b0e0b271008d46$exports = {};
$85b0e0b271008d46$exports = new URL("Starter_Fishing_2.e4f92f12.png", import.meta.url).toString();


var $4faf2143947d92a7$exports = {};
$4faf2143947d92a7$exports = new URL("Starter_Mining.47051aa3.png", import.meta.url).toString();


var $3db03bdf74cf20a1$exports = {};
$3db03bdf74cf20a1$exports = new URL("Starter_Mining_2.47051aa3.png", import.meta.url).toString();


var $8a3a1fe49f1163a0$exports = {};
$8a3a1fe49f1163a0$exports = new URL("Starter_Tending.06659714.png", import.meta.url).toString();


var $38d5e4708845fd99$exports = {};
$38d5e4708845fd99$exports = new URL("Starter_Tending_2.06659714.png", import.meta.url).toString();


var $fd7b54adffd46dd0$exports = {};
$fd7b54adffd46dd0$exports = new URL("Starter_ZenithOrders.d77a8f0a.png", import.meta.url).toString();


var $afe807029394ca45$exports = {};
$afe807029394ca45$exports = new URL("Task_v2_S1_CaveFisher.8e232256.png", import.meta.url).toString();


var $3b729a9ff7535403$exports = {};
$3b729a9ff7535403$exports = new URL("Task_v2_S1_FarmClearer.8d695739.png", import.meta.url).toString();


var $e02fa63e7cc232b4$exports = {};
$e02fa63e7cc232b4$exports = new URL("Task_v2_S1_FarmMiner.9f50cef1.png", import.meta.url).toString();


var $84b8e1127c620c8b$exports = {};
$84b8e1127c620c8b$exports = new URL("Task_v2_S1_NoviceFisher.1f14977b.png", import.meta.url).toString();


var $acee0ead0fdcc85d$exports = {};
$acee0ead0fdcc85d$exports = new URL("Task_v2_S1_NoviceForager.dcf86417.png", import.meta.url).toString();


var $9a7cab4fd0ef36a1$exports = {};
$9a7cab4fd0ef36a1$exports = new URL("Task_v2_S1_NoviceMiner.ea1aa4dd.png", import.meta.url).toString();


var $a58454118b9af977$exports = {};
$a58454118b9af977$exports = new URL("Task_v2_S1_RiverDredger.dd2bdc1e.png", import.meta.url).toString();


var $9cb0f2e875db058c$exports = {};
$9cb0f2e875db058c$exports = new URL("Task_v2_S1_RiverFisher.aa34ab02.png", import.meta.url).toString();


var $de3e701b3a99661b$exports = {};
$de3e701b3a99661b$exports = new URL("Hive_SeasonCards_2026-07-23_S1_CaveFisher.ed48b9dc.png", import.meta.url).toString();


var $c24b14ca7df011ad$exports = {};
$c24b14ca7df011ad$exports = new URL("Hive_SeasonCards_2026-07-23_S1_FarmClearer.ee0b54cf.png", import.meta.url).toString();


var $639ec6dde09c66db$exports = {};
$639ec6dde09c66db$exports = new URL("Hive_SeasonCards_2026-07-23_S1_FarmMiner.bffd61cd.png", import.meta.url).toString();


var $d14423869d6fec08$exports = {};
$d14423869d6fec08$exports = new URL("Hive_SeasonCards_2026-07-23_S1_NoviceFisher.69947c54.png", import.meta.url).toString();


var $da66a11769643464$exports = {};
$da66a11769643464$exports = new URL("Hive_SeasonCards_2026-07-23_S1_NoviceForager.1be9a060.png", import.meta.url).toString();


var $f3e75343fc9bfbce$exports = {};
$f3e75343fc9bfbce$exports = new URL("Hive_SeasonCards_2026-07-23_S1_NoviceMiner.40b103da.png", import.meta.url).toString();


var $4a102d9b267af3ab$exports = {};
$4a102d9b267af3ab$exports = new URL("Hive_SeasonCards_2026-07-23_S1_RiverDredger.92373a4c.png", import.meta.url).toString();


var $5e8e29676fe3699f$exports = {};
$5e8e29676fe3699f$exports = new URL("Hive_SeasonCards_2026-07-23_S1_RiverFisher.d55eeb31.png", import.meta.url).toString();


var $efe4223ca555342e$exports = {};
$efe4223ca555342e$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_CaveFisher.42d33db2.png", import.meta.url).toString();


var $d4d3d4b90d86f0a2$exports = {};
$d4d3d4b90d86f0a2$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_FarmClearer.aeb26332.png", import.meta.url).toString();


var $ab41c69fcd1d72ce$exports = {};
$ab41c69fcd1d72ce$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_FarmMiner.3d107539.png", import.meta.url).toString();


var $bde55aaf8ee2d41c$exports = {};
$bde55aaf8ee2d41c$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_NoviceFisher.0c3c390b.png", import.meta.url).toString();


var $b79350e913a9e737$exports = {};
$b79350e913a9e737$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_NoviceForager.bc4c835b.png", import.meta.url).toString();


var $0f7f3bb693c7c91a$exports = {};
$0f7f3bb693c7c91a$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_NoviceMiner.0727cd91.png", import.meta.url).toString();


var $233816ca024bf0de$exports = {};
$233816ca024bf0de$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_RiverDredger.d8cdd87b.png", import.meta.url).toString();


var $392b5fc84cca3bac$exports = {};
$392b5fc84cca3bac$exports = new URL("Cellar_SeasonCards_2026-07-23_S1_RiverFisher.011c969c.png", import.meta.url).toString();


var $163b375a2d1ef697$exports = {};
$163b375a2d1ef697$exports = new URL("Task_v2_S1_AxeMiner.02956156.png", import.meta.url).toString();


var $d50a2d41d73c7c17$exports = {};
$d50a2d41d73c7c17$exports = new URL("Task_v2_S1_EnergyEnthusiast.df998c67.png", import.meta.url).toString();


var $88bea0272150b056$exports = {};
$88bea0272150b056$exports = new URL("Task_v2_S1_FarmFisher.5198d3a1.png", import.meta.url).toString();


var $744819674213ed22$exports = {};
$744819674213ed22$exports = new URL("Task_v2_S1_Gatherer.672b5aef.png", import.meta.url).toString();


var $0c0d52d8d377c948$exports = {};
$0c0d52d8d377c948$exports = new URL("Task_v2_S1_Grower.24c80ae1.png", import.meta.url).toString();


var $38c29dc01576b73d$exports = {};
$38c29dc01576b73d$exports = new URL("Task_v2_S1_NatureCollector.6699520d.png", import.meta.url).toString();


var $870fe932c109aec6$exports = {};
$870fe932c109aec6$exports = new URL("Task_v2_S1_NoviceCollector.b59782b6.png", import.meta.url).toString();


var $5d59d742521a029f$exports = {};
$5d59d742521a029f$exports = new URL("Task_v2_S1_ShinyCollector.73c7ff9e.png", import.meta.url).toString();


var $1308cc6442367142$exports = {};
$1308cc6442367142$exports = new URL("Task_v2_S1_SkilledApprentice.8b486ed7.png", import.meta.url).toString();


var $afb56b69307797b6$exports = {};
$afb56b69307797b6$exports = new URL("Task_v2_S1_SkilledFisher.9cf83126.png", import.meta.url).toString();


var $4d3b3d3593752106$exports = {};
$4d3b3d3593752106$exports = new URL("Task_v2_S1_SocialButterfly.9dceafc6.png", import.meta.url).toString();


var $ba51ab8e425f0710$exports = {};
$ba51ab8e425f0710$exports = new URL("Task_v2_S1_WoodScrapper.835a6b17.png", import.meta.url).toString();


var $9b14d9235d5a027b$exports = {};
$9b14d9235d5a027b$exports = new URL("Task_v2_S2_AmateurFarmer.ba40f2aa.png", import.meta.url).toString();


var $0cca60d74f953819$exports = {};
$0cca60d74f953819$exports = new URL("Task_v2_S2_CovernGrower.bea90b38.png", import.meta.url).toString();


var $b8e9068c310e2458$exports = {};
$b8e9068c310e2458$exports = new URL("Task_v2_S2_Excavator.8e8954d2.png", import.meta.url).toString();


var $65efba0e1d3b4896$exports = {};
$65efba0e1d3b4896$exports = new URL("Task_v2_S2_ExpertFisher.ad259f65.png", import.meta.url).toString();


var $1647d39d7810d8fe$exports = {};
$1647d39d7810d8fe$exports = new URL("Task_v2_S2_FarmForester.b7cac07c.png", import.meta.url).toString();


var $4a329a802fd51519$exports = {};
$4a329a802fd51519$exports = new URL("Task_v2_S2_LumberjackFisher.99f66fad.png", import.meta.url).toString();


var $d877cf8ca549e9f9$exports = {};
$d877cf8ca549e9f9$exports = new URL("Task_v2_S2_SecretMineFisher.09b34e42.png", import.meta.url).toString();


var $006d57fdb710fcf0$exports = {};
$006d57fdb710fcf0$exports = new URL("Task_v2_S2_WoodsClearer.6c86422b.png", import.meta.url).toString();


var $7c2e6f2378d9cf3a$exports = {};
$7c2e6f2378d9cf3a$exports = new URL("Hive_SeasonCards_2026-07-23_S2_AmateurFarmer.53e5c3e9.png", import.meta.url).toString();


var $fa7543812ead47f2$exports = {};
$fa7543812ead47f2$exports = new URL("Hive_SeasonCards_2026-07-23_S2_CovernGrower.537706eb.png", import.meta.url).toString();


var $5d0e71ada9150c36$exports = {};
$5d0e71ada9150c36$exports = new URL("Hive_SeasonCards_2026-07-23_S2_Excavator.f9a3a6eb.png", import.meta.url).toString();


var $aaf5e7fe89bc0d35$exports = {};
$aaf5e7fe89bc0d35$exports = new URL("Hive_SeasonCards_2026-07-23_S2_ExpertFisher.01aa240c.png", import.meta.url).toString();


var $3371a3ee84b7cc97$exports = {};
$3371a3ee84b7cc97$exports = new URL("Hive_SeasonCards_2026-07-23_S2_FarmForester.75b15ac1.png", import.meta.url).toString();


var $0215f3759aa30557$exports = {};
$0215f3759aa30557$exports = new URL("Hive_SeasonCards_2026-07-23_S2_LumberjackFisher.fcb596bf.png", import.meta.url).toString();


var $c33406072e5f873b$exports = {};
$c33406072e5f873b$exports = new URL("Hive_SeasonCards_2026-07-23_S2_SecretMineFisher.cb39ffe9.png", import.meta.url).toString();


var $9dcdf6df433eb2ee$exports = {};
$9dcdf6df433eb2ee$exports = new URL("Hive_SeasonCards_2026-07-23_S2_WoodsClearer.3c58efe9.png", import.meta.url).toString();


var $f1d9584a3f8c266e$exports = {};
$f1d9584a3f8c266e$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_AmateurFarmer.a2b458a5.png", import.meta.url).toString();


var $c5b5487efc95ba1f$exports = {};
$c5b5487efc95ba1f$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_CovernGrower.ef97df5a.png", import.meta.url).toString();


var $7a3bad6fced4b6df$exports = {};
$7a3bad6fced4b6df$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_Excavator.f72bdfa8.png", import.meta.url).toString();


var $2fdc633ba7bf3fec$exports = {};
$2fdc633ba7bf3fec$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_ExpertFisher.307d18c5.png", import.meta.url).toString();


var $9fe0fcf6e5ad38fc$exports = {};
$9fe0fcf6e5ad38fc$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_FarmForester.89f5b4e6.png", import.meta.url).toString();


var $1e1a5ebd2d6eeac8$exports = {};
$1e1a5ebd2d6eeac8$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_LumberjackFisher.4f11ab15.png", import.meta.url).toString();


var $6974629347f924b5$exports = {};
$6974629347f924b5$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_SecretMineFisher.3d3d6235.png", import.meta.url).toString();


var $4b1494af88d889dc$exports = {};
$4b1494af88d889dc$exports = new URL("Cellar_SeasonCards_2026-07-23_S2_WoodsClearer.eee84db7.png", import.meta.url).toString();


var $d328a81f1b20c42a$exports = {};
$d328a81f1b20c42a$exports = new URL("Task_v2_S2_Collector.93f4e3dc.png", import.meta.url).toString();


var $d224e4efb0636894$exports = {};
$d224e4efb0636894$exports = new URL("Task_v2_S2_Evergizer.44905f3b.png", import.meta.url).toString();


var $eb332019f0da5b2a$exports = {};
$eb332019f0da5b2a$exports = new URL("Task_v2_S2_Extrovert.0dcf1ae8.png", import.meta.url).toString();


var $1668af9aee062d78$exports = {};
$1668af9aee062d78$exports = new URL("Task_v2_S2_FarmExcavator.d58d1a4f.png", import.meta.url).toString();


var $87eabb4bf2c2bd4f$exports = {};
$87eabb4bf2c2bd4f$exports = new URL("Task_v2_S2_Furnisher.cb5bcdae.png", import.meta.url).toString();


var $c6bad5db942f1bae$exports = {};
$c6bad5db942f1bae$exports = new URL("Task_v2_S2_GeneralistMedalEarner.0a5d82f9.png", import.meta.url).toString();


var $2158b004ae53806d$exports = {};
$2158b004ae53806d$exports = new URL("Task_v2_S2_JackOfAllTrades.28f79b83.png", import.meta.url).toString();


var $ce7cb6979b2eba30$exports = {};
$ce7cb6979b2eba30$exports = new URL("Task_v2_S2_LureMaster.bd247813.png", import.meta.url).toString();


var $2d7ef9b519785c07$exports = {};
$2d7ef9b519785c07$exports = new URL("Task_v2_S2_MedalEarner.19d8f076.png", import.meta.url).toString();


var $20b7125da91652d5$exports = {};
$20b7125da91652d5$exports = new URL("Task_v2_S2_Pragmatist.40ca2d38.png", import.meta.url).toString();


var $457860f7ec28656b$exports = {};
$457860f7ec28656b$exports = new URL("Task_v2_S2_ProjectDabbler.0403af4c.png", import.meta.url).toString();


var $87b1e8754e3bdb4c$exports = {};
$87b1e8754e3bdb4c$exports = new URL("Task_v2_S2_Retooler.fa8f290e.png", import.meta.url).toString();


var $b39da5ddc060223a$exports = {};
$b39da5ddc060223a$exports = new URL("Task_v2_S3_Delver.798f1ae8.png", import.meta.url).toString();


var $fa913afd4e9064bc$exports = {};
$fa913afd4e9064bc$exports = new URL("Task_v2_S3_FreshFarmer.8f0bd85a.png", import.meta.url).toString();


var $a9881f7a92fa4147$exports = {};
$a9881f7a92fa4147$exports = new URL("Task_v2_S3_Geologist.b12e0486.png", import.meta.url).toString();


var $f04e5d873c98e566$exports = {};
$f04e5d873c98e566$exports = new URL("Task_v2_S3_GrottoFisher.8e83a369.png", import.meta.url).toString();


var $7b7b94fcba51b1f2$exports = {};
$7b7b94fcba51b1f2$exports = new URL("Task_v2_S3_Kingfisher.1bd9b27c.png", import.meta.url).toString();


var $3409d0f6906b22fb$exports = {};
$3409d0f6906b22fb$exports = new URL("Task_v2_S3_LakeFisher.65aa1380.png", import.meta.url).toString();


var $95cc56212a8bd6f7$exports = {};
$95cc56212a8bd6f7$exports = new URL("Task_v2_S3_MasterFarmer.681eeae1.png", import.meta.url).toString();


var $9072d8f37d24fd41$exports = {};
$9072d8f37d24fd41$exports = new URL("Task_v2_S3_Woodsman.c30b4897.png", import.meta.url).toString();


var $4c79420fb275fba3$exports = {};
$4c79420fb275fba3$exports = new URL("Hive_SeasonCards_2026-07-23_S3_Delver.73818a01.png", import.meta.url).toString();


var $a419e6b6a580f701$exports = {};
$a419e6b6a580f701$exports = new URL("Hive_SeasonCards_2026-07-23_S3_FreshFarmer.4dcc86c8.png", import.meta.url).toString();


var $9fe3d0b3f4258519$exports = {};
$9fe3d0b3f4258519$exports = new URL("Hive_SeasonCards_2026-07-23_S3_Geologist.f7005873.png", import.meta.url).toString();


var $6bb71280ca2e45e1$exports = {};
$6bb71280ca2e45e1$exports = new URL("Hive_SeasonCards_2026-07-23_S3_GrottoFisher.4069ac6a.png", import.meta.url).toString();


var $6b6b604332424114$exports = {};
$6b6b604332424114$exports = new URL("Hive_SeasonCards_2026-07-23_S3_Kingfisher.9dc590a0.png", import.meta.url).toString();


var $6138f4c90b76303b$exports = {};
$6138f4c90b76303b$exports = new URL("Hive_SeasonCards_2026-07-23_S3_LakeFisher.dea02d68.png", import.meta.url).toString();


var $cba60ea961591a8a$exports = {};
$cba60ea961591a8a$exports = new URL("Hive_SeasonCards_2026-07-23_S3_MasterFarmer.e35cdcd5.png", import.meta.url).toString();


var $6cf5a1769f37ab23$exports = {};
$6cf5a1769f37ab23$exports = new URL("Hive_SeasonCards_2026-07-23_S3_Woodsman.12e5db06.png", import.meta.url).toString();


var $3c893e29c5cff50c$exports = {};
$3c893e29c5cff50c$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_Delver.3152fefe.png", import.meta.url).toString();


var $3f8a7706446c37e3$exports = {};
$3f8a7706446c37e3$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_FreshFarmer.3e0beb41.png", import.meta.url).toString();


var $0fa9fe9d8c018c8b$exports = {};
$0fa9fe9d8c018c8b$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_Geologist.86ca4668.png", import.meta.url).toString();


var $6e678615d3d56a3a$exports = {};
$6e678615d3d56a3a$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_GrottoFisher.43e97140.png", import.meta.url).toString();


var $26ead80488a5785c$exports = {};
$26ead80488a5785c$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_Kingfisher.4e533be3.png", import.meta.url).toString();


var $7c2035276a83004d$exports = {};
$7c2035276a83004d$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_LakeFisher.3106ea01.png", import.meta.url).toString();


var $1388fba4b963a556$exports = {};
$1388fba4b963a556$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_MasterFarmer.dd16d848.png", import.meta.url).toString();


var $e26b02baaa2d704d$exports = {};
$e26b02baaa2d704d$exports = new URL("Cellar_SeasonCards_2026-07-23_S3_Woodsman.3f7c89ee.png", import.meta.url).toString();


var $889fc5b75bdd982a$exports = {};
$889fc5b75bdd982a$exports = new URL("Task_v2_S3_AntiAntiSocial.a0fb9975.png", import.meta.url).toString();


var $de85eb4497e72623$exports = {};
$de85eb4497e72623$exports = new URL("Task_v2_S3_CompleteBuilder.1663948f.png", import.meta.url).toString();


var $56568e128b7e2eaf$exports = {};
$56568e128b7e2eaf$exports = new URL("Task_v2_S3_Completist.ee79f7b8.png", import.meta.url).toString();


var $2f8aeb4a1c3788a8$exports = {};
$2f8aeb4a1c3788a8$exports = new URL("Task_v2_S3_EnergyMonster.8ff051e1.png", import.meta.url).toString();


var $b59319f93ac717ee$exports = {};
$b59319f93ac717ee$exports = new URL("Task_v2_S3_FishHunter.454eb0a0.png", import.meta.url).toString();


var $c1e6612f49cc3ead$exports = {};
$c1e6612f49cc3ead$exports = new URL("Task_v2_S3_MarketCultivator.58b42c69.png", import.meta.url).toString();


var $5dac55a4808109d7$exports = {};
$5dac55a4808109d7$exports = new URL("Task_v2_S3_MarketDelver.1d0eec64.png", import.meta.url).toString();


var $7daaeb2f193a3d36$exports = {};
$7daaeb2f193a3d36$exports = new URL("Task_v2_S3_MarketMaster.813ed0c2.png", import.meta.url).toString();


var $d28d86551b7b87e2$exports = {};
$d28d86551b7b87e2$exports = new URL("Task_v2_S3_MarketWizard.47212d00.png", import.meta.url).toString();


var $538c7189c9ef6de7$exports = {};
$538c7189c9ef6de7$exports = new URL("Task_v2_S3_MasterBuilder.1240d89c.png", import.meta.url).toString();


var $9d71f58c656c0d38$exports = {};
$9d71f58c656c0d38$exports = new URL("Task_v2_S3_ResearchBadgeMaster.24b4170e.png", import.meta.url).toString();


var $78b2a54c74ef5f19$exports = {};
$78b2a54c74ef5f19$exports = new URL("Task_v2_S3_WoodsExplorer.fe26c5b1.png", import.meta.url).toString();


var $2784c2418957d661$exports = {};
$2784c2418957d661$exports = new URL("NewModulesIncoming_S1_NewEquipment.31dee524.png", import.meta.url).toString();


var $51703ab6b1b40da0$exports = {};
$51703ab6b1b40da0$exports = new URL("NewModulesIncoming_S2_Adaptation.73caf815.png", import.meta.url).toString();


var $6e81a045fca4d982$exports = {};
$6e81a045fca4d982$exports = new URL("NewModulesIncoming_S3_Investments.02ec6ee8.png", import.meta.url).toString();


var $574175f96916230d$exports = {};
$574175f96916230d$exports = new URL("Objective_S1_BadgeBonus.1df46185.png", import.meta.url).toString();


var $3bb224c36091648b$exports = {};
$3bb224c36091648b$exports = new URL("Objective_S1_BigGuy.52fe6311.png", import.meta.url).toString();


var $dfa11987f48d9785$exports = {};
$dfa11987f48d9785$exports = new URL("Objective_S1_CentralSampler.c2564818.png", import.meta.url).toString();


var $390eadd88aa58232$exports = {};
$390eadd88aa58232$exports = new URL("Objective_S1_Clearer.4e581942.png", import.meta.url).toString();


var $52bd609ecd26f10b$exports = {};
$52bd609ecd26f10b$exports = new URL("Objective_S1_Edges.3fd53cc9.png", import.meta.url).toString();


var $4b624a7f58880bf7$exports = {};
$4b624a7f58880bf7$exports = new URL("Objective_S1_LeftSampler.2aa9e9ea.png", import.meta.url).toString();


var $68bfc519d931268d$exports = {};
$68bfc519d931268d$exports = new URL("Objective_S1_Loner.4213ac90.png", import.meta.url).toString();


var $a35b23f8aa072d8b$exports = {};
$a35b23f8aa072d8b$exports = new URL("Objective_S1_Muncher.1934eba1.png", import.meta.url).toString();


var $ace9dd4376c10d9d$exports = {};
$ace9dd4376c10d9d$exports = new URL("Objective_S1_ProjectBonus.2ca3dad6.png", import.meta.url).toString();


var $06feb3533e3b2eae$exports = {};
$06feb3533e3b2eae$exports = new URL("Objective_S1_RightSampler.572c1701.png", import.meta.url).toString();


var $7d416e2d31bfa58f$exports = {};
$7d416e2d31bfa58f$exports = new URL("Objective_S1_Shrimp.fc3b8242.png", import.meta.url).toString();


var $b8ec24773f4c301d$exports = {};
$b8ec24773f4c301d$exports = new URL("Objective_S1_Socialite.05942c32.png", import.meta.url).toString();


var $715739464bc5fb88$exports = {};
$715739464bc5fb88$exports = new URL("Objective_S2_AnimalHandler.352a28dc.png", import.meta.url).toString();


var $f5a8959f294dc464$exports = {};
$f5a8959f294dc464$exports = new URL("Objective_S2_Biggen.e4fed179.png", import.meta.url).toString();


var $3d13e9cc32273554$exports = {};
$3d13e9cc32273554$exports = new URL("Objective_S2_Borders.fbf28c44.png", import.meta.url).toString();


var $741a441b706c0db6$exports = {};
$741a441b706c0db6$exports = new URL("Objective_S2_CenterSampler.98caf5ed.png", import.meta.url).toString();


var $3568bbf08cc9d5d5$exports = {};
$3568bbf08cc9d5d5$exports = new URL("Objective_S2_Cruncher.b6ea514c.png", import.meta.url).toString();


var $9203c0678ec689fd$exports = {};
$9203c0678ec689fd$exports = new URL("Objective_S2_EastSampler.8cefb356.png", import.meta.url).toString();


var $7b6512656558b8f7$exports = {};
$7b6512656558b8f7$exports = new URL("Objective_S2_Explorer.66f29e41.png", import.meta.url).toString();


var $d397e9f06a996500$exports = {};
$d397e9f06a996500$exports = new URL("Objective_S2_MeritEarner.ce038f2f.png", import.meta.url).toString();


var $7fa2dc87e917c62b$exports = {};
$7fa2dc87e917c62b$exports = new URL("Objective_S2_Moderate.d7675dfe.png", import.meta.url).toString();


var $7f2e2d7aa805ea2b$exports = {};
$7f2e2d7aa805ea2b$exports = new URL("Objective_S2_Organizer.ab7d2ab4.png", import.meta.url).toString();


var $4abee58c28254f30$exports = {};
$4abee58c28254f30$exports = new URL("Objective_S2_Shrimp.9a67af3b.png", import.meta.url).toString();


var $ab7204e665b9763d$exports = {};
$ab7204e665b9763d$exports = new URL("Objective_S2_Spacer.ac92b49c.png", import.meta.url).toString();


var $1a09616bfcc76bba$exports = {};
$1a09616bfcc76bba$exports = new URL("Objective_S2_Upgrader.0ea7e219.png", import.meta.url).toString();


var $d561f219d748e296$exports = {};
$d561f219d748e296$exports = new URL("Objective_S2_WestSampler.e1deea4b.png", import.meta.url).toString();


var $6213881caecb5309$exports = {};
$6213881caecb5309$exports = new URL("Objective_S3_Assembler.a2a5ddfe.png", import.meta.url).toString();


var $cc73848f80221b7a$exports = {};
$cc73848f80221b7a$exports = new URL("Objective_S3_CargoMaster.3978d23e.png", import.meta.url).toString();


var $a614dcfbe877a677$exports = {};
$a614dcfbe877a677$exports = new URL("Objective_S3_Centrist.9de3270b.png", import.meta.url).toString();


var $d3dea7ddbb6e21e4$exports = {};
$d3dea7ddbb6e21e4$exports = new URL("Objective_S3_Lefty.02835f15.png", import.meta.url).toString();


var $095a25b8e5c60f27$exports = {};
$095a25b8e5c60f27$exports = new URL("Objective_S3_Minimalist.8d46d7d2.png", import.meta.url).toString();


var $ea90dc0f5ada9175$exports = {};
$ea90dc0f5ada9175$exports = new URL("Objective_S3_Righty.579a551e.png", import.meta.url).toString();


var $b9a8b73ebd467b33$exports = {};
$b9a8b73ebd467b33$exports = new URL("Objective_S3_TrueFriend.f44a16e4.png", import.meta.url).toString();


var $07ee7ea0e08dfa6f$exports = {};
$07ee7ea0e08dfa6f$exports = new URL("Objective_S3_WideSpacer.ca182a4a.png", import.meta.url).toString();


var $ce4f19cfc365bc26$exports = {};
$ce4f19cfc365bc26$exports = new URL("Season1Action_AxeMiner.ceb18067.png", import.meta.url).toString();


var $2d300d727b04e0df$exports = {};
$2d300d727b04e0df$exports = new URL("Season1Action_CaveFisher.2adcb043.png", import.meta.url).toString();


var $20cc5e39320866ea$exports = {};
$20cc5e39320866ea$exports = new URL("Season1Action_EnergyEnthusiast.bd7f771c.png", import.meta.url).toString();


var $0f7c74ae2e630421$exports = {};
$0f7c74ae2e630421$exports = new URL("Season1Action_FarmClearer.2a92813f.png", import.meta.url).toString();


var $0739b81096f9a49b$exports = {};
$0739b81096f9a49b$exports = new URL("Season1Action_FarmFisher.8c0566e9.png", import.meta.url).toString();


var $dda97a50573ea32d$exports = {};
$dda97a50573ea32d$exports = new URL("Season1Action_FarmMiner.f2f6cc1f.png", import.meta.url).toString();


var $659f7029abe7e8e7$exports = {};
$659f7029abe7e8e7$exports = new URL("Season1Action_Gatherer.4dfbafad.png", import.meta.url).toString();


var $e2d311d52db026c0$exports = {};
$e2d311d52db026c0$exports = new URL("Season1Action_Grower.bbaa88b5.png", import.meta.url).toString();


var $000039ed45721d56$exports = {};
$000039ed45721d56$exports = new URL("Season1Action_NatureCollector.716f8953.png", import.meta.url).toString();


var $3e0e6d960ecce924$exports = {};
$3e0e6d960ecce924$exports = new URL("Season1Action_NoviceCollector.878d6c26.png", import.meta.url).toString();


var $3280b171cfd21a73$exports = {};
$3280b171cfd21a73$exports = new URL("Season1Action_NoviceFisher.eecb330d.png", import.meta.url).toString();


var $1c0c8cc3912ce50f$exports = {};
$1c0c8cc3912ce50f$exports = new URL("Season1Action_NoviceForager.faa93b04.png", import.meta.url).toString();


var $4ef4a0be306913db$exports = {};
$4ef4a0be306913db$exports = new URL("Season1Action_NoviceMiner.9ff4a78d.png", import.meta.url).toString();


var $2d99994fd50744e5$exports = {};
$2d99994fd50744e5$exports = new URL("Season1Action_RiverDredger.f44b38f6.png", import.meta.url).toString();


var $7284beeaf980061d$exports = {};
$7284beeaf980061d$exports = new URL("Season1Action_RiverFisher.1acf604f.png", import.meta.url).toString();


var $caf34d9468b190d0$exports = {};
$caf34d9468b190d0$exports = new URL("Season1Action_ShinyCollector.a3594ac3.png", import.meta.url).toString();


var $cf97b3fc9f383a7a$exports = {};
$cf97b3fc9f383a7a$exports = new URL("Season1Action_SkilledApprentice.f947815e.png", import.meta.url).toString();


var $9a5ccb8cd762b8ab$exports = {};
$9a5ccb8cd762b8ab$exports = new URL("Season1Action_SkilledFisher.0f63cf52.png", import.meta.url).toString();


var $0e92adbb6cdeb2d0$exports = {};
$0e92adbb6cdeb2d0$exports = new URL("Season1Action_SocialButterfly.b7241756.png", import.meta.url).toString();


var $18efc7b98dd8739c$exports = {};
$18efc7b98dd8739c$exports = new URL("Season1Action_WoodScrapper.98eeb050.png", import.meta.url).toString();


var $c7176918f7353591$exports = {};
$c7176918f7353591$exports = new URL("Season2Action_AmateurFarmer.085588d2.png", import.meta.url).toString();


var $0455648024de7ed8$exports = {};
$0455648024de7ed8$exports = new URL("Season2Action_Collector.be2771b4.png", import.meta.url).toString();


var $46c58ee47bfe8556$exports = {};
$46c58ee47bfe8556$exports = new URL("Season2Action_CovernGrower.79eae287.png", import.meta.url).toString();


var $ca30acca15d4240b$exports = {};
$ca30acca15d4240b$exports = new URL("Season2Action_Evergizer.68f1fb16.png", import.meta.url).toString();


var $cb8b3538e4b9b60f$exports = {};
$cb8b3538e4b9b60f$exports = new URL("Season2Action_Excavator.f5a14344.png", import.meta.url).toString();


var $588cedbc2a50827e$exports = {};
$588cedbc2a50827e$exports = new URL("Season2Action_ExpertFisher.d49f8008.png", import.meta.url).toString();


var $72c52951da9f46d8$exports = {};
$72c52951da9f46d8$exports = new URL("Season2Action_Extrovert.2ec8ac24.png", import.meta.url).toString();


var $50499eb2da360347$exports = {};
$50499eb2da360347$exports = new URL("Season2Action_FarmExcavator.3253b47c.png", import.meta.url).toString();


var $177a3b36dff534ba$exports = {};
$177a3b36dff534ba$exports = new URL("Season2Action_FarmForester.821fd4fb.png", import.meta.url).toString();


var $2f6e675f69614a31$exports = {};
$2f6e675f69614a31$exports = new URL("Season2Action_Furnisher.06b78c62.png", import.meta.url).toString();


var $4aee7be3a1a0f362$exports = {};
$4aee7be3a1a0f362$exports = new URL("Season2Action_GeneralistMedalEarner.05e8219f.png", import.meta.url).toString();


var $83c518d87ccf7278$exports = {};
$83c518d87ccf7278$exports = new URL("Season2Action_JackOfAllTrades.bddef728.png", import.meta.url).toString();


var $69f6dd73a30b6458$exports = {};
$69f6dd73a30b6458$exports = new URL("Season2Action_LumberjackFisher.b4467933.png", import.meta.url).toString();


var $43144d980c9e800d$exports = {};
$43144d980c9e800d$exports = new URL("Season2Action_LureMaster.b3945eeb.png", import.meta.url).toString();


var $6171ca07c9324879$exports = {};
$6171ca07c9324879$exports = new URL("Season2Action_MedalEarner.d3fad801.png", import.meta.url).toString();


var $c58f91d07c76bf1e$exports = {};
$c58f91d07c76bf1e$exports = new URL("Season2Action_Pragmatist.df71d001.png", import.meta.url).toString();


var $a922250f89cc5177$exports = {};
$a922250f89cc5177$exports = new URL("Season2Action_ProjectDabbler.4cee2261.png", import.meta.url).toString();


var $a1f38991bdf8bda9$exports = {};
$a1f38991bdf8bda9$exports = new URL("Season2Action_Retooler.64e15542.png", import.meta.url).toString();


var $4f3804ab1d071c97$exports = {};
$4f3804ab1d071c97$exports = new URL("Season2Action_SecretMineFisher.bc79c3a8.png", import.meta.url).toString();


var $29a6c429f0aa4367$exports = {};
$29a6c429f0aa4367$exports = new URL("Season2Action_WoodCleaner.211cd2df.png", import.meta.url).toString();


var $f6323a3e914bba4f$exports = {};
$f6323a3e914bba4f$exports = new URL("Season3Action_AntiAntiSocial.9c1efe2e.png", import.meta.url).toString();


var $620da12c14ce88d6$exports = {};
$620da12c14ce88d6$exports = new URL("Season3Action_CompleteBuilder.b8cbe585.png", import.meta.url).toString();


var $d8a46d98fc542a84$exports = {};
$d8a46d98fc542a84$exports = new URL("Season3Action_Completist.6999aae7.png", import.meta.url).toString();


var $7ea75995fdc55e87$exports = {};
$7ea75995fdc55e87$exports = new URL("Season3Action_Delver.ab19b3e4.png", import.meta.url).toString();


var $337db551a5c0f5a1$exports = {};
$337db551a5c0f5a1$exports = new URL("Season3Action_EnergyMonster.919b32fb.png", import.meta.url).toString();


var $697a9d481e98d84e$exports = {};
$697a9d481e98d84e$exports = new URL("Season3Action_FishHunter.3c269343.png", import.meta.url).toString();


var $f7491c03a6de7cda$exports = {};
$f7491c03a6de7cda$exports = new URL("Season3Action_FreshFarmer.70f87c42.png", import.meta.url).toString();


var $2eec0936c301a3c8$exports = {};
$2eec0936c301a3c8$exports = new URL("Season3Action_Geologist.327a3822.png", import.meta.url).toString();


var $585fc0a95b711db0$exports = {};
$585fc0a95b711db0$exports = new URL("Season3Action_GrottoFisher.ef7c30bd.png", import.meta.url).toString();


var $d719189068c5bde7$exports = {};
$d719189068c5bde7$exports = new URL("Season3Action_Kingfisher.e5e2c451.png", import.meta.url).toString();


var $2244dc5946bd8e3a$exports = {};
$2244dc5946bd8e3a$exports = new URL("Season3Action_LakeFisher.aaedd760.png", import.meta.url).toString();


var $a8f47b26e39c92d4$exports = {};
$a8f47b26e39c92d4$exports = new URL("Season3Action_MarketCultivator.a4520b26.png", import.meta.url).toString();


var $78325d34fe8dbb12$exports = {};
$78325d34fe8dbb12$exports = new URL("Season3Action_MarketDelver.d3108ed5.png", import.meta.url).toString();


var $4806cf83fa70a07f$exports = {};
$4806cf83fa70a07f$exports = new URL("Season3Action_MarketMaster.e61ec48b.png", import.meta.url).toString();


var $6f14dc7103005a4c$exports = {};
$6f14dc7103005a4c$exports = new URL("Season3Action_MarketWizard.412efb40.png", import.meta.url).toString();


var $95916a0bcdae77c3$exports = {};
$95916a0bcdae77c3$exports = new URL("Season3Action_MasterBuilder.3c4fb579.png", import.meta.url).toString();


var $fabd832b74525a59$exports = {};
$fabd832b74525a59$exports = new URL("Season3Action_MasterFarmer.54a59ef7.png", import.meta.url).toString();


var $02e4f5258f105494$exports = {};
$02e4f5258f105494$exports = new URL("Season3Action_ResearchBadgeMaster.9f85d54c.png", import.meta.url).toString();


var $cc4ad30a239b63a7$exports = {};
$cc4ad30a239b63a7$exports = new URL("Season3Action_WoodsExplorer.1214cecf.png", import.meta.url).toString();


var $f0555cd9a1f4542e$exports = {};
$f0555cd9a1f4542e$exports = new URL("Season3Action_Woodsman.023c4fa8.png", import.meta.url).toString();


const $0af4a17cf314e673$export$7901e90382cede3a = [
    (0, (/*@__PURE__*/$parcel$interopDefault($d9c0525122484bdf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4fa89501a44a0f9f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b00cb674107b1d1d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($068a78867a901629$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($976330d12e2a3dea$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($22b7d2f010ed5c16$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($636c594034620b10$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f7a63ddd7a82be$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b21e78937c3f44fd$exports)))
];
const $0af4a17cf314e673$export$899e39b9deff759 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($76bfbebb5650700d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f917eba161e585c1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6395356e67498a22$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fd63decc3af03ee6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9be49999e38d978e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fe98761d4159ba15$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($92c6c6657785d7ac$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c0ed07d672003b66$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c7c58162a02e7239$exports)))
];
const $0af4a17cf314e673$export$2e3c9d013d135fab = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ac30237cd1792c99$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ceb38c0e9f554181$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($abc6d0ea84008005$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4284327e8498de19$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($541ace5e44f5a041$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($944d5dfebb8e768b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c7cfa03b872b0c3c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($21c82075533a9dd3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0d4df08da377cab7$exports)))
];
const $0af4a17cf314e673$export$438ecb7653cb7d5c = [
    (0, (/*@__PURE__*/$parcel$interopDefault($889035cd71309707$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($95acfbaeb3705ac2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6966e8f3ea3c9fa2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($85b0e0b271008d46$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4faf2143947d92a7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3db03bdf74cf20a1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($8a3a1fe49f1163a0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($38d5e4708845fd99$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fd7b54adffd46dd0$exports)))
];
const $0af4a17cf314e673$export$838465f0b10a8424 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($afe807029394ca45$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3b729a9ff7535403$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e02fa63e7cc232b4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($84b8e1127c620c8b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($acee0ead0fdcc85d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9a7cab4fd0ef36a1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a58454118b9af977$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9cb0f2e875db058c$exports)))
];
const $0af4a17cf314e673$export$73f041aa1b99b4cc = [
    (0, (/*@__PURE__*/$parcel$interopDefault($de3e701b3a99661b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c24b14ca7df011ad$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($639ec6dde09c66db$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d14423869d6fec08$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($da66a11769643464$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f3e75343fc9bfbce$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4a102d9b267af3ab$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5e8e29676fe3699f$exports)))
];
const $0af4a17cf314e673$export$850c9407aa04ca24 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($efe4223ca555342e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d4d3d4b90d86f0a2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ab41c69fcd1d72ce$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bde55aaf8ee2d41c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b79350e913a9e737$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0f7f3bb693c7c91a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($233816ca024bf0de$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($392b5fc84cca3bac$exports)))
];
const $0af4a17cf314e673$export$25e22529c0b0772e = [
    (0, (/*@__PURE__*/$parcel$interopDefault($163b375a2d1ef697$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d50a2d41d73c7c17$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($88bea0272150b056$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($744819674213ed22$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0c0d52d8d377c948$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($38c29dc01576b73d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($870fe932c109aec6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5d59d742521a029f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1308cc6442367142$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($afb56b69307797b6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4d3b3d3593752106$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ba51ab8e425f0710$exports)))
];
const $0af4a17cf314e673$export$13dcf7262a09dcaa = [
    (0, (/*@__PURE__*/$parcel$interopDefault($9b14d9235d5a027b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0cca60d74f953819$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b8e9068c310e2458$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($65efba0e1d3b4896$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1647d39d7810d8fe$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4a329a802fd51519$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d877cf8ca549e9f9$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($006d57fdb710fcf0$exports)))
];
const $0af4a17cf314e673$export$f9a43644935fff3a = [
    (0, (/*@__PURE__*/$parcel$interopDefault($7c2e6f2378d9cf3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fa7543812ead47f2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5d0e71ada9150c36$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($aaf5e7fe89bc0d35$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3371a3ee84b7cc97$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0215f3759aa30557$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c33406072e5f873b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9dcdf6df433eb2ee$exports)))
];
const $0af4a17cf314e673$export$a1cceb30f359d53d = [
    (0, (/*@__PURE__*/$parcel$interopDefault($f1d9584a3f8c266e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c5b5487efc95ba1f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7a3bad6fced4b6df$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2fdc633ba7bf3fec$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9fe0fcf6e5ad38fc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1e1a5ebd2d6eeac8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6974629347f924b5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4b1494af88d889dc$exports)))
];
const $0af4a17cf314e673$export$92a55aa69038695a = [
    (0, (/*@__PURE__*/$parcel$interopDefault($d328a81f1b20c42a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d224e4efb0636894$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($eb332019f0da5b2a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1668af9aee062d78$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($87eabb4bf2c2bd4f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c6bad5db942f1bae$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2158b004ae53806d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ce7cb6979b2eba30$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2d7ef9b519785c07$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($20b7125da91652d5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($457860f7ec28656b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($87b1e8754e3bdb4c$exports)))
];
const $0af4a17cf314e673$export$7f2aee5acf21a8ee = [
    (0, (/*@__PURE__*/$parcel$interopDefault($b39da5ddc060223a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fa913afd4e9064bc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a9881f7a92fa4147$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f04e5d873c98e566$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7b7b94fcba51b1f2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3409d0f6906b22fb$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($95cc56212a8bd6f7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9072d8f37d24fd41$exports)))
];
const $0af4a17cf314e673$export$205cf8bd899448c7 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($4c79420fb275fba3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a419e6b6a580f701$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9fe3d0b3f4258519$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6bb71280ca2e45e1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6b6b604332424114$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6138f4c90b76303b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cba60ea961591a8a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6cf5a1769f37ab23$exports)))
];
const $0af4a17cf314e673$export$95955953fabb080f = [
    (0, (/*@__PURE__*/$parcel$interopDefault($3c893e29c5cff50c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3f8a7706446c37e3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0fa9fe9d8c018c8b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6e678615d3d56a3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($26ead80488a5785c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7c2035276a83004d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1388fba4b963a556$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e26b02baaa2d704d$exports)))
];
const $0af4a17cf314e673$export$c05f0cca535ce383 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($889fc5b75bdd982a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($de85eb4497e72623$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($56568e128b7e2eaf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2f8aeb4a1c3788a8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b59319f93ac717ee$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c1e6612f49cc3ead$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5dac55a4808109d7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7daaeb2f193a3d36$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d28d86551b7b87e2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($538c7189c9ef6de7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9d71f58c656c0d38$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($78b2a54c74ef5f19$exports)))
];
const $0af4a17cf314e673$export$5246c8b5008db9a0 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2784c2418957d661$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($51703ab6b1b40da0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6e81a045fca4d982$exports)))
];
const $0af4a17cf314e673$export$ea793f2c86121c1 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($574175f96916230d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3bb224c36091648b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dfa11987f48d9785$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($390eadd88aa58232$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($52bd609ecd26f10b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4b624a7f58880bf7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($68bfc519d931268d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a35b23f8aa072d8b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ace9dd4376c10d9d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($06feb3533e3b2eae$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7d416e2d31bfa58f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b8ec24773f4c301d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($715739464bc5fb88$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f5a8959f294dc464$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3d13e9cc32273554$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($741a441b706c0db6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3568bbf08cc9d5d5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9203c0678ec689fd$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7b6512656558b8f7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d397e9f06a996500$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7fa2dc87e917c62b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7f2e2d7aa805ea2b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4abee58c28254f30$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ab7204e665b9763d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1a09616bfcc76bba$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d561f219d748e296$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6213881caecb5309$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cc73848f80221b7a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a614dcfbe877a677$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d3dea7ddbb6e21e4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($095a25b8e5c60f27$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ea90dc0f5ada9175$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b9a8b73ebd467b33$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($07ee7ea0e08dfa6f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ce4f19cfc365bc26$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2d300d727b04e0df$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($20cc5e39320866ea$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0f7c74ae2e630421$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0739b81096f9a49b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dda97a50573ea32d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($659f7029abe7e8e7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e2d311d52db026c0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($000039ed45721d56$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3e0e6d960ecce924$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3280b171cfd21a73$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1c0c8cc3912ce50f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4ef4a0be306913db$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2d99994fd50744e5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7284beeaf980061d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($caf34d9468b190d0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cf97b3fc9f383a7a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9a5ccb8cd762b8ab$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0e92adbb6cdeb2d0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($18efc7b98dd8739c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c7176918f7353591$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0455648024de7ed8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($46c58ee47bfe8556$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ca30acca15d4240b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cb8b3538e4b9b60f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($588cedbc2a50827e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($72c52951da9f46d8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($50499eb2da360347$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($177a3b36dff534ba$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2f6e675f69614a31$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4aee7be3a1a0f362$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($83c518d87ccf7278$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($69f6dd73a30b6458$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($43144d980c9e800d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6171ca07c9324879$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c58f91d07c76bf1e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a922250f89cc5177$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a1f38991bdf8bda9$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4f3804ab1d071c97$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($29a6c429f0aa4367$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f6323a3e914bba4f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($620da12c14ce88d6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d8a46d98fc542a84$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7ea75995fdc55e87$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($337db551a5c0f5a1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($697a9d481e98d84e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f7491c03a6de7cda$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2eec0936c301a3c8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($585fc0a95b711db0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d719189068c5bde7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($2244dc5946bd8e3a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a8f47b26e39c92d4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($78325d34fe8dbb12$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4806cf83fa70a07f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6f14dc7103005a4c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($95916a0bcdae77c3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fabd832b74525a59$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($02e4f5258f105494$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cc4ad30a239b63a7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f0555cd9a1f4542e$exports)))
];


function $75cf632b34b11e25$var$toCardName(imageUrl) {
    return imageUrl.split("/").pop()?.split(".")[0] ?? imageUrl;
}
function $75cf632b34b11e25$var$buildDefinitions(images, season, source) {
    return images.map((imageUrl)=>({
            name: $75cf632b34b11e25$var$toCardName(imageUrl),
            imageUrl: imageUrl,
            season: season,
            source: source
        }));
}
const $75cf632b34b11e25$export$1acc1ba6e8a7fc0e = $75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$438ecb7653cb7d5c), null, "starter");
const $75cf632b34b11e25$export$37310dc5787c6ead = [
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$838465f0b10a8424), 1, "base"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$13dcf7262a09dcaa), 2, "base"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$7f2aee5acf21a8ee), 3, "base")
];
const $75cf632b34b11e25$export$12a03b29e5e400e5 = [
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$25e22529c0b0772e), 1, "advanced"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$92a55aa69038695a), 2, "advanced"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$c05f0cca535ce383), 3, "advanced")
];
const $75cf632b34b11e25$export$de8a2a88cc7b1963 = [
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$73f041aa1b99b4cc), 1, "hive"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$f9a43644935fff3a), 2, "hive"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$205cf8bd899448c7), 3, "hive")
];
const $75cf632b34b11e25$export$2d1eb671e8b8e061 = [
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$850c9407aa04ca24), 1, "cellar"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$a1cceb30f359d53d), 2, "cellar"),
    ...$75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$95955953fabb080f), 3, "cellar")
];
const $75cf632b34b11e25$export$ce341fca832b1062 = $75cf632b34b11e25$var$buildDefinitions((0, $0af4a17cf314e673$export$5246c8b5008db9a0), null, "seed-event");
const $75cf632b34b11e25$export$82a40ce7f980e40 = [
    ...$75cf632b34b11e25$export$1acc1ba6e8a7fc0e,
    ...$75cf632b34b11e25$export$37310dc5787c6ead,
    ...$75cf632b34b11e25$export$12a03b29e5e400e5,
    ...$75cf632b34b11e25$export$de8a2a88cc7b1963,
    ...$75cf632b34b11e25$export$2d1eb671e8b8e061,
    ...$75cf632b34b11e25$export$ce341fca832b1062
];
const $75cf632b34b11e25$var$actionCardLookup = new Map($75cf632b34b11e25$export$82a40ce7f980e40.map((card)=>[
        card.name,
        card
    ]));
const $75cf632b34b11e25$var$compactAlphabet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const $75cf632b34b11e25$var$compactCodeWidth = 2;
const $75cf632b34b11e25$var$compactSelectableCards = [
    ...$75cf632b34b11e25$export$37310dc5787c6ead,
    ...$75cf632b34b11e25$export$12a03b29e5e400e5,
    ...$75cf632b34b11e25$export$2d1eb671e8b8e061
].map((card, index)=>({
        ...card,
        code: $75cf632b34b11e25$var$encodeCompactNumber(index)
    }));
const $75cf632b34b11e25$var$compactCardCodeLookup = new Map($75cf632b34b11e25$var$compactSelectableCards.map((card)=>[
        card.code,
        card.name
    ]));
const $75cf632b34b11e25$var$compactCardNameLookup = new Map($75cf632b34b11e25$var$compactSelectableCards.map((card)=>[
        card.name,
        card.code
    ]));
function $75cf632b34b11e25$export$350f35cc8fe14249(name) {
    return $75cf632b34b11e25$var$actionCardLookup.get(name);
}
function $75cf632b34b11e25$export$ef7b06446d5f677d() {
    return $75cf632b34b11e25$export$2d1eb671e8b8e061.slice();
}
function $75cf632b34b11e25$export$9ed2a06e2eb0e82e() {
    return [
        ...$75cf632b34b11e25$export$37310dc5787c6ead,
        ...$75cf632b34b11e25$export$12a03b29e5e400e5,
        ...$75cf632b34b11e25$export$2d1eb671e8b8e061
    ];
}
function $75cf632b34b11e25$export$f191e8e7d2a429d1(cardNames) {
    return cardNames.map((cardName)=>$75cf632b34b11e25$var$compactCardNameLookup.get(cardName)).filter((code)=>code != null).sort().join("");
}
function $75cf632b34b11e25$export$aa3f93a482aeb601(encoded) {
    const selectedCardNames = [];
    for(let index = 0; index < encoded.length; index += $75cf632b34b11e25$var$compactCodeWidth){
        const code = encoded.slice(index, index + $75cf632b34b11e25$var$compactCodeWidth);
        if (code.length < $75cf632b34b11e25$var$compactCodeWidth) continue;
        const cardName = $75cf632b34b11e25$var$compactCardCodeLookup.get(code);
        if (cardName != null) selectedCardNames.push(cardName);
    }
    return selectedCardNames;
}
function $75cf632b34b11e25$var$encodeCompactNumber(value) {
    let remaining = value;
    let encoded = "";
    do {
        encoded = $75cf632b34b11e25$var$compactAlphabet[remaining % $75cf632b34b11e25$var$compactAlphabet.length] + encoded;
        remaining = Math.floor(remaining / $75cf632b34b11e25$var$compactAlphabet.length);
    }while (remaining > 0);
    return encoded.padStart($75cf632b34b11e25$var$compactCodeWidth, "0");
}



var $d0aedc3a666faacc$exports = {};
$d0aedc3a666faacc$exports = new URL("Hive-Alex-S1.df1d0505.png", import.meta.url).toString();


var $30e8706ffcabe275$exports = {};
$30e8706ffcabe275$exports = new URL("Hive-Alex-S2.d40b528c.png", import.meta.url).toString();


var $e53300f2641a4949$exports = {};
$e53300f2641a4949$exports = new URL("Hive-Alex-S3.99cfe538.png", import.meta.url).toString();


var $53298ea6a3a11942$exports = {};
$53298ea6a3a11942$exports = new URL("Hive-Jenna-S1.748ad883.png", import.meta.url).toString();


var $17322f4c8536f20e$exports = {};
$17322f4c8536f20e$exports = new URL("Hive-Jenna-S2.e3b66c99.png", import.meta.url).toString();


var $1915ecf08416d029$exports = {};
$1915ecf08416d029$exports = new URL("Hive-Jenna-S3.2d1e9143.png", import.meta.url).toString();


var $f20fb705d322db98$exports = {};
$f20fb705d322db98$exports = new URL("ZenithGardenCo_G1_S1_Prepper.47b78b77.png", import.meta.url).toString();


var $35904cbd0457b1f0$exports = {};
$35904cbd0457b1f0$exports = new URL("ZenithGardenCo_G1_S2_Paperwork.5b95d9bd.png", import.meta.url).toString();


var $1c68c3c35acfaeb6$exports = {};
$1c68c3c35acfaeb6$exports = new URL("ZenithGardenCo_G1_S3_Stockers.38772979.png", import.meta.url).toString();


var $160e79e34d06517e$exports = {};
$160e79e34d06517e$exports = new URL("ZenithGardenCo_G2_S1_Trainee.8960ca49.png", import.meta.url).toString();


var $2f487b4b2eb48ce4$exports = {};
$2f487b4b2eb48ce4$exports = new URL("ZenithGardenCo_G2_S2_Prospector.1f2149f7.png", import.meta.url).toString();


var $e39d59868ccc3bdd$exports = {};
$e39d59868ccc3bdd$exports = new URL("ZenithGardenCo_G2_S3_Crafter.61eeed4f.png", import.meta.url).toString();


var $3659a88aa6c9066a$exports = {};
$3659a88aa6c9066a$exports = new URL("ZenithGardenCo_G3_S1_Smuggler.e6cc6a46.png", import.meta.url).toString();


var $411287919f7daa76$exports = {};
$411287919f7daa76$exports = new URL("ZenithGardenCo_G3_S2_MasterTrader.8bcb00ad.png", import.meta.url).toString();


var $f383959d97afbdba$exports = {};
$f383959d97afbdba$exports = new URL("ZenithGardenCo_G3_S3_SpecialOrder.0e3b4b3c.png", import.meta.url).toString();





const $ff80734700dcac50$export$e2362784656f51f2 = "zenith-garden-co";
// Kept separate from the random objective and action-card pools.
const $ff80734700dcac50$var$zenithGardenCoObjectives = {
    1: {
        1: {
            name: "ZenithGardenCo_G1_S1_Prepper",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f20fb705d322db98$exports)))
        },
        2: {
            name: "ZenithGardenCo_G1_S2_Paperwork",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($35904cbd0457b1f0$exports)))
        },
        3: {
            name: "ZenithGardenCo_G1_S3_Stockers",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1c68c3c35acfaeb6$exports)))
        }
    },
    2: {
        1: {
            name: "ZenithGardenCo_G2_S1_Trainee",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($160e79e34d06517e$exports)))
        },
        2: {
            name: "ZenithGardenCo_G2_S2_Prospector",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2f487b4b2eb48ce4$exports)))
        },
        3: {
            name: "ZenithGardenCo_G2_S3_Crafter",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e39d59868ccc3bdd$exports)))
        }
    },
    3: {
        1: {
            name: "ZenithGardenCo_G3_S1_Smuggler",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3659a88aa6c9066a$exports)))
        },
        2: {
            name: "ZenithGardenCo_G3_S2_MasterTrader",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($411287919f7daa76$exports)))
        },
        3: {
            name: "ZenithGardenCo_G3_S3_SpecialOrder",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f383959d97afbdba$exports)))
        }
    }
};
// These objectives belong only to their exact Hive seed, never to shared pools.
const $ff80734700dcac50$var$hiveInfluencerObjectives = {
    "boardgame-co-hive": {
        1: {
            name: "Hive-Alex-S1",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($d0aedc3a666faacc$exports)))
        },
        2: {
            name: "Hive-Alex-S2",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($30e8706ffcabe275$exports)))
        },
        3: {
            name: "Hive-Alex-S3",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e53300f2641a4949$exports)))
        }
    },
    "boardgame-garden-hive": {
        1: {
            name: "Hive-Jenna-S1",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($53298ea6a3a11942$exports)))
        },
        2: {
            name: "Hive-Jenna-S2",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($17322f4c8536f20e$exports)))
        },
        3: {
            name: "Hive-Jenna-S3",
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1915ecf08416d029$exports)))
        }
    }
};
function $ff80734700dcac50$export$42726379da0917dc(seed) {
    return Object.prototype.hasOwnProperty.call($ff80734700dcac50$var$hiveInfluencerObjectives, $ff80734700dcac50$export$578139a2a6f80b45(seed));
}
function $ff80734700dcac50$export$b8db1089c8443214(seed) {
    return $ff80734700dcac50$export$578139a2a6f80b45(seed) === $ff80734700dcac50$export$e2362784656f51f2;
}
function $ff80734700dcac50$export$989b7d026df6c0ae(name) {
    return [
        ...Object.values($ff80734700dcac50$var$zenithGardenCoObjectives),
        ...Object.values($ff80734700dcac50$var$hiveInfluencerObjectives)
    ].reduce((cards, seasons)=>cards.concat(Object.values(seasons)), []).find((card)=>card.name === name);
}
const $ff80734700dcac50$export$e950c89a2e4681d = "newmodulesincoming";
function $ff80734700dcac50$export$578139a2a6f80b45(seed) {
    return seed?.trim().toLocaleLowerCase() ?? "";
}
function $ff80734700dcac50$export$c047085392fa53a6(seed, campaignGameNumber = 1) {
    const normalizedSeed = $ff80734700dcac50$export$578139a2a6f80b45(seed);
    if ($ff80734700dcac50$export$42726379da0917dc(normalizedSeed)) return {
        seed: normalizedSeed,
        seasonEndCards: $ff80734700dcac50$var$hiveInfluencerObjectives[normalizedSeed]
    };
    if ($ff80734700dcac50$export$b8db1089c8443214(normalizedSeed)) return {
        seed: normalizedSeed,
        seasonEndCards: $ff80734700dcac50$var$zenithGardenCoObjectives[campaignGameNumber]
    };
    if (normalizedSeed !== $ff80734700dcac50$export$e950c89a2e4681d) return null;
    return {
        seed: normalizedSeed,
        seasonEndCards: {
            1: {
                name: "NewModulesIncoming_S1_NewEquipment",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2784c2418957d661$exports)))
            },
            2: {
                name: "NewModulesIncoming_S2_Adaptation",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51703ab6b1b40da0$exports)))
            },
            3: {
                name: "NewModulesIncoming_S3_Investments",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6e81a045fca4d982$exports)))
            }
        }
    };
}


const $559d530d06978d6f$var$SEASON_VISIBLE_CARD_COUNTS = {
    1: 8,
    2: 8,
    3: 6
};
// All image arrays from cardsLists.ts
const $559d530d06978d6f$var$allImageArrays = [
    (0, $0af4a17cf314e673$export$838465f0b10a8424),
    (0, $0af4a17cf314e673$export$25e22529c0b0772e),
    (0, $0af4a17cf314e673$export$13dcf7262a09dcaa),
    (0, $0af4a17cf314e673$export$92a55aa69038695a),
    (0, $0af4a17cf314e673$export$7f2aee5acf21a8ee),
    (0, $0af4a17cf314e673$export$c05f0cca535ce383),
    (0, $0af4a17cf314e673$export$438ecb7653cb7d5c),
    (0, $0af4a17cf314e673$export$73f041aa1b99b4cc),
    (0, $0af4a17cf314e673$export$f9a43644935fff3a),
    (0, $0af4a17cf314e673$export$205cf8bd899448c7),
    (0, $0af4a17cf314e673$export$850c9407aa04ca24),
    (0, $0af4a17cf314e673$export$a1cceb30f359d53d),
    (0, $0af4a17cf314e673$export$95955953fabb080f),
    (0, $0af4a17cf314e673$export$7901e90382cede3a),
    (0, $0af4a17cf314e673$export$899e39b9deff759),
    (0, $0af4a17cf314e673$export$2e3c9d013d135fab),
    (0, $0af4a17cf314e673$export$ea793f2c86121c1)
];
// Function to find card counterparts
const $559d530d06978d6f$var$findCardInImageArrays = (cardName)=>{
    for (let imageArray of $559d530d06978d6f$var$allImageArrays){
        const match = imageArray.find((imageImport)=>imageImport.includes(cardName));
        if (match) return match;
    }
    return null;
};
class $559d530d06978d6f$export$8827d7c739e89978 {
    constructor(){
        this.deckActionCardDraw = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionCardDiscard = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionDrawLeft = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionDrawRight = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionCardActive = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.objectiveOne = undefined;
        this.objectiveTwo = undefined;
        this.objectiveThree = undefined;
        this.cardsWithFullscreenListeners = new Set();
        this.fullscreenCloseListenerBound = false;
    }
    SetupFixedDecks(gameDataObject) {
        this.restoreSerializedState(gameDataObject);
    }
    loadCardsIntoDeck(deck, gameDataCards) {
        deck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        const cardNames = gameDataCards.map((card)=>card.name);
        for (const cardName of cardNames){
            const card = this.createCardByName(cardName);
            if (card != null) deck.addCard(card);
        }
        console.log("create deck", deck);
        return deck;
    }
    SetupDecks(options = {}) {
        if ((0, $ff80734700dcac50$export$42726379da0917dc)(options.currentSeed)) options = {
            ...options,
            hiveExpansionEnabled: true,
            cellarExpansionEnabled: false,
            guaranteedActionCardNames: []
        };
        const includeAdvancedCards = options.includeAdvancedCards ?? true;
        const guaranteedActionCardNames = options.guaranteedActionCardNames ?? [];
        const useCampaignSetup = (options.cellarExpansionEnabled ?? false) || guaranteedActionCardNames.length > 0;
        this.resetDecks();
        this.setupObjectives(options.currentSeed, options.campaignGameNumber);
        if (!useCampaignSetup) {
            this.setupStandardDecks({
                hiveExpansionEnabled: options.hiveExpansionEnabled,
                includeAdvancedCards: includeAdvancedCards,
                currentSeed: options.currentSeed
            });
            return;
        }
        this.setupCampaignDecks({
            includeAdvancedCards: includeAdvancedCards,
            guaranteedActionCardNames: guaranteedActionCardNames,
            cellarExpansionEnabled: options.cellarExpansionEnabled,
            currentSeed: options.currentSeed
        });
    }
    getSerializedState() {
        return {
            deckActionCardDraw: this.deckActionCardDraw.serialize(),
            deckActionCardDiscard: this.deckActionCardDiscard.serialize(),
            deckActionDrawLeft: this.deckActionDrawLeft.serialize(),
            deckActionDrawRight: this.deckActionDrawRight.serialize(),
            deckActionCardActive: this.deckActionCardActive.serialize(),
            objectiveOne: this.objectiveOne ? this.objectiveOne.serialize() : null,
            objectiveTwo: this.objectiveTwo ? this.objectiveTwo.serialize() : null,
            objectiveThree: this.objectiveThree ? this.objectiveThree.serialize() : null
        };
    }
    getCurrentGameActionCardNames(options = {}) {
        const excludeStarterCards = options.excludeStarterCards ?? false;
        const seenNames = new Set();
        const orderedNames = [];
        const pushCardName = (card)=>{
            if (card == null) return;
            if (excludeStarterCards && this.isStarterCard(card.name)) return;
            if (!seenNames.has(card.name)) {
                seenNames.add(card.name);
                orderedNames.push(card.name);
            }
        };
        const decks = [
            this.deckActionCardActive,
            this.deckActionCardDraw,
            this.deckActionCardDiscard,
            this.deckActionDrawLeft,
            this.deckActionDrawRight
        ];
        for (const deck of decks)for (const card of deck.cards)pushCardName(card);
        return orderedNames;
    }
    restoreSerializedState(state) {
        this.resetDecks();
        this.deckActionCardDraw = this.loadCardsIntoDeck(this.deckActionCardDraw, state.deckActionCardDraw.cards);
        this.deckActionCardDiscard = this.loadCardsIntoDeck(this.deckActionCardDiscard, state.deckActionCardDiscard.cards);
        this.deckActionDrawLeft = this.loadCardsIntoDeck(this.deckActionDrawLeft, state.deckActionDrawLeft.cards);
        this.deckActionDrawRight = this.loadCardsIntoDeck(this.deckActionDrawRight, state.deckActionDrawRight.cards);
        this.deckActionCardActive = this.loadCardsIntoDeck(this.deckActionCardActive, state.deckActionCardActive.cards);
        this.objectiveOne = state.objectiveOne ? this.createCardByName(state.objectiveOne.name) ?? undefined : undefined;
        this.objectiveTwo = state.objectiveTwo ? this.createCardByName(state.objectiveTwo.name) ?? undefined : undefined;
        this.objectiveThree = state.objectiveThree ? this.createCardByName(state.objectiveThree.name) ?? undefined : undefined;
    }
    resetDecks() {
        this.deckActionCardDraw = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionCardDiscard = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionDrawLeft = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionDrawRight = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.deckActionCardActive = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        this.objectiveOne = undefined;
        this.objectiveTwo = undefined;
        this.objectiveThree = undefined;
    }
    setupObjectives(currentSeed, campaignGameNumber) {
        const s1ObjectiveDeck = this.createDeck((0, $0af4a17cf314e673$export$7901e90382cede3a));
        const s2ObjectiveDeck = this.createDeck((0, $0af4a17cf314e673$export$899e39b9deff759));
        const s3ObjectiveDeck = this.createDeck((0, $0af4a17cf314e673$export$2e3c9d013d135fab));
        s1ObjectiveDeck.shuffle();
        s2ObjectiveDeck.shuffle();
        s3ObjectiveDeck.shuffle();
        this.objectiveOne = s1ObjectiveDeck.cards[0];
        this.objectiveTwo = s2ObjectiveDeck.cards[0];
        this.objectiveThree = s3ObjectiveDeck.cards[0];
        const seedEvent = (0, $ff80734700dcac50$export$c047085392fa53a6)(currentSeed, campaignGameNumber);
        if (seedEvent != null) {
            this.objectiveOne = new (0, $0a5588a683073f93$export$60332b2344f7fe41)(seedEvent.seasonEndCards[1].name, seedEvent.seasonEndCards[1].imageUrl);
            this.objectiveTwo = new (0, $0a5588a683073f93$export$60332b2344f7fe41)(seedEvent.seasonEndCards[2].name, seedEvent.seasonEndCards[2].imageUrl);
            this.objectiveThree = new (0, $0a5588a683073f93$export$60332b2344f7fe41)(seedEvent.seasonEndCards[3].name, seedEvent.seasonEndCards[3].imageUrl);
        }
    }
    setupStandardDecks(options) {
        const starterActionDeck = this.createDeck((0, $0af4a17cf314e673$export$438ecb7653cb7d5c));
        starterActionDeck.shuffle();
        const seasonOneBaseImages = options.hiveExpansionEnabled ? (0, $0af4a17cf314e673$export$838465f0b10a8424).concat((0, $0af4a17cf314e673$export$73f041aa1b99b4cc)) : (0, $0af4a17cf314e673$export$838465f0b10a8424);
        const seasonTwoBaseImages = options.hiveExpansionEnabled ? (0, $0af4a17cf314e673$export$13dcf7262a09dcaa).concat((0, $0af4a17cf314e673$export$f9a43644935fff3a)) : (0, $0af4a17cf314e673$export$13dcf7262a09dcaa);
        const seasonThreeBaseImages = options.hiveExpansionEnabled ? (0, $0af4a17cf314e673$export$7f2aee5acf21a8ee).concat((0, $0af4a17cf314e673$export$205cf8bd899448c7)) : (0, $0af4a17cf314e673$export$7f2aee5acf21a8ee);
        const actionS1BaseDeck = this.createDeck(seasonOneBaseImages);
        const actionS1FlexDeck = options.includeAdvancedCards ? this.createDeck((0, $0af4a17cf314e673$export$25e22529c0b0772e)) : new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        const actionS2BaseDeck = this.createDeck(seasonTwoBaseImages);
        const actionS2FlexDeck = options.includeAdvancedCards ? this.createDeck((0, $0af4a17cf314e673$export$92a55aa69038695a)) : new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        const actionS3BaseDeck = this.createDeck(seasonThreeBaseImages);
        const actionS3FlexDeck = options.includeAdvancedCards ? this.createDeck((0, $0af4a17cf314e673$export$c05f0cca535ce383)) : new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        actionS1BaseDeck.shuffle();
        actionS2BaseDeck.shuffle();
        actionS3BaseDeck.shuffle();
        if (options.includeAdvancedCards) {
            actionS1FlexDeck.shuffle();
            actionS2FlexDeck.shuffle();
            actionS3FlexDeck.shuffle();
        }
        const s1ActionCardSelectionDeck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for(let index = 0; index < 8; index++)s1ActionCardSelectionDeck.addCard(actionS1BaseDeck.takeTopCard());
        if (options.includeAdvancedCards) for(let index = 0; index < 6; index++)s1ActionCardSelectionDeck.addCard(actionS1FlexDeck.takeTopCard());
        s1ActionCardSelectionDeck.shuffle();
        const s2ActionCardSelectionDeck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for(let index = 0; index < 8; index++)s2ActionCardSelectionDeck.addCard(actionS2BaseDeck.takeTopCard());
        if (options.includeAdvancedCards) for(let index = 0; index < 5; index++)s2ActionCardSelectionDeck.addCard(actionS2FlexDeck.takeTopCard());
        s2ActionCardSelectionDeck.shuffle();
        const s3ActionCardSelectionDeck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for(let index = 0; index < 8; index++)s3ActionCardSelectionDeck.addCard(actionS3BaseDeck.takeTopCard());
        if (options.includeAdvancedCards) for(let index = 0; index < 5; index++)s3ActionCardSelectionDeck.addCard(actionS3FlexDeck.takeTopCard());
        s3ActionCardSelectionDeck.shuffle();
        this.dealSeasonCardsToRoundDecks(s3ActionCardSelectionDeck, 3);
        this.dealSeasonCardsToRoundDecks(s2ActionCardSelectionDeck, 4);
        this.dealSeasonCardsToRoundDecks(s1ActionCardSelectionDeck, 4);
        for(let index = 0; index < 9; index++)this.deckActionCardDraw.addCard(starterActionDeck.takeTopCard());
        for(let index = 0; index < 5; index++)this.deckActionCardActive.addCard(this.deckActionCardDraw.takeTopCard());
    }
    setupCampaignDecks(options) {
        const starterActionDeck = this.createDeck((0, $0af4a17cf314e673$export$438ecb7653cb7d5c));
        starterActionDeck.shuffle();
        const seasonOneCards = this.buildCampaignSeasonDeck(1, options);
        const seasonTwoCards = this.buildCampaignSeasonDeck(2, options);
        const seasonThreeCards = this.buildCampaignSeasonDeck(3, options);
        this.dealSeasonCardsToRoundDecks(seasonThreeCards, 3);
        this.dealSeasonCardsToRoundDecks(seasonTwoCards, 4);
        this.dealSeasonCardsToRoundDecks(seasonOneCards, 4);
        for(let index = 0; index < 9; index++)this.deckActionCardDraw.addCard(starterActionDeck.takeTopCard());
        for(let index = 0; index < 5; index++)this.deckActionCardActive.addCard(this.deckActionCardDraw.takeTopCard());
    }
    buildCampaignSeasonDeck(season, options) {
        const seasonBaseImages = season === 1 ? (0, $0af4a17cf314e673$export$838465f0b10a8424) : season === 2 ? (0, $0af4a17cf314e673$export$13dcf7262a09dcaa) : (0, $0af4a17cf314e673$export$7f2aee5acf21a8ee);
        const seasonAdvancedImages = season === 1 ? (0, $0af4a17cf314e673$export$25e22529c0b0772e) : season === 2 ? (0, $0af4a17cf314e673$export$92a55aa69038695a) : (0, $0af4a17cf314e673$export$c05f0cca535ce383);
        const seasonCellarImages = season === 1 ? (0, $0af4a17cf314e673$export$850c9407aa04ca24) : season === 2 ? (0, $0af4a17cf314e673$export$a1cceb30f359d53d) : (0, $0af4a17cf314e673$export$95955953fabb080f);
        const eligibleImages = seasonBaseImages.concat(options.cellarExpansionEnabled ? seasonCellarImages : []).concat(options.includeAdvancedCards ? seasonAdvancedImages : []);
        const eligibleDeck = this.createDeck(eligibleImages);
        const guaranteedForSeason = options.guaranteedActionCardNames.map((cardName)=>this.createCardByName(cardName)).filter((card)=>card != null && this.getSeasonForCard(card.name) === season);
        const guaranteedNames = new Set(guaranteedForSeason.map((card)=>card.name));
        const availableCards = eligibleDeck.cards.filter((card)=>!guaranteedNames.has(card.name));
        const visibleCardCount = $559d530d06978d6f$var$SEASON_VISIBLE_CARD_COUNTS[season];
        if (guaranteedForSeason.length > visibleCardCount) throw new Error(`Too many guaranteed Season ${season} cards selected for this game.`);
        const fillDeck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for (const card of availableCards)fillDeck.addCard(card);
        fillDeck.shuffle();
        const finalDeck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for (const guaranteedCard of guaranteedForSeason)finalDeck.addCard(guaranteedCard);
        while(finalDeck.getCardCount() < visibleCardCount)finalDeck.addCard(fillDeck.takeTopCard());
        finalDeck.shuffle();
        return finalDeck;
    }
    dealSeasonCardsToRoundDecks(seasonDeck, cardsPerSide) {
        for(let index = 0; index < cardsPerSide; index++){
            this.deckActionDrawLeft.addCard(seasonDeck.takeTopCard());
            this.deckActionDrawRight.addCard(seasonDeck.takeTopCard());
        }
    }
    ShowCurrentCards() {
        this.changeCardImage("objective1", this.objectiveOne?.imageUrl, false);
        this.changeCardImage("objective2", this.objectiveTwo?.imageUrl, false);
        this.changeCardImage("objective3", this.objectiveThree?.imageUrl, false);
        if (this.deckActionDrawLeft.getCardCount() > 0) this.changeCardImage("nextCardLeft", this.deckActionDrawLeft.viewTopCard()?.imageUrl, true);
        else this.changeCardImage("nextCardLeft", undefined, true);
        if (this.deckActionDrawRight.getCardCount() > 0) this.changeCardImage("nextCardRight", this.deckActionDrawRight.viewTopCard()?.imageUrl, true);
        else this.changeCardImage("nextCardRight", undefined, true);
        this.changeCardImage("activeCard1", this.deckActionCardActive.cards[0].imageUrl, true);
        this.changeCardImage("activeCard2", this.deckActionCardActive.cards[1].imageUrl, true);
        this.changeCardImage("activeCard3", this.deckActionCardActive.cards[2].imageUrl, true);
        this.changeCardImage("activeCard4", this.deckActionCardActive.cards[3].imageUrl, true);
        this.changeCardImage("activeCard5", this.deckActionCardActive.cards[4].imageUrl, true);
    }
    ShowScoringObjective(season) {
        const overlay = document.getElementById("scoring-objective-overlay");
        const title = document.getElementById("scoring-objective-title");
        const card = document.getElementById("scoring-objective-card");
        const objective = this.getObjectiveForSeason(season);
        if (overlay == null || title == null || card == null || objective == null) {
            this.HideScoringObjective();
            return;
        }
        title.textContent = `Score Season ${season} Objective`;
        card.style.backgroundImage = `url(${objective.imageUrl})`;
        overlay.classList.add("show");
        overlay.setAttribute("aria-hidden", "false");
    }
    HideScoringObjective() {
        const overlay = document.getElementById("scoring-objective-overlay");
        if (overlay == null) return;
        overlay.classList.remove("show");
        overlay.setAttribute("aria-hidden", "true");
    }
    SetupNextRound() {
        console.log("setting up next round");
        const cardCountOfActiveCards = this.deckActionCardActive.getCardCount();
        // first move all active cards to the discard
        for(let index = 0; index < cardCountOfActiveCards; index++){
            this.deckActionCardDiscard.addCard(this.deckActionCardActive.takeTopCard());
            console.log("discarding card " + index);
        }
        // Draw 3 cards from the deck
        for(let index = 0; index < 3; index++){
            // If the draw pile is empty, transfer all cards from the discard pile to the draw pile and shuffle
            if (this.deckActionCardDraw.getCardCount() == 0) {
                console.log("Refreshing draw pile!");
                const discardPileSize = this.deckActionCardDiscard.getCardCount();
                for(let index = 0; index < discardPileSize; index++)this.deckActionCardDraw.addCard(this.deckActionCardDiscard.takeTopCard());
            }
            this.deckActionCardActive.addCard(this.deckActionCardDraw.takeTopCard());
        }
        // Then add the new cards to the pile
        if (this.deckActionDrawLeft.getCardCount() > 0) this.deckActionCardActive.addCard(this.deckActionDrawLeft.takeTopCard());
        if (this.deckActionDrawRight.getCardCount() > 0) this.deckActionCardActive.addCard(this.deckActionDrawRight.takeTopCard());
    }
    createDeck(images) {
        const deck = new (0, $0a5588a683073f93$export$9b013bad9d0245d0)();
        for(let index = 0; index < images.length; index++){
            const url = images[index];
            const fileName = url.split("/").pop()?.split(".")[0];
            if (fileName != undefined) {
                const card = new (0, $0a5588a683073f93$export$60332b2344f7fe41)(fileName, images[index]);
                //console.log('creating card: ' + card.name);
                deck.addCard(card);
            }
        }
        console.log(deck);
        return deck;
    }
    createCardByName(cardName) {
        const actionCard = (0, $75cf632b34b11e25$export$350f35cc8fe14249)(cardName);
        if (actionCard != null) return new (0, $0a5588a683073f93$export$60332b2344f7fe41)(actionCard.name, actionCard.imageUrl);
        const seedEventCard = (0, $ff80734700dcac50$export$989b7d026df6c0ae)(cardName);
        if (seedEventCard != null) return new (0, $0a5588a683073f93$export$60332b2344f7fe41)(seedEventCard.name, seedEventCard.imageUrl);
        const counterpart = $559d530d06978d6f$var$findCardInImageArrays(cardName);
        if (counterpart != null) return new (0, $0a5588a683073f93$export$60332b2344f7fe41)(cardName, counterpart);
        return null;
    }
    getSeasonForCard(cardName) {
        const actionCard = (0, $75cf632b34b11e25$export$350f35cc8fe14249)(cardName);
        return actionCard?.season ?? null;
    }
    isStarterCard(cardName) {
        const actionCard = (0, $75cf632b34b11e25$export$350f35cc8fe14249)(cardName);
        return actionCard?.source === "starter";
    }
    getObjectiveForSeason(season) {
        if (season === 1) return this.objectiveOne;
        if (season === 2) return this.objectiveTwo;
        if (season === 3) return this.objectiveThree;
        return undefined;
    }
    changeCardImage(cardId, imageUrl, animate) {
        const card = document.getElementById(cardId);
        if (card) {
            const fullscreenContainer = document.getElementById("fullscreen-container");
            const fullscreenCard = document.getElementById("fullscreen-card");
            if (fullscreenCard != null && fullscreenContainer != null) {
                if (!this.cardsWithFullscreenListeners.has(cardId)) {
                    card.addEventListener("click", ()=>{
                        fullscreenCard.innerHTML = card.innerHTML;
                        fullscreenCard.style.backgroundImage = card.style.backgroundImage;
                        fullscreenCard.style.backgroundSize = "cover";
                        fullscreenCard.style.backgroundPosition = "center";
                        fullscreenContainer.classList.add("show");
                    });
                    this.cardsWithFullscreenListeners.add(cardId);
                }
                if (!this.fullscreenCloseListenerBound) {
                    fullscreenContainer.addEventListener("click", (e)=>{
                        if (e.target === fullscreenContainer) fullscreenContainer.classList.remove("show");
                    });
                    this.fullscreenCloseListenerBound = true;
                }
            }
            if (animate == true) {
                card.classList.add("bouncy");
                // Remove the bouncy class after the animation ends to allow it to be retriggered
                setTimeout(()=>{
                    card.classList.remove("bouncy");
                }, 600);
            }
            if (imageUrl == undefined) imageUrl = "https://ucarecdn.com/a5791dbc-b180-47fd-aa98-7b7cad74ec91/-/preview/714x1000/";
            card.style.backgroundImage = `url(${imageUrl})`;
            card.style.backgroundSize = "cover"; // Ensures the image covers the entire card
            card.style.backgroundPosition = "center"; // Centers the image
        } else console.error(`Card with ID ${cardId} not found.`);
    }
    saveStateToFile(filename) {
        const state = this.getSerializedState();
        fs.writeFileSync(filename, JSON.stringify(state, null, 2));
        console.log(`Deck state saved to ${filename}`);
    }
    saveStateToLocalStorage(keyword) {
        const state = this.getSerializedState();
        localStorage.setItem(keyword, JSON.stringify(state));
        console.log(`Deck state saved with keyword: ${keyword}`);
    }
    /*
    
    loadStateFromFile(filename: string) {
        const data = fs.readFileSync(filename, 'utf-8');
        const state = JSON.parse(data);

        this.deckActionCardDraw = Deck.deserialize(state.deckActionCardDraw);
        this.deckActionCardDiscard = Deck.deserialize(state.deckActionCardDiscard);
        this.deckActionDrawLeft = Deck.deserialize(state.deckActionDrawLeft);
        this.deckActionDrawRight = Deck.deserialize(state.deckActionDrawRight);
        this.deckActionCardActive = Deck.deserialize(state.deckActionCardActive);

        this.objectiveOne = state.objectiveOne ? Card.deserialize(state.objectiveOne) : undefined;
        this.objectiveTwo = state.objectiveTwo ? Card.deserialize(state.objectiveTwo) : undefined;
        this.objectiveThree = state.objectiveThree ? Card.deserialize(state.objectiveThree) : undefined;

        console.log(`Deck state loaded from ${filename}`);
    }
    */ loadDeckFromFile(filePath) {
        fs.readFile(filePath, "utf8", async (err, jsonString)=>{
            if (err) {
                console.error("Error reading file:", err);
                return;
            }
            try {
                const data = JSON.parse(jsonString);
                // Assuming directory path is passed or known
                const directoryPath = "./images"; // Example path
                const deckActionCardDraw = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(data.deckActionCardDraw, directoryPath);
                const deckActionCardDiscard = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(data.deckActionCardDiscard, directoryPath);
                const deckActionDrawLeft = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(data.deckActionDrawLeft, directoryPath);
                const deckActionDrawRight = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(data.deckActionDrawRight, directoryPath);
                const deckActionCardActive = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(data.deckActionCardActive, directoryPath);
                console.log("Decks loaded successfully:");
                console.log(deckActionCardDraw, deckActionCardDiscard, deckActionDrawLeft, deckActionDrawRight, deckActionCardActive);
            } catch (err) {
                console.error("Error parsing JSON string:", err);
            }
        });
    }
    async initializeDecks() {
        const directoryPath = "./images";
        const deckActionCardDraw = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(deckData.deckActionCardDraw, directoryPath);
        const deckActionCardDiscard = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(deckData.deckActionCardDiscard, directoryPath);
        const deckActionDrawLeft = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(deckData.deckActionDrawLeft, directoryPath);
        const deckActionDrawRight = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(deckData.deckActionDrawRight, directoryPath);
        const deckActionCardActive = await (0, $0a5588a683073f93$export$9b013bad9d0245d0).deserialize(deckData.deckActionCardActive, directoryPath);
        console.log("Decks initialized successfully:");
        console.log(deckActionCardDraw, deckActionCardDiscard, deckActionDrawLeft, deckActionDrawRight, deckActionCardActive);
    }
}


var $ee6eeebe8e486495$exports = {};
$ee6eeebe8e486495$exports = new URL("yellow-1.c0393b3d.svg", import.meta.url).toString();


var $118e599d321c2fa6$exports = {};
$118e599d321c2fa6$exports = new URL("yellow-2.b7cf2407.svg", import.meta.url).toString();


var $d3cba6e412b615e7$exports = {};
$d3cba6e412b615e7$exports = new URL("yellow-3.93fbe54c.svg", import.meta.url).toString();


var $b64f398c0de27afb$exports = {};
$b64f398c0de27afb$exports = new URL("yellow-4.d60bdaf0.svg", import.meta.url).toString();


var $be5fc8595631a7d0$exports = {};
$be5fc8595631a7d0$exports = new URL("yellow-5.1967517a.svg", import.meta.url).toString();


var $d60b73da2fd4d22a$exports = {};
$d60b73da2fd4d22a$exports = new URL("yellow-wild.a55853f7.svg", import.meta.url).toString();


var $4b453d5f3dd369f0$exports = {};
$4b453d5f3dd369f0$exports = new URL("white-1.a6efde01.svg", import.meta.url).toString();


var $f73d1809cea1e4d2$exports = {};
$f73d1809cea1e4d2$exports = new URL("white-4.60363cd0.svg", import.meta.url).toString();


var $1c3a08e53d566b47$exports = {};
$1c3a08e53d566b47$exports = new URL("white-5.47d37326.svg", import.meta.url).toString();


var $440779c444f79921$exports = {};
$440779c444f79921$exports = new URL("white-5-alt.86d0df77.svg", import.meta.url).toString();


var $46522e22773ff7be$exports = {};
$46522e22773ff7be$exports = new URL("white-6.458aea04.svg", import.meta.url).toString();


var $214c07a15fdca6d0$exports = {};
$214c07a15fdca6d0$exports = new URL("white-wild.59922731.svg", import.meta.url).toString();


const $2ec4bfea98255610$var$whiteFaces = [
    (0, (/*@__PURE__*/$parcel$interopDefault($4b453d5f3dd369f0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f73d1809cea1e4d2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1c3a08e53d566b47$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($440779c444f79921$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($46522e22773ff7be$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($214c07a15fdca6d0$exports)))
];
const $2ec4bfea98255610$var$yellowFaces = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ee6eeebe8e486495$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($118e599d321c2fa6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d3cba6e412b615e7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b64f398c0de27afb$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($be5fc8595631a7d0$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d60b73da2fd4d22a$exports)))
];
const $2ec4bfea98255610$var$rollAnimationDelays = [
    34,
    42,
    52,
    64,
    78,
    94,
    116,
    142,
    174
];
class $2ec4bfea98255610$export$f04aa403a5e6975e {
    initialize() {
        this.container = document.getElementById("bee-dice-row");
        this.whiteDie = document.getElementById("bee-die-white");
        this.yellowDie = document.getElementById("bee-die-yellow");
    }
    setSeed(seed) {
        this.seed = seed.toLocaleLowerCase();
        this.rolls = Array.from({
            length: 12
        }, (_, index)=>({
                white: this.rollDie("white", index + 1),
                yellow: this.rollDie("yellow", index + 1)
            }));
    }
    setEnabled(isEnabled, currentRound) {
        this.enabled = isEnabled;
        this.container?.classList.toggle("is-hidden", !isEnabled);
        window.dispatchEvent(new CustomEvent("card-row-visibility-change"));
        if (isEnabled) this.showRound(currentRound, false);
        else this.clearAnimation();
    }
    showRound(round, animate) {
        if (!this.enabled) return;
        const roll = this.rolls[Math.max(0, Math.min(round - 1, this.rolls.length - 1))];
        if (roll == null) return;
        if (!animate || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this.setDiceFaces(roll);
            this.playFinishAnimation();
            return;
        }
        this.animateToRoll(roll, round);
    }
    animateToRoll(roll, round) {
        this.clearAnimation();
        this.container?.classList.add("is-rolling");
        this.container?.classList.remove("has-finished-roll");
        let elapsed = 0;
        $2ec4bfea98255610$var$rollAnimationDelays.forEach((delay, index)=>{
            elapsed += delay;
            const timer = window.setTimeout(()=>{
                this.setDiceFaces({
                    white: (round + index) % $2ec4bfea98255610$var$whiteFaces.length,
                    yellow: (round + index + 2) % $2ec4bfea98255610$var$yellowFaces.length
                });
            }, elapsed);
            this.animationTimers.push(timer);
        });
        const finalTimer = window.setTimeout(()=>{
            this.setDiceFaces(roll);
            this.container?.classList.remove("is-rolling");
            this.playFinishAnimation();
        }, elapsed + 120);
        this.animationTimers.push(finalTimer);
    }
    setDiceFaces(roll) {
        if (this.whiteDie != null) {
            this.whiteDie.src = $2ec4bfea98255610$var$whiteFaces[roll.white];
            this.whiteDie.alt = `White bee die ${this.getFaceLabel("white", roll.white)}`;
        }
        if (this.yellowDie != null) {
            this.yellowDie.src = $2ec4bfea98255610$var$yellowFaces[roll.yellow];
            this.yellowDie.alt = `Yellow bee die ${this.getFaceLabel("yellow", roll.yellow)}`;
        }
    }
    playFinishAnimation() {
        this.container?.classList.remove("has-finished-roll");
        window.setTimeout(()=>{
            this.container?.classList.add("has-finished-roll");
        }, 0);
    }
    clearAnimation() {
        this.animationTimers.forEach((timer)=>window.clearTimeout(timer));
        this.animationTimers = [];
        this.container?.classList.remove("is-rolling", "has-finished-roll");
    }
    rollDie(color, round) {
        return this.hashToIndex(`${this.seed}|bee-dice|${color}|round-${round}`, 6);
    }
    hashToIndex(value, size) {
        let hash = 2166136261;
        for(let index = 0; index < value.length; index++){
            hash ^= value.charCodeAt(index);
            hash = Math.imul(hash, 16777619);
        }
        return (hash >>> 0) % size;
    }
    getFaceLabel(color, index) {
        const labels = color === "white" ? [
            "1",
            "4",
            "5",
            "5",
            "6",
            "wild"
        ] : [
            "1",
            "2",
            "3",
            "4",
            "5",
            "wild"
        ];
        return labels[index] ?? "unknown";
    }
    constructor(){
        this.container = null;
        this.whiteDie = null;
        this.yellowDie = null;
        this.seed = "";
        this.rolls = [];
        this.enabled = false;
        this.animationTimers = [];
    }
}


const $5a81d9be4d45fe0a$var$a = (a)=>{
    a = 1831565813 + (a |= 0) | 0;
    let e = Math.imul(a ^ a >>> 15, 1 | a);
    return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
};
class $5a81d9be4d45fe0a$var$e {
    constructor(a){
        this.dictionaries = void 0, this.length = void 0, this.separator = void 0, this.style = void 0, this.seed = void 0;
        const { length: e, separator: i, dictionaries: n, style: l, seed: r } = a;
        this.dictionaries = n, this.separator = i, this.length = e, this.style = l, this.seed = r;
    }
    generate() {
        if (!this.dictionaries) throw new Error('Cannot find any dictionary. Please provide at least one, or leave the "dictionary" field empty in the config object');
        if (this.length <= 0) throw new Error("Invalid length provided");
        if (this.length > this.dictionaries.length) throw new Error(`The length cannot be bigger than the number of dictionaries.\nLength provided: ${this.length}. Number of dictionaries provided: ${this.dictionaries.length}`);
        let e = this.seed;
        return this.dictionaries.slice(0, this.length).reduce((i, n)=>{
            let l;
            e ? (l = ((e)=>{
                if ("string" == typeof e) {
                    const i = e.split("").map((a)=>a.charCodeAt(0)).reduce((a, e)=>a + e, 1), n = Math.floor(Number(i));
                    return $5a81d9be4d45fe0a$var$a(n);
                }
                return $5a81d9be4d45fe0a$var$a(e);
            })(e), e = 4294967296 * l) : l = Math.random();
            let r = n[Math.floor(l * n.length)] || "";
            if ("lowerCase" === this.style) r = r.toLowerCase();
            else if ("capital" === this.style) {
                const [a, ...e] = r.split("");
                r = a.toUpperCase() + e.join("");
            } else "upperCase" === this.style && (r = r.toUpperCase());
            return i ? `${i}${this.separator}${r}` : `${r}`;
        }, "");
    }
}
const $5a81d9be4d45fe0a$var$i = {
    separator: "_",
    dictionaries: []
}, $5a81d9be4d45fe0a$export$cbc7f705af9d46b6 = (a)=>{
    const n = [
        ...a && a.dictionaries || $5a81d9be4d45fe0a$var$i.dictionaries
    ], l = {
        ...$5a81d9be4d45fe0a$var$i,
        ...a,
        length: a && a.length || n.length,
        dictionaries: n
    };
    if (!a || !a.dictionaries || !a.dictionaries.length) throw new Error('A "dictionaries" array must be provided. This is a breaking change introduced starting from Unique Name Generator v4. Read more about the breaking change here: https://github.com/andreasonny83/unique-names-generator#migration-guide');
    return new $5a81d9be4d45fe0a$var$e(l).generate();
};
var $5a81d9be4d45fe0a$export$91076e975f93bb = [
    "able",
    "above",
    "absent",
    "absolute",
    "abstract",
    "abundant",
    "academic",
    "acceptable",
    "accepted",
    "accessible",
    "accurate",
    "accused",
    "active",
    "actual",
    "acute",
    "added",
    "additional",
    "adequate",
    "adjacent",
    "administrative",
    "adorable",
    "advanced",
    "adverse",
    "advisory",
    "aesthetic",
    "afraid",
    "aggregate",
    "aggressive",
    "agreeable",
    "agreed",
    "agricultural",
    "alert",
    "alive",
    "alleged",
    "allied",
    "alone",
    "alright",
    "alternative",
    "amateur",
    "amazing",
    "ambitious",
    "amused",
    "ancient",
    "angry",
    "annoyed",
    "annual",
    "anonymous",
    "anxious",
    "appalling",
    "apparent",
    "applicable",
    "appropriate",
    "arbitrary",
    "architectural",
    "armed",
    "arrogant",
    "artificial",
    "artistic",
    "ashamed",
    "asleep",
    "assistant",
    "associated",
    "atomic",
    "attractive",
    "automatic",
    "autonomous",
    "available",
    "average",
    "awake",
    "aware",
    "awful",
    "awkward",
    "back",
    "bad",
    "balanced",
    "bare",
    "basic",
    "beautiful",
    "beneficial",
    "better",
    "bewildered",
    "big",
    "binding",
    "biological",
    "bitter",
    "bizarre",
    "blank",
    "blind",
    "blonde",
    "bloody",
    "blushing",
    "boiling",
    "bold",
    "bored",
    "boring",
    "bottom",
    "brainy",
    "brave",
    "breakable",
    "breezy",
    "brief",
    "bright",
    "brilliant",
    "broad",
    "broken",
    "bumpy",
    "burning",
    "busy",
    "calm",
    "capable",
    "capitalist",
    "careful",
    "casual",
    "causal",
    "cautious",
    "central",
    "certain",
    "changing",
    "characteristic",
    "charming",
    "cheap",
    "cheerful",
    "chemical",
    "chief",
    "chilly",
    "chosen",
    "christian",
    "chronic",
    "chubby",
    "circular",
    "civic",
    "civil",
    "civilian",
    "classic",
    "classical",
    "clean",
    "clear",
    "clever",
    "clinical",
    "close",
    "closed",
    "cloudy",
    "clumsy",
    "coastal",
    "cognitive",
    "coherent",
    "cold",
    "collective",
    "colonial",
    "colorful",
    "colossal",
    "coloured",
    "colourful",
    "combative",
    "combined",
    "comfortable",
    "coming",
    "commercial",
    "common",
    "communist",
    "compact",
    "comparable",
    "comparative",
    "compatible",
    "competent",
    "competitive",
    "complete",
    "complex",
    "complicated",
    "comprehensive",
    "compulsory",
    "conceptual",
    "concerned",
    "concrete",
    "condemned",
    "confident",
    "confidential",
    "confused",
    "conscious",
    "conservation",
    "conservative",
    "considerable",
    "consistent",
    "constant",
    "constitutional",
    "contemporary",
    "content",
    "continental",
    "continued",
    "continuing",
    "continuous",
    "controlled",
    "controversial",
    "convenient",
    "conventional",
    "convinced",
    "convincing",
    "cooing",
    "cool",
    "cooperative",
    "corporate",
    "correct",
    "corresponding",
    "costly",
    "courageous",
    "crazy",
    "creative",
    "creepy",
    "criminal",
    "critical",
    "crooked",
    "crowded",
    "crucial",
    "crude",
    "cruel",
    "cuddly",
    "cultural",
    "curious",
    "curly",
    "current",
    "curved",
    "cute",
    "daily",
    "damaged",
    "damp",
    "dangerous",
    "dark",
    "dead",
    "deaf",
    "deafening",
    "dear",
    "decent",
    "decisive",
    "deep",
    "defeated",
    "defensive",
    "defiant",
    "definite",
    "deliberate",
    "delicate",
    "delicious",
    "delighted",
    "delightful",
    "democratic",
    "dependent",
    "depressed",
    "desirable",
    "desperate",
    "detailed",
    "determined",
    "developed",
    "developing",
    "devoted",
    "different",
    "difficult",
    "digital",
    "diplomatic",
    "direct",
    "dirty",
    "disabled",
    "disappointed",
    "disastrous",
    "disciplinary",
    "disgusted",
    "distant",
    "distinct",
    "distinctive",
    "distinguished",
    "disturbed",
    "disturbing",
    "diverse",
    "divine",
    "dizzy",
    "domestic",
    "dominant",
    "double",
    "doubtful",
    "drab",
    "dramatic",
    "dreadful",
    "driving",
    "drunk",
    "dry",
    "dual",
    "due",
    "dull",
    "dusty",
    "dutch",
    "dying",
    "dynamic",
    "eager",
    "early",
    "eastern",
    "easy",
    "economic",
    "educational",
    "eerie",
    "effective",
    "efficient",
    "elaborate",
    "elated",
    "elderly",
    "eldest",
    "electoral",
    "electric",
    "electrical",
    "electronic",
    "elegant",
    "eligible",
    "embarrassed",
    "embarrassing",
    "emotional",
    "empirical",
    "empty",
    "enchanting",
    "encouraging",
    "endless",
    "energetic",
    "enormous",
    "enthusiastic",
    "entire",
    "entitled",
    "envious",
    "environmental",
    "equal",
    "equivalent",
    "essential",
    "established",
    "estimated",
    "ethical",
    "ethnic",
    "eventual",
    "everyday",
    "evident",
    "evil",
    "evolutionary",
    "exact",
    "excellent",
    "exceptional",
    "excess",
    "excessive",
    "excited",
    "exciting",
    "exclusive",
    "existing",
    "exotic",
    "expected",
    "expensive",
    "experienced",
    "experimental",
    "explicit",
    "extended",
    "extensive",
    "external",
    "extra",
    "extraordinary",
    "extreme",
    "exuberant",
    "faint",
    "fair",
    "faithful",
    "familiar",
    "famous",
    "fancy",
    "fantastic",
    "far",
    "fascinating",
    "fashionable",
    "fast",
    "fat",
    "fatal",
    "favourable",
    "favourite",
    "federal",
    "fellow",
    "female",
    "feminist",
    "few",
    "fierce",
    "filthy",
    "final",
    "financial",
    "fine",
    "firm",
    "fiscal",
    "fit",
    "fixed",
    "flaky",
    "flat",
    "flexible",
    "fluffy",
    "fluttering",
    "flying",
    "following",
    "fond",
    "foolish",
    "foreign",
    "formal",
    "formidable",
    "forthcoming",
    "fortunate",
    "forward",
    "fragile",
    "frail",
    "frantic",
    "free",
    "frequent",
    "fresh",
    "friendly",
    "frightened",
    "front",
    "frozen",
    "full",
    "fun",
    "functional",
    "fundamental",
    "funny",
    "furious",
    "future",
    "fuzzy",
    "gastric",
    "gay",
    "general",
    "generous",
    "genetic",
    "gentle",
    "genuine",
    "geographical",
    "giant",
    "gigantic",
    "given",
    "glad",
    "glamorous",
    "gleaming",
    "global",
    "glorious",
    "golden",
    "good",
    "gorgeous",
    "gothic",
    "governing",
    "graceful",
    "gradual",
    "grand",
    "grateful",
    "greasy",
    "great",
    "grieving",
    "grim",
    "gross",
    "grotesque",
    "growing",
    "grubby",
    "grumpy",
    "guilty",
    "handicapped",
    "handsome",
    "happy",
    "hard",
    "harsh",
    "head",
    "healthy",
    "heavy",
    "helpful",
    "helpless",
    "hidden",
    "high",
    "hilarious",
    "hissing",
    "historic",
    "historical",
    "hollow",
    "holy",
    "homeless",
    "homely",
    "hon",
    "honest",
    "horizontal",
    "horrible",
    "hostile",
    "hot",
    "huge",
    "human",
    "hungry",
    "hurt",
    "hushed",
    "husky",
    "icy",
    "ideal",
    "identical",
    "ideological",
    "ill",
    "illegal",
    "imaginative",
    "immediate",
    "immense",
    "imperial",
    "implicit",
    "important",
    "impossible",
    "impressed",
    "impressive",
    "improved",
    "inadequate",
    "inappropriate",
    "inc",
    "inclined",
    "increased",
    "increasing",
    "incredible",
    "independent",
    "indirect",
    "individual",
    "industrial",
    "inevitable",
    "influential",
    "informal",
    "inherent",
    "initial",
    "injured",
    "inland",
    "inner",
    "innocent",
    "innovative",
    "inquisitive",
    "instant",
    "institutional",
    "insufficient",
    "intact",
    "integral",
    "integrated",
    "intellectual",
    "intelligent",
    "intense",
    "intensive",
    "interested",
    "interesting",
    "interim",
    "interior",
    "intermediate",
    "internal",
    "international",
    "intimate",
    "invisible",
    "involved",
    "irrelevant",
    "isolated",
    "itchy",
    "jealous",
    "jittery",
    "joint",
    "jolly",
    "joyous",
    "judicial",
    "juicy",
    "junior",
    "just",
    "keen",
    "key",
    "kind",
    "known",
    "labour",
    "large",
    "late",
    "latin",
    "lazy",
    "leading",
    "left",
    "legal",
    "legislative",
    "legitimate",
    "lengthy",
    "lesser",
    "level",
    "lexical",
    "liable",
    "liberal",
    "light",
    "like",
    "likely",
    "limited",
    "linear",
    "linguistic",
    "liquid",
    "literary",
    "little",
    "live",
    "lively",
    "living",
    "local",
    "logical",
    "lonely",
    "long",
    "loose",
    "lost",
    "loud",
    "lovely",
    "low",
    "loyal",
    "ltd",
    "lucky",
    "mad",
    "magic",
    "magnetic",
    "magnificent",
    "main",
    "major",
    "male",
    "mammoth",
    "managerial",
    "managing",
    "manual",
    "many",
    "marginal",
    "marine",
    "marked",
    "married",
    "marvellous",
    "marxist",
    "mass",
    "massive",
    "mathematical",
    "mature",
    "maximum",
    "mean",
    "meaningful",
    "mechanical",
    "medical",
    "medieval",
    "melodic",
    "melted",
    "mental",
    "mere",
    "metropolitan",
    "mid",
    "middle",
    "mighty",
    "mild",
    "military",
    "miniature",
    "minimal",
    "minimum",
    "ministerial",
    "minor",
    "miserable",
    "misleading",
    "missing",
    "misty",
    "mixed",
    "moaning",
    "mobile",
    "moderate",
    "modern",
    "modest",
    "molecular",
    "monetary",
    "monthly",
    "moral",
    "motionless",
    "muddy",
    "multiple",
    "mushy",
    "musical",
    "mute",
    "mutual",
    "mysterious",
    "naked",
    "narrow",
    "nasty",
    "national",
    "native",
    "natural",
    "naughty",
    "naval",
    "near",
    "nearby",
    "neat",
    "necessary",
    "negative",
    "neighbouring",
    "nervous",
    "net",
    "neutral",
    "new",
    "nice",
    "noble",
    "noisy",
    "normal",
    "northern",
    "nosy",
    "notable",
    "novel",
    "nuclear",
    "numerous",
    "nursing",
    "nutritious",
    "nutty",
    "obedient",
    "objective",
    "obliged",
    "obnoxious",
    "obvious",
    "occasional",
    "occupational",
    "odd",
    "official",
    "ok",
    "okay",
    "old",
    "olympic",
    "only",
    "open",
    "operational",
    "opposite",
    "optimistic",
    "oral",
    "ordinary",
    "organic",
    "organisational",
    "original",
    "orthodox",
    "other",
    "outdoor",
    "outer",
    "outrageous",
    "outside",
    "outstanding",
    "overall",
    "overseas",
    "overwhelming",
    "painful",
    "pale",
    "panicky",
    "parallel",
    "parental",
    "parliamentary",
    "partial",
    "particular",
    "passing",
    "passive",
    "past",
    "patient",
    "payable",
    "peaceful",
    "peculiar",
    "perfect",
    "permanent",
    "persistent",
    "personal",
    "petite",
    "philosophical",
    "physical",
    "plain",
    "planned",
    "plastic",
    "pleasant",
    "pleased",
    "poised",
    "polite",
    "political",
    "poor",
    "popular",
    "positive",
    "possible",
    "potential",
    "powerful",
    "practical",
    "precious",
    "precise",
    "preferred",
    "pregnant",
    "preliminary",
    "premier",
    "prepared",
    "present",
    "presidential",
    "pretty",
    "previous",
    "prickly",
    "primary",
    "prime",
    "primitive",
    "principal",
    "printed",
    "prior",
    "private",
    "probable",
    "productive",
    "professional",
    "profitable",
    "profound",
    "progressive",
    "prominent",
    "promising",
    "proper",
    "proposed",
    "prospective",
    "protective",
    "protestant",
    "proud",
    "provincial",
    "psychiatric",
    "psychological",
    "public",
    "puny",
    "pure",
    "purring",
    "puzzled",
    "quaint",
    "qualified",
    "quarrelsome",
    "querulous",
    "quick",
    "quickest",
    "quiet",
    "quintessential",
    "quixotic",
    "racial",
    "radical",
    "rainy",
    "random",
    "rapid",
    "rare",
    "raspy",
    "rational",
    "ratty",
    "raw",
    "ready",
    "real",
    "realistic",
    "rear",
    "reasonable",
    "recent",
    "reduced",
    "redundant",
    "regional",
    "registered",
    "regular",
    "regulatory",
    "related",
    "relative",
    "relaxed",
    "relevant",
    "reliable",
    "relieved",
    "religious",
    "reluctant",
    "remaining",
    "remarkable",
    "remote",
    "renewed",
    "representative",
    "repulsive",
    "required",
    "resident",
    "residential",
    "resonant",
    "respectable",
    "respective",
    "responsible",
    "resulting",
    "retail",
    "retired",
    "revolutionary",
    "rich",
    "ridiculous",
    "right",
    "rigid",
    "ripe",
    "rising",
    "rival",
    "roasted",
    "robust",
    "rolling",
    "romantic",
    "rotten",
    "rough",
    "round",
    "royal",
    "rubber",
    "rude",
    "ruling",
    "running",
    "rural",
    "sacred",
    "sad",
    "safe",
    "salty",
    "satisfactory",
    "satisfied",
    "scared",
    "scary",
    "scattered",
    "scientific",
    "scornful",
    "scrawny",
    "screeching",
    "secondary",
    "secret",
    "secure",
    "select",
    "selected",
    "selective",
    "selfish",
    "semantic",
    "senior",
    "sensible",
    "sensitive",
    "separate",
    "serious",
    "severe",
    "sexual",
    "shaggy",
    "shaky",
    "shallow",
    "shared",
    "sharp",
    "sheer",
    "shiny",
    "shivering",
    "shocked",
    "short",
    "shrill",
    "shy",
    "sick",
    "significant",
    "silent",
    "silky",
    "silly",
    "similar",
    "simple",
    "single",
    "skilled",
    "skinny",
    "sleepy",
    "slight",
    "slim",
    "slimy",
    "slippery",
    "slow",
    "small",
    "smart",
    "smiling",
    "smoggy",
    "smooth",
    "social",
    "socialist",
    "soft",
    "solar",
    "sole",
    "solid",
    "sophisticated",
    "sore",
    "sorry",
    "sound",
    "sour",
    "southern",
    "soviet",
    "spare",
    "sparkling",
    "spatial",
    "special",
    "specific",
    "specified",
    "spectacular",
    "spicy",
    "spiritual",
    "splendid",
    "spontaneous",
    "sporting",
    "spotless",
    "spotty",
    "square",
    "squealing",
    "stable",
    "stale",
    "standard",
    "static",
    "statistical",
    "statutory",
    "steady",
    "steep",
    "sticky",
    "stiff",
    "still",
    "stingy",
    "stormy",
    "straight",
    "straightforward",
    "strange",
    "strategic",
    "strict",
    "striking",
    "striped",
    "strong",
    "structural",
    "stuck",
    "stupid",
    "subjective",
    "subsequent",
    "substantial",
    "subtle",
    "successful",
    "successive",
    "sudden",
    "sufficient",
    "suitable",
    "sunny",
    "super",
    "superb",
    "superior",
    "supporting",
    "supposed",
    "supreme",
    "sure",
    "surprised",
    "surprising",
    "surrounding",
    "surviving",
    "suspicious",
    "sweet",
    "swift",
    "symbolic",
    "sympathetic",
    "systematic",
    "tall",
    "tame",
    "tart",
    "tasteless",
    "tasty",
    "technical",
    "technological",
    "teenage",
    "temporary",
    "tender",
    "tense",
    "terrible",
    "territorial",
    "testy",
    "then",
    "theoretical",
    "thick",
    "thin",
    "thirsty",
    "thorough",
    "thoughtful",
    "thoughtless",
    "thundering",
    "tight",
    "tiny",
    "tired",
    "top",
    "tory",
    "total",
    "tough",
    "toxic",
    "traditional",
    "tragic",
    "tremendous",
    "tricky",
    "tropical",
    "troubled",
    "typical",
    "ugliest",
    "ugly",
    "ultimate",
    "unable",
    "unacceptable",
    "unaware",
    "uncertain",
    "unchanged",
    "uncomfortable",
    "unconscious",
    "underground",
    "underlying",
    "unemployed",
    "uneven",
    "unexpected",
    "unfair",
    "unfortunate",
    "unhappy",
    "uniform",
    "uninterested",
    "unique",
    "united",
    "universal",
    "unknown",
    "unlikely",
    "unnecessary",
    "unpleasant",
    "unsightly",
    "unusual",
    "unwilling",
    "upper",
    "upset",
    "uptight",
    "urban",
    "urgent",
    "used",
    "useful",
    "useless",
    "usual",
    "vague",
    "valid",
    "valuable",
    "variable",
    "varied",
    "various",
    "varying",
    "vast",
    "verbal",
    "vertical",
    "very",
    "vicarious",
    "vicious",
    "victorious",
    "violent",
    "visible",
    "visiting",
    "visual",
    "vital",
    "vitreous",
    "vivacious",
    "vivid",
    "vocal",
    "vocational",
    "voiceless",
    "voluminous",
    "voluntary",
    "vulnerable",
    "wandering",
    "warm",
    "wasteful",
    "watery",
    "weak",
    "wealthy",
    "weary",
    "wee",
    "weekly",
    "weird",
    "welcome",
    "well",
    "western",
    "wet",
    "whispering",
    "whole",
    "wicked",
    "wide",
    "widespread",
    "wild",
    "wilful",
    "willing",
    "willowy",
    "wily",
    "wise",
    "wispy",
    "wittering",
    "witty",
    "wonderful",
    "wooden",
    "working",
    "worldwide",
    "worried",
    "worrying",
    "worthwhile",
    "worthy",
    "written",
    "wrong",
    "xenacious",
    "xenial",
    "xenogeneic",
    "xenophobic",
    "xeric",
    "xerothermic",
    "yabbering",
    "yammering",
    "yappiest",
    "yappy",
    "yawning",
    "yearling",
    "yearning",
    "yeasty",
    "yelling",
    "yelping",
    "yielding",
    "yodelling",
    "young",
    "youngest",
    "youthful",
    "ytterbic",
    "yucky",
    "yummy",
    "zany",
    "zealous",
    "zeroth",
    "zestful",
    "zesty",
    "zippy",
    "zonal",
    "zoophagous",
    "zygomorphic",
    "zygotic"
], $5a81d9be4d45fe0a$export$c0295a61754d69eb = [
    "aardvark",
    "aardwolf",
    "albatross",
    "alligator",
    "alpaca",
    "amphibian",
    "anaconda",
    "angelfish",
    "anglerfish",
    "ant",
    "anteater",
    "antelope",
    "antlion",
    "ape",
    "aphid",
    "armadillo",
    "asp",
    "baboon",
    "badger",
    "bandicoot",
    "barnacle",
    "barracuda",
    "basilisk",
    "bass",
    "bat",
    "bear",
    "beaver",
    "bedbug",
    "bee",
    "beetle",
    "bird",
    "bison",
    "blackbird",
    "boa",
    "boar",
    "bobcat",
    "bobolink",
    "bonobo",
    "booby",
    "bovid",
    "bug",
    "butterfly",
    "buzzard",
    "camel",
    "canid",
    "canidae",
    "capybara",
    "cardinal",
    "caribou",
    "carp",
    "cat",
    "caterpillar",
    "catfish",
    "catshark",
    "cattle",
    "centipede",
    "cephalopod",
    "chameleon",
    "cheetah",
    "chickadee",
    "chicken",
    "chimpanzee",
    "chinchilla",
    "chipmunk",
    "cicada",
    "clam",
    "clownfish",
    "cobra",
    "cockroach",
    "cod",
    "condor",
    "constrictor",
    "coral",
    "cougar",
    "cow",
    "coyote",
    "crab",
    "crane",
    "crawdad",
    "crayfish",
    "cricket",
    "crocodile",
    "crow",
    "cuckoo",
    "damselfly",
    "deer",
    "dingo",
    "dinosaur",
    "dog",
    "dolphin",
    "donkey",
    "dormouse",
    "dove",
    "dragon",
    "dragonfly",
    "duck",
    "eagle",
    "earthworm",
    "earwig",
    "echidna",
    "eel",
    "egret",
    "elephant",
    "elk",
    "emu",
    "ermine",
    "falcon",
    "felidae",
    "ferret",
    "finch",
    "firefly",
    "fish",
    "flamingo",
    "flea",
    "fly",
    "flyingfish",
    "fowl",
    "fox",
    "frog",
    "galliform",
    "gamefowl",
    "gayal",
    "gazelle",
    "gecko",
    "gerbil",
    "gibbon",
    "giraffe",
    "goat",
    "goldfish",
    "goose",
    "gopher",
    "gorilla",
    "grasshopper",
    "grouse",
    "guan",
    "guanaco",
    "guineafowl",
    "gull",
    "guppy",
    "haddock",
    "halibut",
    "hamster",
    "hare",
    "harrier",
    "hawk",
    "hedgehog",
    "heron",
    "herring",
    "hippopotamus",
    "hookworm",
    "hornet",
    "horse",
    "hoverfly",
    "hummingbird",
    "hyena",
    "iguana",
    "impala",
    "jackal",
    "jaguar",
    "jay",
    "jellyfish",
    "junglefowl",
    "kangaroo",
    "kingfisher",
    "kite",
    "kiwi",
    "koala",
    "koi",
    "krill",
    "ladybug",
    "lamprey",
    "landfowl",
    "lark",
    "leech",
    "lemming",
    "lemur",
    "leopard",
    "leopon",
    "limpet",
    "lion",
    "lizard",
    "llama",
    "lobster",
    "locust",
    "loon",
    "louse",
    "lungfish",
    "lynx",
    "macaw",
    "mackerel",
    "magpie",
    "mammal",
    "manatee",
    "mandrill",
    "marlin",
    "marmoset",
    "marmot",
    "marsupial",
    "marten",
    "mastodon",
    "meadowlark",
    "meerkat",
    "mink",
    "minnow",
    "mite",
    "mockingbird",
    "mole",
    "mollusk",
    "mongoose",
    "monkey",
    "moose",
    "mosquito",
    "moth",
    "mouse",
    "mule",
    "muskox",
    "narwhal",
    "newt",
    "nightingale",
    "ocelot",
    "octopus",
    "opossum",
    "orangutan",
    "orca",
    "ostrich",
    "otter",
    "owl",
    "ox",
    "panda",
    "panther",
    "parakeet",
    "parrot",
    "parrotfish",
    "partridge",
    "peacock",
    "peafowl",
    "pelican",
    "penguin",
    "perch",
    "pheasant",
    "pig",
    "pigeon",
    "pike",
    "pinniped",
    "piranha",
    "planarian",
    "platypus",
    "pony",
    "porcupine",
    "porpoise",
    "possum",
    "prawn",
    "primate",
    "ptarmigan",
    "puffin",
    "puma",
    "python",
    "quail",
    "quelea",
    "quokka",
    "rabbit",
    "raccoon",
    "rat",
    "rattlesnake",
    "raven",
    "reindeer",
    "reptile",
    "rhinoceros",
    "roadrunner",
    "rodent",
    "rook",
    "rooster",
    "roundworm",
    "sailfish",
    "salamander",
    "salmon",
    "sawfish",
    "scallop",
    "scorpion",
    "seahorse",
    "shark",
    "sheep",
    "shrew",
    "shrimp",
    "silkworm",
    "silverfish",
    "skink",
    "skunk",
    "sloth",
    "slug",
    "smelt",
    "snail",
    "snake",
    "snipe",
    "sole",
    "sparrow",
    "spider",
    "spoonbill",
    "squid",
    "squirrel",
    "starfish",
    "stingray",
    "stoat",
    "stork",
    "sturgeon",
    "swallow",
    "swan",
    "swift",
    "swordfish",
    "swordtail",
    "tahr",
    "takin",
    "tapir",
    "tarantula",
    "tarsier",
    "termite",
    "tern",
    "thrush",
    "tick",
    "tiger",
    "tiglon",
    "toad",
    "tortoise",
    "toucan",
    "trout",
    "tuna",
    "turkey",
    "turtle",
    "tyrannosaurus",
    "unicorn",
    "urial",
    "vicuna",
    "viper",
    "vole",
    "vulture",
    "wallaby",
    "walrus",
    "warbler",
    "wasp",
    "weasel",
    "whale",
    "whippet",
    "whitefish",
    "wildcat",
    "wildebeest",
    "wildfowl",
    "wolf",
    "wolverine",
    "wombat",
    "woodpecker",
    "worm",
    "wren",
    "xerinae",
    "yak",
    "zebra"
], $5a81d9be4d45fe0a$export$8f45430ccf837300 = [
    "amaranth",
    "amber",
    "amethyst",
    "apricot",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "black",
    "blue",
    "blush",
    "bronze",
    "brown",
    "chocolate",
    "coffee",
    "copper",
    "coral",
    "crimson",
    "cyan",
    "emerald",
    "fuchsia",
    "gold",
    "gray",
    "green",
    "harlequin",
    "indigo",
    "ivory",
    "jade",
    "lavender",
    "lime",
    "magenta",
    "maroon",
    "moccasin",
    "olive",
    "orange",
    "peach",
    "pink",
    "plum",
    "purple",
    "red",
    "rose",
    "salmon",
    "sapphire",
    "scarlet",
    "silver",
    "tan",
    "teal",
    "tomato",
    "turquoise",
    "violet",
    "white",
    "yellow"
], $5a81d9be4d45fe0a$export$e5ad74579c86b003 = [
    "Afghanistan",
    "\xc5land Islands",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Ascension Island",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Canary Islands",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Ceuta & Melilla",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "C\xf4te d'Ivoire",
    "Croatia",
    "Cuba",
    "Cura\xe7ao",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Diego Garcia",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Eurozone",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong SAR China",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau SAR China",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Korea",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Islands",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "R\xe9union",
    "Romania",
    "Russia",
    "Rwanda",
    "Samoa",
    "San Marino",
    "S\xe3o Tom\xe9 & Pr\xedncipe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia & South Sandwich Islands",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "St. Barth\xe9lemy",
    "St. Helena",
    "St. Kitts & Nevis",
    "St. Lucia",
    "St. Martin",
    "St. Pierre & Miquelon",
    "St. Vincent & Grenadines",
    "Sudan",
    "Suriname",
    "Svalbard & Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tristan da Cunha",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "U.S. Outlying Islands",
    "U.S. Virgin Islands",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United Nations",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Wallis & Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
], $5a81d9be4d45fe0a$export$d0d68bb9ed2c643d = [
    "Akan",
    "Amharic",
    "Arabic",
    "Assamese",
    "Awadhi",
    "Azerbaijani",
    "Balochi",
    "Belarusian",
    "Bengali",
    "Bhojpuri",
    "Burmese",
    "Cebuano",
    "Chewa",
    "Chhattisgarhi",
    "Chittagonian",
    "Czech",
    "Deccan",
    "Dhundhari",
    "Dutch",
    "English",
    "French",
    "Fula",
    "Gan",
    "German",
    "Greek",
    "Gujarati",
    "Hakka",
    "Haryanvi",
    "Hausa",
    "Hiligaynon",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Igbo",
    "Ilocano",
    "Italian",
    "Japanese",
    "Javanese",
    "Jin",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Kirundi",
    "Konkani",
    "Korean",
    "Kurdish",
    "Madurese",
    "Magahi",
    "Maithili",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Mandarin",
    "Marathi",
    "Marwari",
    "Min",
    "Mossi",
    "Nepali",
    "Odia",
    "Oromo",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Russian",
    "Saraiki",
    "Shona",
    "Sindhi",
    "Sinhala",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swedish",
    "Sylheti",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Vietnamese",
    "Wu",
    "Xhosa",
    "Xiang",
    "Yoruba",
    "Yue",
    "Zhuang",
    "Zulu"
], $5a81d9be4d45fe0a$export$e4b2ac9215619f8d = [
    "Aaren",
    "Aarika",
    "Abagael",
    "Abagail",
    "Abbe",
    "Abbey",
    "Abbi",
    "Abbie",
    "Abby",
    "Abbye",
    "Abigael",
    "Abigail",
    "Abigale",
    "Abra",
    "Ada",
    "Adah",
    "Adaline",
    "Adan",
    "Adara",
    "Adda",
    "Addi",
    "Addia",
    "Addie",
    "Addy",
    "Adel",
    "Adela",
    "Adelaida",
    "Adelaide",
    "Adele",
    "Adelheid",
    "Adelice",
    "Adelina",
    "Adelind",
    "Adeline",
    "Adella",
    "Adelle",
    "Adena",
    "Adey",
    "Adi",
    "Adiana",
    "Adina",
    "Adora",
    "Adore",
    "Adoree",
    "Adorne",
    "Adrea",
    "Adria",
    "Adriaens",
    "Adrian",
    "Adriana",
    "Adriane",
    "Adrianna",
    "Adrianne",
    "Adriena",
    "Adrienne",
    "Aeriel",
    "Aeriela",
    "Aeriell",
    "Afton",
    "Ag",
    "Agace",
    "Agata",
    "Agatha",
    "Agathe",
    "Aggi",
    "Aggie",
    "Aggy",
    "Agna",
    "Agnella",
    "Agnes",
    "Agnese",
    "Agnesse",
    "Agneta",
    "Agnola",
    "Agretha",
    "Aida",
    "Aidan",
    "Aigneis",
    "Aila",
    "Aile",
    "Ailee",
    "Aileen",
    "Ailene",
    "Ailey",
    "Aili",
    "Ailina",
    "Ailis",
    "Ailsun",
    "Ailyn",
    "Aime",
    "Aimee",
    "Aimil",
    "Aindrea",
    "Ainslee",
    "Ainsley",
    "Ainslie",
    "Ajay",
    "Alaine",
    "Alameda",
    "Alana",
    "Alanah",
    "Alane",
    "Alanna",
    "Alayne",
    "Alberta",
    "Albertina",
    "Albertine",
    "Albina",
    "Alecia",
    "Aleda",
    "Aleece",
    "Aleen",
    "Alejandra",
    "Alejandrina",
    "Alena",
    "Alene",
    "Alessandra",
    "Aleta",
    "Alethea",
    "Alex",
    "Alexa",
    "Alexandra",
    "Alexandrina",
    "Alexi",
    "Alexia",
    "Alexina",
    "Alexine",
    "Alexis",
    "Alfi",
    "Alfie",
    "Alfreda",
    "Alfy",
    "Ali",
    "Alia",
    "Alica",
    "Alice",
    "Alicea",
    "Alicia",
    "Alida",
    "Alidia",
    "Alie",
    "Alika",
    "Alikee",
    "Alina",
    "Aline",
    "Alis",
    "Alisa",
    "Alisha",
    "Alison",
    "Alissa",
    "Alisun",
    "Alix",
    "Aliza",
    "Alla",
    "Alleen",
    "Allegra",
    "Allene",
    "Alli",
    "Allianora",
    "Allie",
    "Allina",
    "Allis",
    "Allison",
    "Allissa",
    "Allix",
    "Allsun",
    "Allx",
    "Ally",
    "Allyce",
    "Allyn",
    "Allys",
    "Allyson",
    "Alma",
    "Almeda",
    "Almeria",
    "Almeta",
    "Almira",
    "Almire",
    "Aloise",
    "Aloisia",
    "Aloysia",
    "Alta",
    "Althea",
    "Alvera",
    "Alverta",
    "Alvina",
    "Alvinia",
    "Alvira",
    "Alyce",
    "Alyda",
    "Alys",
    "Alysa",
    "Alyse",
    "Alysia",
    "Alyson",
    "Alyss",
    "Alyssa",
    "Amabel",
    "Amabelle",
    "Amalea",
    "Amalee",
    "Amaleta",
    "Amalia",
    "Amalie",
    "Amalita",
    "Amalle",
    "Amanda",
    "Amandi",
    "Amandie",
    "Amandy",
    "Amara",
    "Amargo",
    "Amata",
    "Amber",
    "Amberly",
    "Ambur",
    "Ame",
    "Amelia",
    "Amelie",
    "Amelina",
    "Ameline",
    "Amelita",
    "Ami",
    "Amie",
    "Amii",
    "Amil",
    "Amitie",
    "Amity",
    "Ammamaria",
    "Amy",
    "Amye",
    "Ana",
    "Anabal",
    "Anabel",
    "Anabella",
    "Anabelle",
    "Analiese",
    "Analise",
    "Anallese",
    "Anallise",
    "Anastasia",
    "Anastasie",
    "Anastassia",
    "Anatola",
    "Andee",
    "Andeee",
    "Anderea",
    "Andi",
    "Andie",
    "Andra",
    "Andrea",
    "Andreana",
    "Andree",
    "Andrei",
    "Andria",
    "Andriana",
    "Andriette",
    "Andromache",
    "Andy",
    "Anestassia",
    "Anet",
    "Anett",
    "Anetta",
    "Anette",
    "Ange",
    "Angel",
    "Angela",
    "Angele",
    "Angelia",
    "Angelica",
    "Angelika",
    "Angelina",
    "Angeline",
    "Angelique",
    "Angelita",
    "Angelle",
    "Angie",
    "Angil",
    "Angy",
    "Ania",
    "Anica",
    "Anissa",
    "Anita",
    "Anitra",
    "Anjanette",
    "Anjela",
    "Ann",
    "Ann-marie",
    "Anna",
    "Anna-diana",
    "Anna-diane",
    "Anna-maria",
    "Annabal",
    "Annabel",
    "Annabela",
    "Annabell",
    "Annabella",
    "Annabelle",
    "Annadiana",
    "Annadiane",
    "Annalee",
    "Annaliese",
    "Annalise",
    "Annamaria",
    "Annamarie",
    "Anne",
    "Anne-corinne",
    "Anne-marie",
    "Annecorinne",
    "Anneliese",
    "Annelise",
    "Annemarie",
    "Annetta",
    "Annette",
    "Anni",
    "Annice",
    "Annie",
    "Annis",
    "Annissa",
    "Annmaria",
    "Annmarie",
    "Annnora",
    "Annora",
    "Anny",
    "Anselma",
    "Ansley",
    "Anstice",
    "Anthe",
    "Anthea",
    "Anthia",
    "Anthiathia",
    "Antoinette",
    "Antonella",
    "Antonetta",
    "Antonia",
    "Antonie",
    "Antonietta",
    "Antonina",
    "Anya",
    "Appolonia",
    "April",
    "Aprilette",
    "Ara",
    "Arabel",
    "Arabela",
    "Arabele",
    "Arabella",
    "Arabelle",
    "Arda",
    "Ardath",
    "Ardeen",
    "Ardelia",
    "Ardelis",
    "Ardella",
    "Ardelle",
    "Arden",
    "Ardene",
    "Ardenia",
    "Ardine",
    "Ardis",
    "Ardisj",
    "Ardith",
    "Ardra",
    "Ardyce",
    "Ardys",
    "Ardyth",
    "Aretha",
    "Ariadne",
    "Ariana",
    "Aridatha",
    "Ariel",
    "Ariela",
    "Ariella",
    "Arielle",
    "Arlana",
    "Arlee",
    "Arleen",
    "Arlen",
    "Arlena",
    "Arlene",
    "Arleta",
    "Arlette",
    "Arleyne",
    "Arlie",
    "Arliene",
    "Arlina",
    "Arlinda",
    "Arline",
    "Arluene",
    "Arly",
    "Arlyn",
    "Arlyne",
    "Aryn",
    "Ashely",
    "Ashia",
    "Ashien",
    "Ashil",
    "Ashla",
    "Ashlan",
    "Ashlee",
    "Ashleigh",
    "Ashlen",
    "Ashley",
    "Ashli",
    "Ashlie",
    "Ashly",
    "Asia",
    "Astra",
    "Astrid",
    "Astrix",
    "Atalanta",
    "Athena",
    "Athene",
    "Atlanta",
    "Atlante",
    "Auberta",
    "Aubine",
    "Aubree",
    "Aubrette",
    "Aubrey",
    "Aubrie",
    "Aubry",
    "Audi",
    "Audie",
    "Audra",
    "Audre",
    "Audrey",
    "Audrie",
    "Audry",
    "Audrye",
    "Audy",
    "Augusta",
    "Auguste",
    "Augustina",
    "Augustine",
    "Aundrea",
    "Aura",
    "Aurea",
    "Aurel",
    "Aurelea",
    "Aurelia",
    "Aurelie",
    "Auria",
    "Aurie",
    "Aurilia",
    "Aurlie",
    "Auroora",
    "Aurora",
    "Aurore",
    "Austin",
    "Austina",
    "Austine",
    "Ava",
    "Aveline",
    "Averil",
    "Averyl",
    "Avie",
    "Avis",
    "Aviva",
    "Avivah",
    "Avril",
    "Avrit",
    "Ayn",
    "Bab",
    "Babara",
    "Babb",
    "Babbette",
    "Babbie",
    "Babette",
    "Babita",
    "Babs",
    "Bambi",
    "Bambie",
    "Bamby",
    "Barb",
    "Barbabra",
    "Barbara",
    "Barbara-anne",
    "Barbaraanne",
    "Barbe",
    "Barbee",
    "Barbette",
    "Barbey",
    "Barbi",
    "Barbie",
    "Barbra",
    "Barby",
    "Bari",
    "Barrie",
    "Barry",
    "Basia",
    "Bathsheba",
    "Batsheva",
    "Bea",
    "Beatrice",
    "Beatrisa",
    "Beatrix",
    "Beatriz",
    "Bebe",
    "Becca",
    "Becka",
    "Becki",
    "Beckie",
    "Becky",
    "Bee",
    "Beilul",
    "Beitris",
    "Bekki",
    "Bel",
    "Belia",
    "Belicia",
    "Belinda",
    "Belita",
    "Bell",
    "Bella",
    "Bellanca",
    "Belle",
    "Bellina",
    "Belva",
    "Belvia",
    "Bendite",
    "Benedetta",
    "Benedicta",
    "Benedikta",
    "Benetta",
    "Benita",
    "Benni",
    "Bennie",
    "Benny",
    "Benoite",
    "Berenice",
    "Beret",
    "Berget",
    "Berna",
    "Bernadene",
    "Bernadette",
    "Bernadina",
    "Bernadine",
    "Bernardina",
    "Bernardine",
    "Bernelle",
    "Bernete",
    "Bernetta",
    "Bernette",
    "Berni",
    "Bernice",
    "Bernie",
    "Bernita",
    "Berny",
    "Berri",
    "Berrie",
    "Berry",
    "Bert",
    "Berta",
    "Berte",
    "Bertha",
    "Berthe",
    "Berti",
    "Bertie",
    "Bertina",
    "Bertine",
    "Berty",
    "Beryl",
    "Beryle",
    "Bess",
    "Bessie",
    "Bessy",
    "Beth",
    "Bethanne",
    "Bethany",
    "Bethena",
    "Bethina",
    "Betsey",
    "Betsy",
    "Betta",
    "Bette",
    "Bette-ann",
    "Betteann",
    "Betteanne",
    "Betti",
    "Bettina",
    "Bettine",
    "Betty",
    "Bettye",
    "Beulah",
    "Bev",
    "Beverie",
    "Beverlee",
    "Beverley",
    "Beverlie",
    "Beverly",
    "Bevvy",
    "Bianca",
    "Bianka",
    "Bibbie",
    "Bibby",
    "Bibbye",
    "Bibi",
    "Biddie",
    "Biddy",
    "Bidget",
    "Bili",
    "Bill",
    "Billi",
    "Billie",
    "Billy",
    "Billye",
    "Binni",
    "Binnie",
    "Binny",
    "Bird",
    "Birdie",
    "Birgit",
    "Birgitta",
    "Blair",
    "Blaire",
    "Blake",
    "Blakelee",
    "Blakeley",
    "Blanca",
    "Blanch",
    "Blancha",
    "Blanche",
    "Blinni",
    "Blinnie",
    "Blinny",
    "Bliss",
    "Blisse",
    "Blithe",
    "Blondell",
    "Blondelle",
    "Blondie",
    "Blondy",
    "Blythe",
    "Bobbe",
    "Bobbee",
    "Bobbette",
    "Bobbi",
    "Bobbie",
    "Bobby",
    "Bobbye",
    "Bobette",
    "Bobina",
    "Bobine",
    "Bobinette",
    "Bonita",
    "Bonnee",
    "Bonni",
    "Bonnibelle",
    "Bonnie",
    "Bonny",
    "Brana",
    "Brandais",
    "Brande",
    "Brandea",
    "Brandi",
    "Brandice",
    "Brandie",
    "Brandise",
    "Brandy",
    "Breanne",
    "Brear",
    "Bree",
    "Breena",
    "Bren",
    "Brena",
    "Brenda",
    "Brenn",
    "Brenna",
    "Brett",
    "Bria",
    "Briana",
    "Brianna",
    "Brianne",
    "Bride",
    "Bridget",
    "Bridgette",
    "Bridie",
    "Brier",
    "Brietta",
    "Brigid",
    "Brigida",
    "Brigit",
    "Brigitta",
    "Brigitte",
    "Brina",
    "Briney",
    "Brinn",
    "Brinna",
    "Briny",
    "Brit",
    "Brita",
    "Britney",
    "Britni",
    "Britt",
    "Britta",
    "Brittan",
    "Brittaney",
    "Brittani",
    "Brittany",
    "Britte",
    "Britteny",
    "Brittne",
    "Brittney",
    "Brittni",
    "Brook",
    "Brooke",
    "Brooks",
    "Brunhilda",
    "Brunhilde",
    "Bryana",
    "Bryn",
    "Bryna",
    "Brynn",
    "Brynna",
    "Brynne",
    "Buffy",
    "Bunni",
    "Bunnie",
    "Bunny",
    "Cacilia",
    "Cacilie",
    "Cahra",
    "Cairistiona",
    "Caitlin",
    "Caitrin",
    "Cal",
    "Calida",
    "Calla",
    "Calley",
    "Calli",
    "Callida",
    "Callie",
    "Cally",
    "Calypso",
    "Cam",
    "Camala",
    "Camel",
    "Camella",
    "Camellia",
    "Cami",
    "Camila",
    "Camile",
    "Camilla",
    "Camille",
    "Cammi",
    "Cammie",
    "Cammy",
    "Candace",
    "Candi",
    "Candice",
    "Candida",
    "Candide",
    "Candie",
    "Candis",
    "Candra",
    "Candy",
    "Caprice",
    "Cara",
    "Caralie",
    "Caren",
    "Carena",
    "Caresa",
    "Caressa",
    "Caresse",
    "Carey",
    "Cari",
    "Caria",
    "Carie",
    "Caril",
    "Carilyn",
    "Carin",
    "Carina",
    "Carine",
    "Cariotta",
    "Carissa",
    "Carita",
    "Caritta",
    "Carla",
    "Carlee",
    "Carleen",
    "Carlen",
    "Carlene",
    "Carley",
    "Carlie",
    "Carlin",
    "Carlina",
    "Carline",
    "Carlita",
    "Carlota",
    "Carlotta",
    "Carly",
    "Carlye",
    "Carlyn",
    "Carlynn",
    "Carlynne",
    "Carma",
    "Carmel",
    "Carmela",
    "Carmelia",
    "Carmelina",
    "Carmelita",
    "Carmella",
    "Carmelle",
    "Carmen",
    "Carmencita",
    "Carmina",
    "Carmine",
    "Carmita",
    "Carmon",
    "Caro",
    "Carol",
    "Carol-jean",
    "Carola",
    "Carolan",
    "Carolann",
    "Carole",
    "Carolee",
    "Carolin",
    "Carolina",
    "Caroline",
    "Caroljean",
    "Carolyn",
    "Carolyne",
    "Carolynn",
    "Caron",
    "Carree",
    "Carri",
    "Carrie",
    "Carrissa",
    "Carroll",
    "Carry",
    "Cary",
    "Caryl",
    "Caryn",
    "Casandra",
    "Casey",
    "Casi",
    "Casie",
    "Cass",
    "Cassandra",
    "Cassandre",
    "Cassandry",
    "Cassaundra",
    "Cassey",
    "Cassi",
    "Cassie",
    "Cassondra",
    "Cassy",
    "Catarina",
    "Cate",
    "Caterina",
    "Catha",
    "Catharina",
    "Catharine",
    "Cathe",
    "Cathee",
    "Catherin",
    "Catherina",
    "Catherine",
    "Cathi",
    "Cathie",
    "Cathleen",
    "Cathlene",
    "Cathrin",
    "Cathrine",
    "Cathryn",
    "Cathy",
    "Cathyleen",
    "Cati",
    "Catie",
    "Catina",
    "Catlaina",
    "Catlee",
    "Catlin",
    "Catrina",
    "Catriona",
    "Caty",
    "Caye",
    "Cayla",
    "Cecelia",
    "Cecil",
    "Cecile",
    "Ceciley",
    "Cecilia",
    "Cecilla",
    "Cecily",
    "Ceil",
    "Cele",
    "Celene",
    "Celesta",
    "Celeste",
    "Celestia",
    "Celestina",
    "Celestine",
    "Celestyn",
    "Celestyna",
    "Celia",
    "Celie",
    "Celina",
    "Celinda",
    "Celine",
    "Celinka",
    "Celisse",
    "Celka",
    "Celle",
    "Cesya",
    "Chad",
    "Chanda",
    "Chandal",
    "Chandra",
    "Channa",
    "Chantal",
    "Chantalle",
    "Charil",
    "Charin",
    "Charis",
    "Charissa",
    "Charisse",
    "Charita",
    "Charity",
    "Charla",
    "Charlean",
    "Charleen",
    "Charlena",
    "Charlene",
    "Charline",
    "Charlot",
    "Charlotta",
    "Charlotte",
    "Charmain",
    "Charmaine",
    "Charmane",
    "Charmian",
    "Charmine",
    "Charmion",
    "Charo",
    "Charyl",
    "Chastity",
    "Chelsae",
    "Chelsea",
    "Chelsey",
    "Chelsie",
    "Chelsy",
    "Cher",
    "Chere",
    "Cherey",
    "Cheri",
    "Cherianne",
    "Cherice",
    "Cherida",
    "Cherie",
    "Cherilyn",
    "Cherilynn",
    "Cherin",
    "Cherise",
    "Cherish",
    "Cherlyn",
    "Cherri",
    "Cherrita",
    "Cherry",
    "Chery",
    "Cherye",
    "Cheryl",
    "Cheslie",
    "Chiarra",
    "Chickie",
    "Chicky",
    "Chiquia",
    "Chiquita",
    "Chlo",
    "Chloe",
    "Chloette",
    "Chloris",
    "Chris",
    "Chrissie",
    "Chrissy",
    "Christa",
    "Christabel",
    "Christabella",
    "Christal",
    "Christalle",
    "Christan",
    "Christean",
    "Christel",
    "Christen",
    "Christi",
    "Christian",
    "Christiana",
    "Christiane",
    "Christie",
    "Christin",
    "Christina",
    "Christine",
    "Christy",
    "Christye",
    "Christyna",
    "Chrysa",
    "Chrysler",
    "Chrystal",
    "Chryste",
    "Chrystel",
    "Cicely",
    "Cicily",
    "Ciel",
    "Cilka",
    "Cinda",
    "Cindee",
    "Cindelyn",
    "Cinderella",
    "Cindi",
    "Cindie",
    "Cindra",
    "Cindy",
    "Cinnamon",
    "Cissiee",
    "Cissy",
    "Clair",
    "Claire",
    "Clara",
    "Clarabelle",
    "Clare",
    "Claresta",
    "Clareta",
    "Claretta",
    "Clarette",
    "Clarey",
    "Clari",
    "Claribel",
    "Clarice",
    "Clarie",
    "Clarinda",
    "Clarine",
    "Clarissa",
    "Clarisse",
    "Clarita",
    "Clary",
    "Claude",
    "Claudelle",
    "Claudetta",
    "Claudette",
    "Claudia",
    "Claudie",
    "Claudina",
    "Claudine",
    "Clea",
    "Clem",
    "Clemence",
    "Clementia",
    "Clementina",
    "Clementine",
    "Clemmie",
    "Clemmy",
    "Cleo",
    "Cleopatra",
    "Clerissa",
    "Clio",
    "Clo",
    "Cloe",
    "Cloris",
    "Clotilda",
    "Clovis",
    "Codee",
    "Codi",
    "Codie",
    "Cody",
    "Coleen",
    "Colene",
    "Coletta",
    "Colette",
    "Colleen",
    "Collen",
    "Collete",
    "Collette",
    "Collie",
    "Colline",
    "Colly",
    "Con",
    "Concettina",
    "Conchita",
    "Concordia",
    "Conni",
    "Connie",
    "Conny",
    "Consolata",
    "Constance",
    "Constancia",
    "Constancy",
    "Constanta",
    "Constantia",
    "Constantina",
    "Constantine",
    "Consuela",
    "Consuelo",
    "Cookie",
    "Cora",
    "Corabel",
    "Corabella",
    "Corabelle",
    "Coral",
    "Coralie",
    "Coraline",
    "Coralyn",
    "Cordelia",
    "Cordelie",
    "Cordey",
    "Cordi",
    "Cordie",
    "Cordula",
    "Cordy",
    "Coreen",
    "Corella",
    "Corenda",
    "Corene",
    "Coretta",
    "Corette",
    "Corey",
    "Cori",
    "Corie",
    "Corilla",
    "Corina",
    "Corine",
    "Corinna",
    "Corinne",
    "Coriss",
    "Corissa",
    "Corliss",
    "Corly",
    "Cornela",
    "Cornelia",
    "Cornelle",
    "Cornie",
    "Corny",
    "Correna",
    "Correy",
    "Corri",
    "Corrianne",
    "Corrie",
    "Corrina",
    "Corrine",
    "Corrinne",
    "Corry",
    "Cortney",
    "Cory",
    "Cosetta",
    "Cosette",
    "Costanza",
    "Courtenay",
    "Courtnay",
    "Courtney",
    "Crin",
    "Cris",
    "Crissie",
    "Crissy",
    "Crista",
    "Cristabel",
    "Cristal",
    "Cristen",
    "Cristi",
    "Cristie",
    "Cristin",
    "Cristina",
    "Cristine",
    "Cristionna",
    "Cristy",
    "Crysta",
    "Crystal",
    "Crystie",
    "Cthrine",
    "Cyb",
    "Cybil",
    "Cybill",
    "Cymbre",
    "Cynde",
    "Cyndi",
    "Cyndia",
    "Cyndie",
    "Cyndy",
    "Cynthea",
    "Cynthia",
    "Cynthie",
    "Cynthy",
    "Dacey",
    "Dacia",
    "Dacie",
    "Dacy",
    "Dael",
    "Daffi",
    "Daffie",
    "Daffy",
    "Dagmar",
    "Dahlia",
    "Daile",
    "Daisey",
    "Daisi",
    "Daisie",
    "Daisy",
    "Dale",
    "Dalenna",
    "Dalia",
    "Dalila",
    "Dallas",
    "Daloris",
    "Damara",
    "Damaris",
    "Damita",
    "Dana",
    "Danell",
    "Danella",
    "Danette",
    "Dani",
    "Dania",
    "Danica",
    "Danice",
    "Daniela",
    "Daniele",
    "Daniella",
    "Danielle",
    "Danika",
    "Danila",
    "Danit",
    "Danita",
    "Danna",
    "Danni",
    "Dannie",
    "Danny",
    "Dannye",
    "Danya",
    "Danyelle",
    "Danyette",
    "Daphene",
    "Daphna",
    "Daphne",
    "Dara",
    "Darb",
    "Darbie",
    "Darby",
    "Darcee",
    "Darcey",
    "Darci",
    "Darcie",
    "Darcy",
    "Darda",
    "Dareen",
    "Darell",
    "Darelle",
    "Dari",
    "Daria",
    "Darice",
    "Darla",
    "Darleen",
    "Darlene",
    "Darline",
    "Darlleen",
    "Daron",
    "Darrelle",
    "Darryl",
    "Darsey",
    "Darsie",
    "Darya",
    "Daryl",
    "Daryn",
    "Dasha",
    "Dasi",
    "Dasie",
    "Dasya",
    "Datha",
    "Daune",
    "Daveen",
    "Daveta",
    "Davida",
    "Davina",
    "Davine",
    "Davita",
    "Dawn",
    "Dawna",
    "Dayle",
    "Dayna",
    "Ddene",
    "De",
    "Deana",
    "Deane",
    "Deanna",
    "Deanne",
    "Deb",
    "Debbi",
    "Debbie",
    "Debby",
    "Debee",
    "Debera",
    "Debi",
    "Debor",
    "Debora",
    "Deborah",
    "Debra",
    "Dede",
    "Dedie",
    "Dedra",
    "Dee",
    "Deeann",
    "Deeanne",
    "Deedee",
    "Deena",
    "Deerdre",
    "Deeyn",
    "Dehlia",
    "Deidre",
    "Deina",
    "Deirdre",
    "Del",
    "Dela",
    "Delcina",
    "Delcine",
    "Delia",
    "Delila",
    "Delilah",
    "Delinda",
    "Dell",
    "Della",
    "Delly",
    "Delora",
    "Delores",
    "Deloria",
    "Deloris",
    "Delphine",
    "Delphinia",
    "Demeter",
    "Demetra",
    "Demetria",
    "Demetris",
    "Dena",
    "Deni",
    "Denice",
    "Denise",
    "Denna",
    "Denni",
    "Dennie",
    "Denny",
    "Deny",
    "Denys",
    "Denyse",
    "Deonne",
    "Desdemona",
    "Desirae",
    "Desiree",
    "Desiri",
    "Deva",
    "Devan",
    "Devi",
    "Devin",
    "Devina",
    "Devinne",
    "Devon",
    "Devondra",
    "Devonna",
    "Devonne",
    "Devora",
    "Di",
    "Diahann",
    "Dian",
    "Diana",
    "Diandra",
    "Diane",
    "Diane-marie",
    "Dianemarie",
    "Diann",
    "Dianna",
    "Dianne",
    "Diannne",
    "Didi",
    "Dido",
    "Diena",
    "Dierdre",
    "Dina",
    "Dinah",
    "Dinnie",
    "Dinny",
    "Dion",
    "Dione",
    "Dionis",
    "Dionne",
    "Dita",
    "Dix",
    "Dixie",
    "Dniren",
    "Dode",
    "Dodi",
    "Dodie",
    "Dody",
    "Doe",
    "Doll",
    "Dolley",
    "Dolli",
    "Dollie",
    "Dolly",
    "Dolores",
    "Dolorita",
    "Doloritas",
    "Domeniga",
    "Dominga",
    "Domini",
    "Dominica",
    "Dominique",
    "Dona",
    "Donella",
    "Donelle",
    "Donetta",
    "Donia",
    "Donica",
    "Donielle",
    "Donna",
    "Donnamarie",
    "Donni",
    "Donnie",
    "Donny",
    "Dora",
    "Doralia",
    "Doralin",
    "Doralyn",
    "Doralynn",
    "Doralynne",
    "Dore",
    "Doreen",
    "Dorelia",
    "Dorella",
    "Dorelle",
    "Dorena",
    "Dorene",
    "Doretta",
    "Dorette",
    "Dorey",
    "Dori",
    "Doria",
    "Dorian",
    "Dorice",
    "Dorie",
    "Dorine",
    "Doris",
    "Dorisa",
    "Dorise",
    "Dorita",
    "Doro",
    "Dorolice",
    "Dorolisa",
    "Dorotea",
    "Doroteya",
    "Dorothea",
    "Dorothee",
    "Dorothy",
    "Dorree",
    "Dorri",
    "Dorrie",
    "Dorris",
    "Dorry",
    "Dorthea",
    "Dorthy",
    "Dory",
    "Dosi",
    "Dot",
    "Doti",
    "Dotti",
    "Dottie",
    "Dotty",
    "Dre",
    "Dreddy",
    "Dredi",
    "Drona",
    "Dru",
    "Druci",
    "Drucie",
    "Drucill",
    "Drucy",
    "Drusi",
    "Drusie",
    "Drusilla",
    "Drusy",
    "Dulce",
    "Dulcea",
    "Dulci",
    "Dulcia",
    "Dulciana",
    "Dulcie",
    "Dulcine",
    "Dulcinea",
    "Dulcy",
    "Dulsea",
    "Dusty",
    "Dyan",
    "Dyana",
    "Dyane",
    "Dyann",
    "Dyanna",
    "Dyanne",
    "Dyna",
    "Dynah",
    "Eachelle",
    "Eada",
    "Eadie",
    "Eadith",
    "Ealasaid",
    "Eartha",
    "Easter",
    "Eba",
    "Ebba",
    "Ebonee",
    "Ebony",
    "Eda",
    "Eddi",
    "Eddie",
    "Eddy",
    "Ede",
    "Edee",
    "Edeline",
    "Eden",
    "Edi",
    "Edie",
    "Edin",
    "Edita",
    "Edith",
    "Editha",
    "Edithe",
    "Ediva",
    "Edna",
    "Edwina",
    "Edy",
    "Edyth",
    "Edythe",
    "Effie",
    "Eileen",
    "Eilis",
    "Eimile",
    "Eirena",
    "Ekaterina",
    "Elaina",
    "Elaine",
    "Elana",
    "Elane",
    "Elayne",
    "Elberta",
    "Elbertina",
    "Elbertine",
    "Eleanor",
    "Eleanora",
    "Eleanore",
    "Electra",
    "Eleen",
    "Elena",
    "Elene",
    "Eleni",
    "Elenore",
    "Eleonora",
    "Eleonore",
    "Elfie",
    "Elfreda",
    "Elfrida",
    "Elfrieda",
    "Elga",
    "Elianora",
    "Elianore",
    "Elicia",
    "Elie",
    "Elinor",
    "Elinore",
    "Elisa",
    "Elisabet",
    "Elisabeth",
    "Elisabetta",
    "Elise",
    "Elisha",
    "Elissa",
    "Elita",
    "Eliza",
    "Elizabet",
    "Elizabeth",
    "Elka",
    "Elke",
    "Ella",
    "Elladine",
    "Elle",
    "Ellen",
    "Ellene",
    "Ellette",
    "Elli",
    "Ellie",
    "Ellissa",
    "Elly",
    "Ellyn",
    "Ellynn",
    "Elmira",
    "Elna",
    "Elnora",
    "Elnore",
    "Eloisa",
    "Eloise",
    "Elonore",
    "Elora",
    "Elsa",
    "Elsbeth",
    "Else",
    "Elset",
    "Elsey",
    "Elsi",
    "Elsie",
    "Elsinore",
    "Elspeth",
    "Elsy",
    "Elva",
    "Elvera",
    "Elvina",
    "Elvira",
    "Elwira",
    "Elyn",
    "Elyse",
    "Elysee",
    "Elysha",
    "Elysia",
    "Elyssa",
    "Em",
    "Ema",
    "Emalee",
    "Emalia",
    "Emelda",
    "Emelia",
    "Emelina",
    "Emeline",
    "Emelita",
    "Emelyne",
    "Emera",
    "Emilee",
    "Emili",
    "Emilia",
    "Emilie",
    "Emiline",
    "Emily",
    "Emlyn",
    "Emlynn",
    "Emlynne",
    "Emma",
    "Emmalee",
    "Emmaline",
    "Emmalyn",
    "Emmalynn",
    "Emmalynne",
    "Emmeline",
    "Emmey",
    "Emmi",
    "Emmie",
    "Emmy",
    "Emmye",
    "Emogene",
    "Emyle",
    "Emylee",
    "Engracia",
    "Enid",
    "Enrica",
    "Enrichetta",
    "Enrika",
    "Enriqueta",
    "Eolanda",
    "Eolande",
    "Eran",
    "Erda",
    "Erena",
    "Erica",
    "Ericha",
    "Ericka",
    "Erika",
    "Erin",
    "Erina",
    "Erinn",
    "Erinna",
    "Erma",
    "Ermengarde",
    "Ermentrude",
    "Ermina",
    "Erminia",
    "Erminie",
    "Erna",
    "Ernaline",
    "Ernesta",
    "Ernestine",
    "Ertha",
    "Eryn",
    "Esma",
    "Esmaria",
    "Esme",
    "Esmeralda",
    "Essa",
    "Essie",
    "Essy",
    "Esta",
    "Estel",
    "Estele",
    "Estell",
    "Estella",
    "Estelle",
    "Ester",
    "Esther",
    "Estrella",
    "Estrellita",
    "Ethel",
    "Ethelda",
    "Ethelin",
    "Ethelind",
    "Etheline",
    "Ethelyn",
    "Ethyl",
    "Etta",
    "Etti",
    "Ettie",
    "Etty",
    "Eudora",
    "Eugenia",
    "Eugenie",
    "Eugine",
    "Eula",
    "Eulalie",
    "Eunice",
    "Euphemia",
    "Eustacia",
    "Eva",
    "Evaleen",
    "Evangelia",
    "Evangelin",
    "Evangelina",
    "Evangeline",
    "Evania",
    "Evanne",
    "Eve",
    "Eveleen",
    "Evelina",
    "Eveline",
    "Evelyn",
    "Evey",
    "Evie",
    "Evita",
    "Evonne",
    "Evvie",
    "Evvy",
    "Evy",
    "Eyde",
    "Eydie",
    "Ezmeralda",
    "Fae",
    "Faina",
    "Faith",
    "Fallon",
    "Fan",
    "Fanchette",
    "Fanchon",
    "Fancie",
    "Fancy",
    "Fanechka",
    "Fania",
    "Fanni",
    "Fannie",
    "Fanny",
    "Fanya",
    "Fara",
    "Farah",
    "Farand",
    "Farica",
    "Farra",
    "Farrah",
    "Farrand",
    "Faun",
    "Faunie",
    "Faustina",
    "Faustine",
    "Fawn",
    "Fawne",
    "Fawnia",
    "Fay",
    "Faydra",
    "Faye",
    "Fayette",
    "Fayina",
    "Fayre",
    "Fayth",
    "Faythe",
    "Federica",
    "Fedora",
    "Felecia",
    "Felicdad",
    "Felice",
    "Felicia",
    "Felicity",
    "Felicle",
    "Felipa",
    "Felisha",
    "Felita",
    "Feliza",
    "Fenelia",
    "Feodora",
    "Ferdinanda",
    "Ferdinande",
    "Fern",
    "Fernanda",
    "Fernande",
    "Fernandina",
    "Ferne",
    "Fey",
    "Fiann",
    "Fianna",
    "Fidela",
    "Fidelia",
    "Fidelity",
    "Fifi",
    "Fifine",
    "Filia",
    "Filide",
    "Filippa",
    "Fina",
    "Fiona",
    "Fionna",
    "Fionnula",
    "Fiorenze",
    "Fleur",
    "Fleurette",
    "Flo",
    "Flor",
    "Flora",
    "Florance",
    "Flore",
    "Florella",
    "Florence",
    "Florencia",
    "Florentia",
    "Florenza",
    "Florette",
    "Flori",
    "Floria",
    "Florida",
    "Florie",
    "Florina",
    "Florinda",
    "Floris",
    "Florri",
    "Florrie",
    "Florry",
    "Flory",
    "Flossi",
    "Flossie",
    "Flossy",
    "Flss",
    "Fran",
    "Francene",
    "Frances",
    "Francesca",
    "Francine",
    "Francisca",
    "Franciska",
    "Francoise",
    "Francyne",
    "Frank",
    "Frankie",
    "Franky",
    "Franni",
    "Frannie",
    "Franny",
    "Frayda",
    "Fred",
    "Freda",
    "Freddi",
    "Freddie",
    "Freddy",
    "Fredelia",
    "Frederica",
    "Fredericka",
    "Frederique",
    "Fredi",
    "Fredia",
    "Fredra",
    "Fredrika",
    "Freida",
    "Frieda",
    "Friederike",
    "Fulvia",
    "Gabbey",
    "Gabbi",
    "Gabbie",
    "Gabey",
    "Gabi",
    "Gabie",
    "Gabriel",
    "Gabriela",
    "Gabriell",
    "Gabriella",
    "Gabrielle",
    "Gabriellia",
    "Gabrila",
    "Gaby",
    "Gae",
    "Gael",
    "Gail",
    "Gale",
    "Galina",
    "Garland",
    "Garnet",
    "Garnette",
    "Gates",
    "Gavra",
    "Gavrielle",
    "Gay",
    "Gaye",
    "Gayel",
    "Gayla",
    "Gayle",
    "Gayleen",
    "Gaylene",
    "Gaynor",
    "Gelya",
    "Gena",
    "Gene",
    "Geneva",
    "Genevieve",
    "Genevra",
    "Genia",
    "Genna",
    "Genni",
    "Gennie",
    "Gennifer",
    "Genny",
    "Genovera",
    "Genvieve",
    "George",
    "Georgeanna",
    "Georgeanne",
    "Georgena",
    "Georgeta",
    "Georgetta",
    "Georgette",
    "Georgia",
    "Georgiana",
    "Georgianna",
    "Georgianne",
    "Georgie",
    "Georgina",
    "Georgine",
    "Geralda",
    "Geraldine",
    "Gerda",
    "Gerhardine",
    "Geri",
    "Gerianna",
    "Gerianne",
    "Gerladina",
    "Germain",
    "Germaine",
    "Germana",
    "Gerri",
    "Gerrie",
    "Gerrilee",
    "Gerry",
    "Gert",
    "Gerta",
    "Gerti",
    "Gertie",
    "Gertrud",
    "Gertruda",
    "Gertrude",
    "Gertrudis",
    "Gerty",
    "Giacinta",
    "Giana",
    "Gianina",
    "Gianna",
    "Gigi",
    "Gilberta",
    "Gilberte",
    "Gilbertina",
    "Gilbertine",
    "Gilda",
    "Gilemette",
    "Gill",
    "Gillan",
    "Gilli",
    "Gillian",
    "Gillie",
    "Gilligan",
    "Gilly",
    "Gina",
    "Ginelle",
    "Ginevra",
    "Ginger",
    "Ginni",
    "Ginnie",
    "Ginnifer",
    "Ginny",
    "Giorgia",
    "Giovanna",
    "Gipsy",
    "Giralda",
    "Gisela",
    "Gisele",
    "Gisella",
    "Giselle",
    "Giuditta",
    "Giulia",
    "Giulietta",
    "Giustina",
    "Gizela",
    "Glad",
    "Gladi",
    "Gladys",
    "Gleda",
    "Glen",
    "Glenda",
    "Glenine",
    "Glenn",
    "Glenna",
    "Glennie",
    "Glennis",
    "Glori",
    "Gloria",
    "Gloriana",
    "Gloriane",
    "Glory",
    "Glyn",
    "Glynda",
    "Glynis",
    "Glynnis",
    "Gnni",
    "Godiva",
    "Golda",
    "Goldarina",
    "Goldi",
    "Goldia",
    "Goldie",
    "Goldina",
    "Goldy",
    "Grace",
    "Gracia",
    "Gracie",
    "Grata",
    "Gratia",
    "Gratiana",
    "Gray",
    "Grayce",
    "Grazia",
    "Greer",
    "Greta",
    "Gretal",
    "Gretchen",
    "Grete",
    "Gretel",
    "Grethel",
    "Gretna",
    "Gretta",
    "Grier",
    "Griselda",
    "Grissel",
    "Guendolen",
    "Guenevere",
    "Guenna",
    "Guglielma",
    "Gui",
    "Guillema",
    "Guillemette",
    "Guinevere",
    "Guinna",
    "Gunilla",
    "Gus",
    "Gusella",
    "Gussi",
    "Gussie",
    "Gussy",
    "Gusta",
    "Gusti",
    "Gustie",
    "Gusty",
    "Gwen",
    "Gwendolen",
    "Gwendolin",
    "Gwendolyn",
    "Gweneth",
    "Gwenette",
    "Gwenneth",
    "Gwenni",
    "Gwennie",
    "Gwenny",
    "Gwenora",
    "Gwenore",
    "Gwyn",
    "Gwyneth",
    "Gwynne",
    "Gypsy",
    "Hadria",
    "Hailee",
    "Haily",
    "Haleigh",
    "Halette",
    "Haley",
    "Hali",
    "Halie",
    "Halimeda",
    "Halley",
    "Halli",
    "Hallie",
    "Hally",
    "Hana",
    "Hanna",
    "Hannah",
    "Hanni",
    "Hannie",
    "Hannis",
    "Hanny",
    "Happy",
    "Harlene",
    "Harley",
    "Harli",
    "Harlie",
    "Harmonia",
    "Harmonie",
    "Harmony",
    "Harri",
    "Harrie",
    "Harriet",
    "Harriett",
    "Harrietta",
    "Harriette",
    "Harriot",
    "Harriott",
    "Hatti",
    "Hattie",
    "Hatty",
    "Hayley",
    "Hazel",
    "Heath",
    "Heather",
    "Heda",
    "Hedda",
    "Heddi",
    "Heddie",
    "Hedi",
    "Hedvig",
    "Hedvige",
    "Hedwig",
    "Hedwiga",
    "Hedy",
    "Heida",
    "Heidi",
    "Heidie",
    "Helaina",
    "Helaine",
    "Helen",
    "Helen-elizabeth",
    "Helena",
    "Helene",
    "Helenka",
    "Helga",
    "Helge",
    "Helli",
    "Heloise",
    "Helsa",
    "Helyn",
    "Hendrika",
    "Henka",
    "Henrie",
    "Henrieta",
    "Henrietta",
    "Henriette",
    "Henryetta",
    "Hephzibah",
    "Hermia",
    "Hermina",
    "Hermine",
    "Herminia",
    "Hermione",
    "Herta",
    "Hertha",
    "Hester",
    "Hesther",
    "Hestia",
    "Hetti",
    "Hettie",
    "Hetty",
    "Hilary",
    "Hilda",
    "Hildagard",
    "Hildagarde",
    "Hilde",
    "Hildegaard",
    "Hildegarde",
    "Hildy",
    "Hillary",
    "Hilliary",
    "Hinda",
    "Holli",
    "Hollie",
    "Holly",
    "Holly-anne",
    "Hollyanne",
    "Honey",
    "Honor",
    "Honoria",
    "Hope",
    "Horatia",
    "Hortense",
    "Hortensia",
    "Hulda",
    "Hyacinth",
    "Hyacintha",
    "Hyacinthe",
    "Hyacinthia",
    "Hyacinthie",
    "Hynda",
    "Ianthe",
    "Ibbie",
    "Ibby",
    "Ida",
    "Idalia",
    "Idalina",
    "Idaline",
    "Idell",
    "Idelle",
    "Idette",
    "Ileana",
    "Ileane",
    "Ilene",
    "Ilise",
    "Ilka",
    "Illa",
    "Ilsa",
    "Ilse",
    "Ilysa",
    "Ilyse",
    "Ilyssa",
    "Imelda",
    "Imogen",
    "Imogene",
    "Imojean",
    "Ina",
    "Indira",
    "Ines",
    "Inesita",
    "Inessa",
    "Inez",
    "Inga",
    "Ingaberg",
    "Ingaborg",
    "Inge",
    "Ingeberg",
    "Ingeborg",
    "Inger",
    "Ingrid",
    "Ingunna",
    "Inna",
    "Iolande",
    "Iolanthe",
    "Iona",
    "Iormina",
    "Ira",
    "Irena",
    "Irene",
    "Irina",
    "Iris",
    "Irita",
    "Irma",
    "Isa",
    "Isabel",
    "Isabelita",
    "Isabella",
    "Isabelle",
    "Isadora",
    "Isahella",
    "Iseabal",
    "Isidora",
    "Isis",
    "Isobel",
    "Issi",
    "Issie",
    "Issy",
    "Ivett",
    "Ivette",
    "Ivie",
    "Ivonne",
    "Ivory",
    "Ivy",
    "Izabel",
    "Jacenta",
    "Jacinda",
    "Jacinta",
    "Jacintha",
    "Jacinthe",
    "Jackelyn",
    "Jacki",
    "Jackie",
    "Jacklin",
    "Jacklyn",
    "Jackquelin",
    "Jackqueline",
    "Jacky",
    "Jaclin",
    "Jaclyn",
    "Jacquelin",
    "Jacqueline",
    "Jacquelyn",
    "Jacquelynn",
    "Jacquenetta",
    "Jacquenette",
    "Jacquetta",
    "Jacquette",
    "Jacqui",
    "Jacquie",
    "Jacynth",
    "Jada",
    "Jade",
    "Jaime",
    "Jaimie",
    "Jaine",
    "Jami",
    "Jamie",
    "Jamima",
    "Jammie",
    "Jan",
    "Jana",
    "Janaya",
    "Janaye",
    "Jandy",
    "Jane",
    "Janean",
    "Janeczka",
    "Janeen",
    "Janel",
    "Janela",
    "Janella",
    "Janelle",
    "Janene",
    "Janenna",
    "Janessa",
    "Janet",
    "Janeta",
    "Janetta",
    "Janette",
    "Janeva",
    "Janey",
    "Jania",
    "Janice",
    "Janie",
    "Janifer",
    "Janina",
    "Janine",
    "Janis",
    "Janith",
    "Janka",
    "Janna",
    "Jannel",
    "Jannelle",
    "Janot",
    "Jany",
    "Jaquelin",
    "Jaquelyn",
    "Jaquenetta",
    "Jaquenette",
    "Jaquith",
    "Jasmin",
    "Jasmina",
    "Jasmine",
    "Jayme",
    "Jaymee",
    "Jayne",
    "Jaynell",
    "Jazmin",
    "Jean",
    "Jeana",
    "Jeane",
    "Jeanelle",
    "Jeanette",
    "Jeanie",
    "Jeanine",
    "Jeanna",
    "Jeanne",
    "Jeannette",
    "Jeannie",
    "Jeannine",
    "Jehanna",
    "Jelene",
    "Jemie",
    "Jemima",
    "Jemimah",
    "Jemmie",
    "Jemmy",
    "Jen",
    "Jena",
    "Jenda",
    "Jenelle",
    "Jeni",
    "Jenica",
    "Jeniece",
    "Jenifer",
    "Jeniffer",
    "Jenilee",
    "Jenine",
    "Jenn",
    "Jenna",
    "Jennee",
    "Jennette",
    "Jenni",
    "Jennica",
    "Jennie",
    "Jennifer",
    "Jennilee",
    "Jennine",
    "Jenny",
    "Jeralee",
    "Jere",
    "Jeri",
    "Jermaine",
    "Jerrie",
    "Jerrilee",
    "Jerrilyn",
    "Jerrine",
    "Jerry",
    "Jerrylee",
    "Jess",
    "Jessa",
    "Jessalin",
    "Jessalyn",
    "Jessamine",
    "Jessamyn",
    "Jesse",
    "Jesselyn",
    "Jessi",
    "Jessica",
    "Jessie",
    "Jessika",
    "Jessy",
    "Jewel",
    "Jewell",
    "Jewelle",
    "Jill",
    "Jillana",
    "Jillane",
    "Jillayne",
    "Jilleen",
    "Jillene",
    "Jilli",
    "Jillian",
    "Jillie",
    "Jilly",
    "Jinny",
    "Jo",
    "Jo-ann",
    "Jo-anne",
    "Joan",
    "Joana",
    "Joane",
    "Joanie",
    "Joann",
    "Joanna",
    "Joanne",
    "Joannes",
    "Jobey",
    "Jobi",
    "Jobie",
    "Jobina",
    "Joby",
    "Jobye",
    "Jobyna",
    "Jocelin",
    "Joceline",
    "Jocelyn",
    "Jocelyne",
    "Jodee",
    "Jodi",
    "Jodie",
    "Jody",
    "Joeann",
    "Joela",
    "Joelie",
    "Joell",
    "Joella",
    "Joelle",
    "Joellen",
    "Joelly",
    "Joellyn",
    "Joelynn",
    "Joete",
    "Joey",
    "Johanna",
    "Johannah",
    "Johna",
    "Johnath",
    "Johnette",
    "Johnna",
    "Joice",
    "Jojo",
    "Jolee",
    "Joleen",
    "Jolene",
    "Joletta",
    "Joli",
    "Jolie",
    "Joline",
    "Joly",
    "Jolyn",
    "Jolynn",
    "Jonell",
    "Joni",
    "Jonie",
    "Jonis",
    "Jordain",
    "Jordan",
    "Jordana",
    "Jordanna",
    "Jorey",
    "Jori",
    "Jorie",
    "Jorrie",
    "Jorry",
    "Joscelin",
    "Josee",
    "Josefa",
    "Josefina",
    "Josepha",
    "Josephina",
    "Josephine",
    "Josey",
    "Josi",
    "Josie",
    "Josselyn",
    "Josy",
    "Jourdan",
    "Joy",
    "Joya",
    "Joyan",
    "Joyann",
    "Joyce",
    "Joycelin",
    "Joye",
    "Jsandye",
    "Juana",
    "Juanita",
    "Judi",
    "Judie",
    "Judith",
    "Juditha",
    "Judy",
    "Judye",
    "Juieta",
    "Julee",
    "Juli",
    "Julia",
    "Juliana",
    "Juliane",
    "Juliann",
    "Julianna",
    "Julianne",
    "Julie",
    "Julienne",
    "Juliet",
    "Julieta",
    "Julietta",
    "Juliette",
    "Julina",
    "Juline",
    "Julissa",
    "Julita",
    "June",
    "Junette",
    "Junia",
    "Junie",
    "Junina",
    "Justina",
    "Justine",
    "Justinn",
    "Jyoti",
    "Kacey",
    "Kacie",
    "Kacy",
    "Kaela",
    "Kai",
    "Kaia",
    "Kaila",
    "Kaile",
    "Kailey",
    "Kaitlin",
    "Kaitlyn",
    "Kaitlynn",
    "Kaja",
    "Kakalina",
    "Kala",
    "Kaleena",
    "Kali",
    "Kalie",
    "Kalila",
    "Kalina",
    "Kalinda",
    "Kalindi",
    "Kalli",
    "Kally",
    "Kameko",
    "Kamila",
    "Kamilah",
    "Kamillah",
    "Kandace",
    "Kandy",
    "Kania",
    "Kanya",
    "Kara",
    "Kara-lynn",
    "Karalee",
    "Karalynn",
    "Kare",
    "Karee",
    "Karel",
    "Karen",
    "Karena",
    "Kari",
    "Karia",
    "Karie",
    "Karil",
    "Karilynn",
    "Karin",
    "Karina",
    "Karine",
    "Kariotta",
    "Karisa",
    "Karissa",
    "Karita",
    "Karla",
    "Karlee",
    "Karleen",
    "Karlen",
    "Karlene",
    "Karlie",
    "Karlotta",
    "Karlotte",
    "Karly",
    "Karlyn",
    "Karmen",
    "Karna",
    "Karol",
    "Karola",
    "Karole",
    "Karolina",
    "Karoline",
    "Karoly",
    "Karon",
    "Karrah",
    "Karrie",
    "Karry",
    "Kary",
    "Karyl",
    "Karylin",
    "Karyn",
    "Kasey",
    "Kass",
    "Kassandra",
    "Kassey",
    "Kassi",
    "Kassia",
    "Kassie",
    "Kat",
    "Kata",
    "Katalin",
    "Kate",
    "Katee",
    "Katerina",
    "Katerine",
    "Katey",
    "Kath",
    "Katha",
    "Katharina",
    "Katharine",
    "Katharyn",
    "Kathe",
    "Katherina",
    "Katherine",
    "Katheryn",
    "Kathi",
    "Kathie",
    "Kathleen",
    "Kathlin",
    "Kathrine",
    "Kathryn",
    "Kathryne",
    "Kathy",
    "Kathye",
    "Kati",
    "Katie",
    "Katina",
    "Katine",
    "Katinka",
    "Katleen",
    "Katlin",
    "Katrina",
    "Katrine",
    "Katrinka",
    "Katti",
    "Kattie",
    "Katuscha",
    "Katusha",
    "Katy",
    "Katya",
    "Kay",
    "Kaycee",
    "Kaye",
    "Kayla",
    "Kayle",
    "Kaylee",
    "Kayley",
    "Kaylil",
    "Kaylyn",
    "Keeley",
    "Keelia",
    "Keely",
    "Kelcey",
    "Kelci",
    "Kelcie",
    "Kelcy",
    "Kelila",
    "Kellen",
    "Kelley",
    "Kelli",
    "Kellia",
    "Kellie",
    "Kellina",
    "Kellsie",
    "Kelly",
    "Kellyann",
    "Kelsey",
    "Kelsi",
    "Kelsy",
    "Kendra",
    "Kendre",
    "Kenna",
    "Keri",
    "Keriann",
    "Kerianne",
    "Kerri",
    "Kerrie",
    "Kerrill",
    "Kerrin",
    "Kerry",
    "Kerstin",
    "Kesley",
    "Keslie",
    "Kessia",
    "Kessiah",
    "Ketti",
    "Kettie",
    "Ketty",
    "Kevina",
    "Kevyn",
    "Ki",
    "Kiah",
    "Kial",
    "Kiele",
    "Kiersten",
    "Kikelia",
    "Kiley",
    "Kim",
    "Kimberlee",
    "Kimberley",
    "Kimberli",
    "Kimberly",
    "Kimberlyn",
    "Kimbra",
    "Kimmi",
    "Kimmie",
    "Kimmy",
    "Kinna",
    "Kip",
    "Kipp",
    "Kippie",
    "Kippy",
    "Kira",
    "Kirbee",
    "Kirbie",
    "Kirby",
    "Kiri",
    "Kirsten",
    "Kirsteni",
    "Kirsti",
    "Kirstin",
    "Kirstyn",
    "Kissee",
    "Kissiah",
    "Kissie",
    "Kit",
    "Kitti",
    "Kittie",
    "Kitty",
    "Kizzee",
    "Kizzie",
    "Klara",
    "Klarika",
    "Klarrisa",
    "Konstance",
    "Konstanze",
    "Koo",
    "Kora",
    "Koral",
    "Koralle",
    "Kordula",
    "Kore",
    "Korella",
    "Koren",
    "Koressa",
    "Kori",
    "Korie",
    "Korney",
    "Korrie",
    "Korry",
    "Kris",
    "Krissie",
    "Krissy",
    "Krista",
    "Kristal",
    "Kristan",
    "Kriste",
    "Kristel",
    "Kristen",
    "Kristi",
    "Kristien",
    "Kristin",
    "Kristina",
    "Kristine",
    "Kristy",
    "Kristyn",
    "Krysta",
    "Krystal",
    "Krystalle",
    "Krystle",
    "Krystyna",
    "Kyla",
    "Kyle",
    "Kylen",
    "Kylie",
    "Kylila",
    "Kylynn",
    "Kym",
    "Kynthia",
    "Kyrstin",
    "Lacee",
    "Lacey",
    "Lacie",
    "Lacy",
    "Ladonna",
    "Laetitia",
    "Laina",
    "Lainey",
    "Lana",
    "Lanae",
    "Lane",
    "Lanette",
    "Laney",
    "Lani",
    "Lanie",
    "Lanita",
    "Lanna",
    "Lanni",
    "Lanny",
    "Lara",
    "Laraine",
    "Lari",
    "Larina",
    "Larine",
    "Larisa",
    "Larissa",
    "Lark",
    "Laryssa",
    "Latashia",
    "Latia",
    "Latisha",
    "Latrena",
    "Latrina",
    "Laura",
    "Lauraine",
    "Laural",
    "Lauralee",
    "Laure",
    "Lauree",
    "Laureen",
    "Laurel",
    "Laurella",
    "Lauren",
    "Laurena",
    "Laurene",
    "Lauretta",
    "Laurette",
    "Lauri",
    "Laurianne",
    "Laurice",
    "Laurie",
    "Lauryn",
    "Lavena",
    "Laverna",
    "Laverne",
    "Lavina",
    "Lavinia",
    "Lavinie",
    "Layla",
    "Layne",
    "Layney",
    "Lea",
    "Leah",
    "Leandra",
    "Leann",
    "Leanna",
    "Leanor",
    "Leanora",
    "Lebbie",
    "Leda",
    "Lee",
    "Leeann",
    "Leeanne",
    "Leela",
    "Leelah",
    "Leena",
    "Leesa",
    "Leese",
    "Legra",
    "Leia",
    "Leigh",
    "Leigha",
    "Leila",
    "Leilah",
    "Leisha",
    "Lela",
    "Lelah",
    "Leland",
    "Lelia",
    "Lena",
    "Lenee",
    "Lenette",
    "Lenka",
    "Lenna",
    "Lenora",
    "Lenore",
    "Leodora",
    "Leoine",
    "Leola",
    "Leoline",
    "Leona",
    "Leonanie",
    "Leone",
    "Leonelle",
    "Leonie",
    "Leonora",
    "Leonore",
    "Leontine",
    "Leontyne",
    "Leora",
    "Leshia",
    "Lesley",
    "Lesli",
    "Leslie",
    "Lesly",
    "Lesya",
    "Leta",
    "Lethia",
    "Leticia",
    "Letisha",
    "Letitia",
    "Letizia",
    "Letta",
    "Letti",
    "Lettie",
    "Letty",
    "Lexi",
    "Lexie",
    "Lexine",
    "Lexis",
    "Lexy",
    "Leyla",
    "Lezlie",
    "Lia",
    "Lian",
    "Liana",
    "Liane",
    "Lianna",
    "Lianne",
    "Lib",
    "Libbey",
    "Libbi",
    "Libbie",
    "Libby",
    "Licha",
    "Lida",
    "Lidia",
    "Liesa",
    "Lil",
    "Lila",
    "Lilah",
    "Lilas",
    "Lilia",
    "Lilian",
    "Liliane",
    "Lilias",
    "Lilith",
    "Lilla",
    "Lilli",
    "Lillian",
    "Lillis",
    "Lilllie",
    "Lilly",
    "Lily",
    "Lilyan",
    "Lin",
    "Lina",
    "Lind",
    "Linda",
    "Lindi",
    "Lindie",
    "Lindsay",
    "Lindsey",
    "Lindsy",
    "Lindy",
    "Linea",
    "Linell",
    "Linet",
    "Linette",
    "Linn",
    "Linnea",
    "Linnell",
    "Linnet",
    "Linnie",
    "Linzy",
    "Lira",
    "Lisa",
    "Lisabeth",
    "Lisbeth",
    "Lise",
    "Lisetta",
    "Lisette",
    "Lisha",
    "Lishe",
    "Lissa",
    "Lissi",
    "Lissie",
    "Lissy",
    "Lita",
    "Liuka",
    "Liv",
    "Liva",
    "Livia",
    "Livvie",
    "Livvy",
    "Livvyy",
    "Livy",
    "Liz",
    "Liza",
    "Lizabeth",
    "Lizbeth",
    "Lizette",
    "Lizzie",
    "Lizzy",
    "Loella",
    "Lois",
    "Loise",
    "Lola",
    "Loleta",
    "Lolita",
    "Lolly",
    "Lona",
    "Lonee",
    "Loni",
    "Lonna",
    "Lonni",
    "Lonnie",
    "Lora",
    "Lorain",
    "Loraine",
    "Loralee",
    "Loralie",
    "Loralyn",
    "Loree",
    "Loreen",
    "Lorelei",
    "Lorelle",
    "Loren",
    "Lorena",
    "Lorene",
    "Lorenza",
    "Loretta",
    "Lorette",
    "Lori",
    "Loria",
    "Lorianna",
    "Lorianne",
    "Lorie",
    "Lorilee",
    "Lorilyn",
    "Lorinda",
    "Lorine",
    "Lorita",
    "Lorna",
    "Lorne",
    "Lorraine",
    "Lorrayne",
    "Lorri",
    "Lorrie",
    "Lorrin",
    "Lorry",
    "Lory",
    "Lotta",
    "Lotte",
    "Lotti",
    "Lottie",
    "Lotty",
    "Lou",
    "Louella",
    "Louisa",
    "Louise",
    "Louisette",
    "Loutitia",
    "Lu",
    "Luce",
    "Luci",
    "Lucia",
    "Luciana",
    "Lucie",
    "Lucienne",
    "Lucila",
    "Lucilia",
    "Lucille",
    "Lucina",
    "Lucinda",
    "Lucine",
    "Lucita",
    "Lucky",
    "Lucretia",
    "Lucy",
    "Ludovika",
    "Luella",
    "Luelle",
    "Luisa",
    "Luise",
    "Lula",
    "Lulita",
    "Lulu",
    "Lura",
    "Lurette",
    "Lurleen",
    "Lurlene",
    "Lurline",
    "Lusa",
    "Luz",
    "Lyda",
    "Lydia",
    "Lydie",
    "Lyn",
    "Lynda",
    "Lynde",
    "Lyndel",
    "Lyndell",
    "Lyndsay",
    "Lyndsey",
    "Lyndsie",
    "Lyndy",
    "Lynea",
    "Lynelle",
    "Lynett",
    "Lynette",
    "Lynn",
    "Lynna",
    "Lynne",
    "Lynnea",
    "Lynnell",
    "Lynnelle",
    "Lynnet",
    "Lynnett",
    "Lynnette",
    "Lynsey",
    "Lyssa",
    "Mab",
    "Mabel",
    "Mabelle",
    "Mable",
    "Mada",
    "Madalena",
    "Madalyn",
    "Maddalena",
    "Maddi",
    "Maddie",
    "Maddy",
    "Madel",
    "Madelaine",
    "Madeleine",
    "Madelena",
    "Madelene",
    "Madelin",
    "Madelina",
    "Madeline",
    "Madella",
    "Madelle",
    "Madelon",
    "Madelyn",
    "Madge",
    "Madlen",
    "Madlin",
    "Madonna",
    "Mady",
    "Mae",
    "Maegan",
    "Mag",
    "Magda",
    "Magdaia",
    "Magdalen",
    "Magdalena",
    "Magdalene",
    "Maggee",
    "Maggi",
    "Maggie",
    "Maggy",
    "Mahala",
    "Mahalia",
    "Maia",
    "Maible",
    "Maiga",
    "Maighdiln",
    "Mair",
    "Maire",
    "Maisey",
    "Maisie",
    "Maitilde",
    "Mala",
    "Malanie",
    "Malena",
    "Malia",
    "Malina",
    "Malinda",
    "Malinde",
    "Malissa",
    "Malissia",
    "Mallissa",
    "Mallorie",
    "Mallory",
    "Malorie",
    "Malory",
    "Malva",
    "Malvina",
    "Malynda",
    "Mame",
    "Mamie",
    "Manda",
    "Mandi",
    "Mandie",
    "Mandy",
    "Manon",
    "Manya",
    "Mara",
    "Marabel",
    "Marcela",
    "Marcelia",
    "Marcella",
    "Marcelle",
    "Marcellina",
    "Marcelline",
    "Marchelle",
    "Marci",
    "Marcia",
    "Marcie",
    "Marcile",
    "Marcille",
    "Marcy",
    "Mareah",
    "Maren",
    "Marena",
    "Maressa",
    "Marga",
    "Margalit",
    "Margalo",
    "Margaret",
    "Margareta",
    "Margarete",
    "Margaretha",
    "Margarethe",
    "Margaretta",
    "Margarette",
    "Margarita",
    "Margaux",
    "Marge",
    "Margeaux",
    "Margery",
    "Marget",
    "Margette",
    "Margi",
    "Margie",
    "Margit",
    "Margo",
    "Margot",
    "Margret",
    "Marguerite",
    "Margy",
    "Mari",
    "Maria",
    "Mariam",
    "Marian",
    "Mariana",
    "Mariann",
    "Marianna",
    "Marianne",
    "Maribel",
    "Maribelle",
    "Maribeth",
    "Marice",
    "Maridel",
    "Marie",
    "Marie-ann",
    "Marie-jeanne",
    "Marieann",
    "Mariejeanne",
    "Mariel",
    "Mariele",
    "Marielle",
    "Mariellen",
    "Marietta",
    "Mariette",
    "Marigold",
    "Marijo",
    "Marika",
    "Marilee",
    "Marilin",
    "Marillin",
    "Marilyn",
    "Marin",
    "Marina",
    "Marinna",
    "Marion",
    "Mariquilla",
    "Maris",
    "Marisa",
    "Mariska",
    "Marissa",
    "Marita",
    "Maritsa",
    "Mariya",
    "Marj",
    "Marja",
    "Marje",
    "Marji",
    "Marjie",
    "Marjorie",
    "Marjory",
    "Marjy",
    "Marketa",
    "Marla",
    "Marlane",
    "Marleah",
    "Marlee",
    "Marleen",
    "Marlena",
    "Marlene",
    "Marley",
    "Marlie",
    "Marline",
    "Marlo",
    "Marlyn",
    "Marna",
    "Marne",
    "Marney",
    "Marni",
    "Marnia",
    "Marnie",
    "Marquita",
    "Marrilee",
    "Marris",
    "Marrissa",
    "Marsha",
    "Marsiella",
    "Marta",
    "Martelle",
    "Martguerita",
    "Martha",
    "Marthe",
    "Marthena",
    "Marti",
    "Martica",
    "Martie",
    "Martina",
    "Martita",
    "Marty",
    "Martynne",
    "Mary",
    "Marya",
    "Maryann",
    "Maryanna",
    "Maryanne",
    "Marybelle",
    "Marybeth",
    "Maryellen",
    "Maryjane",
    "Maryjo",
    "Maryl",
    "Marylee",
    "Marylin",
    "Marylinda",
    "Marylou",
    "Marylynne",
    "Maryrose",
    "Marys",
    "Marysa",
    "Masha",
    "Matelda",
    "Mathilda",
    "Mathilde",
    "Matilda",
    "Matilde",
    "Matti",
    "Mattie",
    "Matty",
    "Maud",
    "Maude",
    "Maudie",
    "Maura",
    "Maure",
    "Maureen",
    "Maureene",
    "Maurene",
    "Maurine",
    "Maurise",
    "Maurita",
    "Maurizia",
    "Mavis",
    "Mavra",
    "Max",
    "Maxi",
    "Maxie",
    "Maxine",
    "Maxy",
    "May",
    "Maybelle",
    "Maye",
    "Mead",
    "Meade",
    "Meagan",
    "Meaghan",
    "Meara",
    "Mechelle",
    "Meg",
    "Megan",
    "Megen",
    "Meggi",
    "Meggie",
    "Meggy",
    "Meghan",
    "Meghann",
    "Mehetabel",
    "Mei",
    "Mel",
    "Mela",
    "Melamie",
    "Melania",
    "Melanie",
    "Melantha",
    "Melany",
    "Melba",
    "Melesa",
    "Melessa",
    "Melicent",
    "Melina",
    "Melinda",
    "Melinde",
    "Melisa",
    "Melisande",
    "Melisandra",
    "Melisenda",
    "Melisent",
    "Melissa",
    "Melisse",
    "Melita",
    "Melitta",
    "Mella",
    "Melli",
    "Mellicent",
    "Mellie",
    "Mellisa",
    "Mellisent",
    "Melloney",
    "Melly",
    "Melodee",
    "Melodie",
    "Melody",
    "Melonie",
    "Melony",
    "Melosa",
    "Melva",
    "Mercedes",
    "Merci",
    "Mercie",
    "Mercy",
    "Meredith",
    "Meredithe",
    "Meridel",
    "Meridith",
    "Meriel",
    "Merilee",
    "Merilyn",
    "Meris",
    "Merissa",
    "Merl",
    "Merla",
    "Merle",
    "Merlina",
    "Merline",
    "Merna",
    "Merola",
    "Merralee",
    "Merridie",
    "Merrie",
    "Merrielle",
    "Merrile",
    "Merrilee",
    "Merrili",
    "Merrill",
    "Merrily",
    "Merry",
    "Mersey",
    "Meryl",
    "Meta",
    "Mia",
    "Micaela",
    "Michaela",
    "Michaelina",
    "Michaeline",
    "Michaella",
    "Michal",
    "Michel",
    "Michele",
    "Michelina",
    "Micheline",
    "Michell",
    "Michelle",
    "Micki",
    "Mickie",
    "Micky",
    "Midge",
    "Mignon",
    "Mignonne",
    "Miguela",
    "Miguelita",
    "Mikaela",
    "Mil",
    "Mildred",
    "Mildrid",
    "Milena",
    "Milicent",
    "Milissent",
    "Milka",
    "Milli",
    "Millicent",
    "Millie",
    "Millisent",
    "Milly",
    "Milzie",
    "Mimi",
    "Min",
    "Mina",
    "Minda",
    "Mindy",
    "Minerva",
    "Minetta",
    "Minette",
    "Minna",
    "Minnaminnie",
    "Minne",
    "Minni",
    "Minnie",
    "Minnnie",
    "Minny",
    "Minta",
    "Miquela",
    "Mira",
    "Mirabel",
    "Mirabella",
    "Mirabelle",
    "Miran",
    "Miranda",
    "Mireielle",
    "Mireille",
    "Mirella",
    "Mirelle",
    "Miriam",
    "Mirilla",
    "Mirna",
    "Misha",
    "Missie",
    "Missy",
    "Misti",
    "Misty",
    "Mitzi",
    "Modesta",
    "Modestia",
    "Modestine",
    "Modesty",
    "Moina",
    "Moira",
    "Moll",
    "Mollee",
    "Molli",
    "Mollie",
    "Molly",
    "Mommy",
    "Mona",
    "Monah",
    "Monica",
    "Monika",
    "Monique",
    "Mora",
    "Moreen",
    "Morena",
    "Morgan",
    "Morgana",
    "Morganica",
    "Morganne",
    "Morgen",
    "Moria",
    "Morissa",
    "Morna",
    "Moselle",
    "Moyna",
    "Moyra",
    "Mozelle",
    "Muffin",
    "Mufi",
    "Mufinella",
    "Muire",
    "Mureil",
    "Murial",
    "Muriel",
    "Murielle",
    "Myra",
    "Myrah",
    "Myranda",
    "Myriam",
    "Myrilla",
    "Myrle",
    "Myrlene",
    "Myrna",
    "Myrta",
    "Myrtia",
    "Myrtice",
    "Myrtie",
    "Myrtle",
    "Nada",
    "Nadean",
    "Nadeen",
    "Nadia",
    "Nadine",
    "Nadiya",
    "Nady",
    "Nadya",
    "Nalani",
    "Nan",
    "Nana",
    "Nananne",
    "Nance",
    "Nancee",
    "Nancey",
    "Nanci",
    "Nancie",
    "Nancy",
    "Nanete",
    "Nanette",
    "Nani",
    "Nanice",
    "Nanine",
    "Nannette",
    "Nanni",
    "Nannie",
    "Nanny",
    "Nanon",
    "Naoma",
    "Naomi",
    "Nara",
    "Nari",
    "Nariko",
    "Nat",
    "Nata",
    "Natala",
    "Natalee",
    "Natalie",
    "Natalina",
    "Nataline",
    "Natalya",
    "Natasha",
    "Natassia",
    "Nathalia",
    "Nathalie",
    "Natividad",
    "Natka",
    "Natty",
    "Neala",
    "Neda",
    "Nedda",
    "Nedi",
    "Neely",
    "Neila",
    "Neile",
    "Neilla",
    "Neille",
    "Nelia",
    "Nelie",
    "Nell",
    "Nelle",
    "Nelli",
    "Nellie",
    "Nelly",
    "Nerissa",
    "Nerita",
    "Nert",
    "Nerta",
    "Nerte",
    "Nerti",
    "Nertie",
    "Nerty",
    "Nessa",
    "Nessi",
    "Nessie",
    "Nessy",
    "Nesta",
    "Netta",
    "Netti",
    "Nettie",
    "Nettle",
    "Netty",
    "Nevsa",
    "Neysa",
    "Nichol",
    "Nichole",
    "Nicholle",
    "Nicki",
    "Nickie",
    "Nicky",
    "Nicol",
    "Nicola",
    "Nicole",
    "Nicolea",
    "Nicolette",
    "Nicoli",
    "Nicolina",
    "Nicoline",
    "Nicolle",
    "Nikaniki",
    "Nike",
    "Niki",
    "Nikki",
    "Nikkie",
    "Nikoletta",
    "Nikolia",
    "Nina",
    "Ninetta",
    "Ninette",
    "Ninnetta",
    "Ninnette",
    "Ninon",
    "Nissa",
    "Nisse",
    "Nissie",
    "Nissy",
    "Nita",
    "Nixie",
    "Noami",
    "Noel",
    "Noelani",
    "Noell",
    "Noella",
    "Noelle",
    "Noellyn",
    "Noelyn",
    "Noemi",
    "Nola",
    "Nolana",
    "Nolie",
    "Nollie",
    "Nomi",
    "Nona",
    "Nonah",
    "Noni",
    "Nonie",
    "Nonna",
    "Nonnah",
    "Nora",
    "Norah",
    "Norean",
    "Noreen",
    "Norene",
    "Norina",
    "Norine",
    "Norma",
    "Norri",
    "Norrie",
    "Norry",
    "Novelia",
    "Nydia",
    "Nyssa",
    "Octavia",
    "Odele",
    "Odelia",
    "Odelinda",
    "Odella",
    "Odelle",
    "Odessa",
    "Odetta",
    "Odette",
    "Odilia",
    "Odille",
    "Ofelia",
    "Ofella",
    "Ofilia",
    "Ola",
    "Olenka",
    "Olga",
    "Olia",
    "Olimpia",
    "Olive",
    "Olivette",
    "Olivia",
    "Olivie",
    "Oliy",
    "Ollie",
    "Olly",
    "Olva",
    "Olwen",
    "Olympe",
    "Olympia",
    "Olympie",
    "Ondrea",
    "Oneida",
    "Onida",
    "Oona",
    "Opal",
    "Opalina",
    "Opaline",
    "Ophelia",
    "Ophelie",
    "Ora",
    "Oralee",
    "Oralia",
    "Oralie",
    "Oralla",
    "Oralle",
    "Orel",
    "Orelee",
    "Orelia",
    "Orelie",
    "Orella",
    "Orelle",
    "Oriana",
    "Orly",
    "Orsa",
    "Orsola",
    "Ortensia",
    "Otha",
    "Othelia",
    "Othella",
    "Othilia",
    "Othilie",
    "Ottilie",
    "Page",
    "Paige",
    "Paloma",
    "Pam",
    "Pamela",
    "Pamelina",
    "Pamella",
    "Pammi",
    "Pammie",
    "Pammy",
    "Pandora",
    "Pansie",
    "Pansy",
    "Paola",
    "Paolina",
    "Papagena",
    "Pat",
    "Patience",
    "Patrica",
    "Patrice",
    "Patricia",
    "Patrizia",
    "Patsy",
    "Patti",
    "Pattie",
    "Patty",
    "Paula",
    "Paule",
    "Pauletta",
    "Paulette",
    "Pauli",
    "Paulie",
    "Paulina",
    "Pauline",
    "Paulita",
    "Pauly",
    "Pavia",
    "Pavla",
    "Pearl",
    "Pearla",
    "Pearle",
    "Pearline",
    "Peg",
    "Pegeen",
    "Peggi",
    "Peggie",
    "Peggy",
    "Pen",
    "Penelopa",
    "Penelope",
    "Penni",
    "Pennie",
    "Penny",
    "Pepi",
    "Pepita",
    "Peri",
    "Peria",
    "Perl",
    "Perla",
    "Perle",
    "Perri",
    "Perrine",
    "Perry",
    "Persis",
    "Pet",
    "Peta",
    "Petra",
    "Petrina",
    "Petronella",
    "Petronia",
    "Petronilla",
    "Petronille",
    "Petunia",
    "Phaedra",
    "Phaidra",
    "Phebe",
    "Phedra",
    "Phelia",
    "Phil",
    "Philipa",
    "Philippa",
    "Philippe",
    "Philippine",
    "Philis",
    "Phillida",
    "Phillie",
    "Phillis",
    "Philly",
    "Philomena",
    "Phoebe",
    "Phylis",
    "Phyllida",
    "Phyllis",
    "Phyllys",
    "Phylys",
    "Pia",
    "Pier",
    "Pierette",
    "Pierrette",
    "Pietra",
    "Piper",
    "Pippa",
    "Pippy",
    "Polly",
    "Pollyanna",
    "Pooh",
    "Poppy",
    "Portia",
    "Pris",
    "Prisca",
    "Priscella",
    "Priscilla",
    "Prissie",
    "Pru",
    "Prudence",
    "Prudi",
    "Prudy",
    "Prue",
    "Queenie",
    "Quentin",
    "Querida",
    "Quinn",
    "Quinta",
    "Quintana",
    "Quintilla",
    "Quintina",
    "Rachael",
    "Rachel",
    "Rachele",
    "Rachelle",
    "Rae",
    "Raeann",
    "Raf",
    "Rafa",
    "Rafaela",
    "Rafaelia",
    "Rafaelita",
    "Rahal",
    "Rahel",
    "Raina",
    "Raine",
    "Rakel",
    "Ralina",
    "Ramona",
    "Ramonda",
    "Rana",
    "Randa",
    "Randee",
    "Randene",
    "Randi",
    "Randie",
    "Randy",
    "Ranee",
    "Rani",
    "Rania",
    "Ranice",
    "Ranique",
    "Ranna",
    "Raphaela",
    "Raquel",
    "Raquela",
    "Rasia",
    "Rasla",
    "Raven",
    "Ray",
    "Raychel",
    "Raye",
    "Rayna",
    "Raynell",
    "Rayshell",
    "Rea",
    "Reba",
    "Rebbecca",
    "Rebe",
    "Rebeca",
    "Rebecca",
    "Rebecka",
    "Rebeka",
    "Rebekah",
    "Rebekkah",
    "Ree",
    "Reeba",
    "Reena",
    "Reeta",
    "Reeva",
    "Regan",
    "Reggi",
    "Reggie",
    "Regina",
    "Regine",
    "Reiko",
    "Reina",
    "Reine",
    "Remy",
    "Rena",
    "Renae",
    "Renata",
    "Renate",
    "Rene",
    "Renee",
    "Renell",
    "Renelle",
    "Renie",
    "Rennie",
    "Reta",
    "Retha",
    "Revkah",
    "Rey",
    "Reyna",
    "Rhea",
    "Rheba",
    "Rheta",
    "Rhetta",
    "Rhiamon",
    "Rhianna",
    "Rhianon",
    "Rhoda",
    "Rhodia",
    "Rhodie",
    "Rhody",
    "Rhona",
    "Rhonda",
    "Riane",
    "Riannon",
    "Rianon",
    "Rica",
    "Ricca",
    "Rici",
    "Ricki",
    "Rickie",
    "Ricky",
    "Riki",
    "Rikki",
    "Rina",
    "Risa",
    "Rita",
    "Riva",
    "Rivalee",
    "Rivi",
    "Rivkah",
    "Rivy",
    "Roana",
    "Roanna",
    "Roanne",
    "Robbi",
    "Robbie",
    "Robbin",
    "Robby",
    "Robbyn",
    "Robena",
    "Robenia",
    "Roberta",
    "Robin",
    "Robina",
    "Robinet",
    "Robinett",
    "Robinetta",
    "Robinette",
    "Robinia",
    "Roby",
    "Robyn",
    "Roch",
    "Rochell",
    "Rochella",
    "Rochelle",
    "Rochette",
    "Roda",
    "Rodi",
    "Rodie",
    "Rodina",
    "Rois",
    "Romola",
    "Romona",
    "Romonda",
    "Romy",
    "Rona",
    "Ronalda",
    "Ronda",
    "Ronica",
    "Ronna",
    "Ronni",
    "Ronnica",
    "Ronnie",
    "Ronny",
    "Roobbie",
    "Rora",
    "Rori",
    "Rorie",
    "Rory",
    "Ros",
    "Rosa",
    "Rosabel",
    "Rosabella",
    "Rosabelle",
    "Rosaleen",
    "Rosalia",
    "Rosalie",
    "Rosalind",
    "Rosalinda",
    "Rosalinde",
    "Rosaline",
    "Rosalyn",
    "Rosalynd",
    "Rosamond",
    "Rosamund",
    "Rosana",
    "Rosanna",
    "Rosanne",
    "Rose",
    "Roseann",
    "Roseanna",
    "Roseanne",
    "Roselia",
    "Roselin",
    "Roseline",
    "Rosella",
    "Roselle",
    "Rosemaria",
    "Rosemarie",
    "Rosemary",
    "Rosemonde",
    "Rosene",
    "Rosetta",
    "Rosette",
    "Roshelle",
    "Rosie",
    "Rosina",
    "Rosita",
    "Roslyn",
    "Rosmunda",
    "Rosy",
    "Row",
    "Rowe",
    "Rowena",
    "Roxana",
    "Roxane",
    "Roxanna",
    "Roxanne",
    "Roxi",
    "Roxie",
    "Roxine",
    "Roxy",
    "Roz",
    "Rozalie",
    "Rozalin",
    "Rozamond",
    "Rozanna",
    "Rozanne",
    "Roze",
    "Rozele",
    "Rozella",
    "Rozelle",
    "Rozina",
    "Rubetta",
    "Rubi",
    "Rubia",
    "Rubie",
    "Rubina",
    "Ruby",
    "Ruperta",
    "Ruth",
    "Ruthann",
    "Ruthanne",
    "Ruthe",
    "Ruthi",
    "Ruthie",
    "Ruthy",
    "Ryann",
    "Rycca",
    "Saba",
    "Sabina",
    "Sabine",
    "Sabra",
    "Sabrina",
    "Sacha",
    "Sada",
    "Sadella",
    "Sadie",
    "Sadye",
    "Saidee",
    "Sal",
    "Salaidh",
    "Sallee",
    "Salli",
    "Sallie",
    "Sally",
    "Sallyann",
    "Sallyanne",
    "Saloma",
    "Salome",
    "Salomi",
    "Sam",
    "Samantha",
    "Samara",
    "Samaria",
    "Sammy",
    "Sande",
    "Sandi",
    "Sandie",
    "Sandra",
    "Sandy",
    "Sandye",
    "Sapphira",
    "Sapphire",
    "Sara",
    "Sara-ann",
    "Saraann",
    "Sarah",
    "Sarajane",
    "Saree",
    "Sarena",
    "Sarene",
    "Sarette",
    "Sari",
    "Sarina",
    "Sarine",
    "Sarita",
    "Sascha",
    "Sasha",
    "Sashenka",
    "Saudra",
    "Saundra",
    "Savina",
    "Sayre",
    "Scarlet",
    "Scarlett",
    "Sean",
    "Seana",
    "Seka",
    "Sela",
    "Selena",
    "Selene",
    "Selestina",
    "Selia",
    "Selie",
    "Selina",
    "Selinda",
    "Seline",
    "Sella",
    "Selle",
    "Selma",
    "Sena",
    "Sephira",
    "Serena",
    "Serene",
    "Shae",
    "Shaina",
    "Shaine",
    "Shalna",
    "Shalne",
    "Shana",
    "Shanda",
    "Shandee",
    "Shandeigh",
    "Shandie",
    "Shandra",
    "Shandy",
    "Shane",
    "Shani",
    "Shanie",
    "Shanna",
    "Shannah",
    "Shannen",
    "Shannon",
    "Shanon",
    "Shanta",
    "Shantee",
    "Shara",
    "Sharai",
    "Shari",
    "Sharia",
    "Sharity",
    "Sharl",
    "Sharla",
    "Sharleen",
    "Sharlene",
    "Sharline",
    "Sharon",
    "Sharona",
    "Sharron",
    "Sharyl",
    "Shaun",
    "Shauna",
    "Shawn",
    "Shawna",
    "Shawnee",
    "Shay",
    "Shayla",
    "Shaylah",
    "Shaylyn",
    "Shaylynn",
    "Shayna",
    "Shayne",
    "Shea",
    "Sheba",
    "Sheela",
    "Sheelagh",
    "Sheelah",
    "Sheena",
    "Sheeree",
    "Sheila",
    "Sheila-kathryn",
    "Sheilah",
    "Shel",
    "Shela",
    "Shelagh",
    "Shelba",
    "Shelbi",
    "Shelby",
    "Shelia",
    "Shell",
    "Shelley",
    "Shelli",
    "Shellie",
    "Shelly",
    "Shena",
    "Sher",
    "Sheree",
    "Sheri",
    "Sherie",
    "Sherill",
    "Sherilyn",
    "Sherline",
    "Sherri",
    "Sherrie",
    "Sherry",
    "Sherye",
    "Sheryl",
    "Shina",
    "Shir",
    "Shirl",
    "Shirlee",
    "Shirleen",
    "Shirlene",
    "Shirley",
    "Shirline",
    "Shoshana",
    "Shoshanna",
    "Siana",
    "Sianna",
    "Sib",
    "Sibbie",
    "Sibby",
    "Sibeal",
    "Sibel",
    "Sibella",
    "Sibelle",
    "Sibilla",
    "Sibley",
    "Sibyl",
    "Sibylla",
    "Sibylle",
    "Sidoney",
    "Sidonia",
    "Sidonnie",
    "Sigrid",
    "Sile",
    "Sileas",
    "Silva",
    "Silvana",
    "Silvia",
    "Silvie",
    "Simona",
    "Simone",
    "Simonette",
    "Simonne",
    "Sindee",
    "Siobhan",
    "Sioux",
    "Siouxie",
    "Sisely",
    "Sisile",
    "Sissie",
    "Sissy",
    "Siusan",
    "Sofia",
    "Sofie",
    "Sondra",
    "Sonia",
    "Sonja",
    "Sonni",
    "Sonnie",
    "Sonnnie",
    "Sonny",
    "Sonya",
    "Sophey",
    "Sophi",
    "Sophia",
    "Sophie",
    "Sophronia",
    "Sorcha",
    "Sosanna",
    "Stace",
    "Stacee",
    "Stacey",
    "Staci",
    "Stacia",
    "Stacie",
    "Stacy",
    "Stafani",
    "Star",
    "Starla",
    "Starlene",
    "Starlin",
    "Starr",
    "Stefa",
    "Stefania",
    "Stefanie",
    "Steffane",
    "Steffi",
    "Steffie",
    "Stella",
    "Stepha",
    "Stephana",
    "Stephani",
    "Stephanie",
    "Stephannie",
    "Stephenie",
    "Stephi",
    "Stephie",
    "Stephine",
    "Stesha",
    "Stevana",
    "Stevena",
    "Stoddard",
    "Storm",
    "Stormi",
    "Stormie",
    "Stormy",
    "Sue",
    "Suellen",
    "Sukey",
    "Suki",
    "Sula",
    "Sunny",
    "Sunshine",
    "Susan",
    "Susana",
    "Susanetta",
    "Susann",
    "Susanna",
    "Susannah",
    "Susanne",
    "Susette",
    "Susi",
    "Susie",
    "Susy",
    "Suzann",
    "Suzanna",
    "Suzanne",
    "Suzette",
    "Suzi",
    "Suzie",
    "Suzy",
    "Sybil",
    "Sybila",
    "Sybilla",
    "Sybille",
    "Sybyl",
    "Sydel",
    "Sydelle",
    "Sydney",
    "Sylvia",
    "Tabatha",
    "Tabbatha",
    "Tabbi",
    "Tabbie",
    "Tabbitha",
    "Tabby",
    "Tabina",
    "Tabitha",
    "Taffy",
    "Talia",
    "Tallia",
    "Tallie",
    "Tallou",
    "Tallulah",
    "Tally",
    "Talya",
    "Talyah",
    "Tamar",
    "Tamara",
    "Tamarah",
    "Tamarra",
    "Tamera",
    "Tami",
    "Tamiko",
    "Tamma",
    "Tammara",
    "Tammi",
    "Tammie",
    "Tammy",
    "Tamqrah",
    "Tamra",
    "Tana",
    "Tandi",
    "Tandie",
    "Tandy",
    "Tanhya",
    "Tani",
    "Tania",
    "Tanitansy",
    "Tansy",
    "Tanya",
    "Tara",
    "Tarah",
    "Tarra",
    "Tarrah",
    "Taryn",
    "Tasha",
    "Tasia",
    "Tate",
    "Tatiana",
    "Tatiania",
    "Tatum",
    "Tawnya",
    "Tawsha",
    "Ted",
    "Tedda",
    "Teddi",
    "Teddie",
    "Teddy",
    "Tedi",
    "Tedra",
    "Teena",
    "Teirtza",
    "Teodora",
    "Tera",
    "Teresa",
    "Terese",
    "Teresina",
    "Teresita",
    "Teressa",
    "Teri",
    "Teriann",
    "Terra",
    "Terri",
    "Terrie",
    "Terrijo",
    "Terry",
    "Terrye",
    "Tersina",
    "Terza",
    "Tess",
    "Tessa",
    "Tessi",
    "Tessie",
    "Tessy",
    "Thalia",
    "Thea",
    "Theadora",
    "Theda",
    "Thekla",
    "Thelma",
    "Theo",
    "Theodora",
    "Theodosia",
    "Theresa",
    "Therese",
    "Theresina",
    "Theresita",
    "Theressa",
    "Therine",
    "Thia",
    "Thomasa",
    "Thomasin",
    "Thomasina",
    "Thomasine",
    "Tiena",
    "Tierney",
    "Tiertza",
    "Tiff",
    "Tiffani",
    "Tiffanie",
    "Tiffany",
    "Tiffi",
    "Tiffie",
    "Tiffy",
    "Tilda",
    "Tildi",
    "Tildie",
    "Tildy",
    "Tillie",
    "Tilly",
    "Tim",
    "Timi",
    "Timmi",
    "Timmie",
    "Timmy",
    "Timothea",
    "Tina",
    "Tine",
    "Tiphani",
    "Tiphanie",
    "Tiphany",
    "Tish",
    "Tisha",
    "Tobe",
    "Tobey",
    "Tobi",
    "Toby",
    "Tobye",
    "Toinette",
    "Toma",
    "Tomasina",
    "Tomasine",
    "Tomi",
    "Tommi",
    "Tommie",
    "Tommy",
    "Toni",
    "Tonia",
    "Tonie",
    "Tony",
    "Tonya",
    "Tonye",
    "Tootsie",
    "Torey",
    "Tori",
    "Torie",
    "Torrie",
    "Tory",
    "Tova",
    "Tove",
    "Tracee",
    "Tracey",
    "Traci",
    "Tracie",
    "Tracy",
    "Trenna",
    "Tresa",
    "Trescha",
    "Tressa",
    "Tricia",
    "Trina",
    "Trish",
    "Trisha",
    "Trista",
    "Trix",
    "Trixi",
    "Trixie",
    "Trixy",
    "Truda",
    "Trude",
    "Trudey",
    "Trudi",
    "Trudie",
    "Trudy",
    "Trula",
    "Tuesday",
    "Twila",
    "Twyla",
    "Tybi",
    "Tybie",
    "Tyne",
    "Ula",
    "Ulla",
    "Ulrica",
    "Ulrika",
    "Ulrikaumeko",
    "Ulrike",
    "Umeko",
    "Una",
    "Ursa",
    "Ursala",
    "Ursola",
    "Ursula",
    "Ursulina",
    "Ursuline",
    "Uta",
    "Val",
    "Valaree",
    "Valaria",
    "Vale",
    "Valeda",
    "Valencia",
    "Valene",
    "Valenka",
    "Valentia",
    "Valentina",
    "Valentine",
    "Valera",
    "Valeria",
    "Valerie",
    "Valery",
    "Valerye",
    "Valida",
    "Valina",
    "Valli",
    "Vallie",
    "Vally",
    "Valma",
    "Valry",
    "Van",
    "Vanda",
    "Vanessa",
    "Vania",
    "Vanna",
    "Vanni",
    "Vannie",
    "Vanny",
    "Vanya",
    "Veda",
    "Velma",
    "Velvet",
    "Venita",
    "Venus",
    "Vera",
    "Veradis",
    "Vere",
    "Verena",
    "Verene",
    "Veriee",
    "Verile",
    "Verina",
    "Verine",
    "Verla",
    "Verna",
    "Vernice",
    "Veronica",
    "Veronika",
    "Veronike",
    "Veronique",
    "Vevay",
    "Vi",
    "Vicki",
    "Vickie",
    "Vicky",
    "Victoria",
    "Vida",
    "Viki",
    "Vikki",
    "Vikky",
    "Vilhelmina",
    "Vilma",
    "Vin",
    "Vina",
    "Vinita",
    "Vinni",
    "Vinnie",
    "Vinny",
    "Viola",
    "Violante",
    "Viole",
    "Violet",
    "Violetta",
    "Violette",
    "Virgie",
    "Virgina",
    "Virginia",
    "Virginie",
    "Vita",
    "Vitia",
    "Vitoria",
    "Vittoria",
    "Viv",
    "Viva",
    "Vivi",
    "Vivia",
    "Vivian",
    "Viviana",
    "Vivianna",
    "Vivianne",
    "Vivie",
    "Vivien",
    "Viviene",
    "Vivienne",
    "Viviyan",
    "Vivyan",
    "Vivyanne",
    "Vonni",
    "Vonnie",
    "Vonny",
    "Vyky",
    "Wallie",
    "Wallis",
    "Walliw",
    "Wally",
    "Waly",
    "Wanda",
    "Wandie",
    "Wandis",
    "Waneta",
    "Wanids",
    "Wenda",
    "Wendeline",
    "Wendi",
    "Wendie",
    "Wendy",
    "Wendye",
    "Wenona",
    "Wenonah",
    "Whitney",
    "Wileen",
    "Wilhelmina",
    "Wilhelmine",
    "Wilie",
    "Willa",
    "Willabella",
    "Willamina",
    "Willetta",
    "Willette",
    "Willi",
    "Willie",
    "Willow",
    "Willy",
    "Willyt",
    "Wilma",
    "Wilmette",
    "Wilona",
    "Wilone",
    "Wilow",
    "Windy",
    "Wini",
    "Winifred",
    "Winna",
    "Winnah",
    "Winne",
    "Winni",
    "Winnie",
    "Winnifred",
    "Winny",
    "Winona",
    "Winonah",
    "Wren",
    "Wrennie",
    "Wylma",
    "Wynn",
    "Wynne",
    "Wynnie",
    "Wynny",
    "Xaviera",
    "Xena",
    "Xenia",
    "Xylia",
    "Xylina",
    "Yalonda",
    "Yasmeen",
    "Yasmin",
    "Yelena",
    "Yetta",
    "Yettie",
    "Yetty",
    "Yevette",
    "Ynes",
    "Ynez",
    "Yoko",
    "Yolanda",
    "Yolande",
    "Yolane",
    "Yolanthe",
    "Yoshi",
    "Yoshiko",
    "Yovonnda",
    "Ysabel",
    "Yvette",
    "Yvonne",
    "Zabrina",
    "Zahara",
    "Zandra",
    "Zaneta",
    "Zara",
    "Zarah",
    "Zaria",
    "Zarla",
    "Zea",
    "Zelda",
    "Zelma",
    "Zena",
    "Zenia",
    "Zia",
    "Zilvia",
    "Zita",
    "Zitella",
    "Zoe",
    "Zola",
    "Zonda",
    "Zondra",
    "Zonnya",
    "Zora",
    "Zorah",
    "Zorana",
    "Zorina",
    "Zorine",
    "Zsazsa",
    "Zulema",
    "Zuzana"
], $5a81d9be4d45fe0a$export$99948208785e5ca1 = [
    "Ackbar",
    "Adi Gallia",
    "Anakin Skywalker",
    "Arvel Crynyd",
    "Ayla Secura",
    "Bail Prestor Organa",
    "Barriss Offee",
    "Ben Quadinaros",
    "Beru Whitesun lars",
    "Bib Fortuna",
    "Biggs Darklighter",
    "Boba Fett",
    "Bossk",
    "C-3PO",
    "Chewbacca",
    "Cliegg Lars",
    "Cord\xe9",
    "Darth Maul",
    "Darth Vader",
    "Dexter Jettster",
    "Dooku",
    "Dorm\xe9",
    "Dud Bolt",
    "Eeth Koth",
    "Finis Valorum",
    "Gasgano",
    "Greedo",
    "Gregar Typho",
    "Grievous",
    "Han Solo",
    "IG-88",
    "Jabba Desilijic Tiure",
    "Jango Fett",
    "Jar Jar Binks",
    "Jek Tono Porkins",
    "Jocasta Nu",
    "Ki-Adi-Mundi",
    "Kit Fisto",
    "Lama Su",
    "Lando Calrissian",
    "Leia Organa",
    "Lobot",
    "Luke Skywalker",
    "Luminara Unduli",
    "Mace Windu",
    "Mas Amedda",
    "Mon Mothma",
    "Nien Nunb",
    "Nute Gunray",
    "Obi-Wan Kenobi",
    "Owen Lars",
    "Padm\xe9 Amidala",
    "Palpatine",
    "Plo Koon",
    "Poggle the Lesser",
    "Quarsh Panaka",
    "Qui-Gon Jinn",
    "R2-D2",
    "R4-P17",
    "R5-D4",
    "Ratts Tyerel",
    "Raymus Antilles",
    "Ric Oli\xe9",
    "Roos Tarpals",
    "Rugor Nass",
    "Saesee Tiin",
    "San Hill",
    "Sebulba",
    "Shaak Ti",
    "Shmi Skywalker",
    "Sly Moore",
    "Tarfful",
    "Taun We",
    "Tion Medon",
    "Wat Tambor",
    "Watto",
    "Wedge Antilles",
    "Wicket Systri Warrick",
    "Wilhuff Tarkin",
    "Yarael Poof",
    "Yoda",
    "Zam Wesell"
];
class $5a81d9be4d45fe0a$export$254ee373f8c5ef6e {
    static generate(a = {}) {
        let e = a.min || 1, i = a.max || 999;
        if (a.length) {
            const n = Math.pow(10, a.length);
            return e = n / 10, i = n - 1, [
                `${Math.floor(Math.random() * (i - e)) + e}`
            ];
        }
        return [
            `${Math.floor(Math.random() * (i - e)) + e}`
        ];
    }
}


var $41348c35dfeff093$exports = {};
$41348c35dfeff093$exports = JSON.parse('{"deckActionCardDraw":{"cards":[{"name":"Starter_Mining_2"},{"name":"Starter_Mining"},{"name":"Starter_Fishing"},{"name":"Starter_Tending_2"}]},"deckActionCardDiscard":{"cards":[]},"deckActionDrawLeft":{"cards":[{"name":"Season3Action_MarketDelver"},{"name":"Season3Action_LakeFisher"},{"name":"Season3Action_FreshFarmer"},{"name":"Season2Action_Collector"},{"name":"Season2Action_CovernGrower"},{"name":"Season2Action_WoodCleaner"},{"name":"Season2Action_GeneralistMedalEarner"},{"name":"Season1Action_WoodScrapper"},{"name":"Season1Action_NoviceMiner"},{"name":"Season1Action_RiverDredger"},{"name":"Season1Action_AxeMiner"}]},"deckActionDrawRight":{"cards":[{"name":"Season3Action_Geologist"},{"name":"Season3Action_MarketWizard"},{"name":"Season3Action_FishHunter"},{"name":"Season2Action_LureMaster"},{"name":"Season2Action_Excavator"},{"name":"Season2Action_AmateurFarmer"},{"name":"Season2Action_Retooler"},{"name":"Season1Action_NoviceForager"},{"name":"Season1Action_FarmMiner"},{"name":"Season1Action_RiverFisher"},{"name":"Season1Action_SocialButterfly"}]},"deckActionCardActive":{"cards":[{"name":"Starter_Tending"},{"name":"Starter_Chopping"},{"name":"Starter_Fishing_2"},{"name":"Starter_ZenithOrders"},{"name":"Starter_Chopping_2"}]},"objectiveOne":{"name":"Objective_S1_CentralSampler"},"objectiveTwo":{"name":"Objective_S2_Explorer"},"objectiveThree":{"name":"Objective_S3_TrueFriend"},"randomSeed":{"seed":9}}');


var $13f552a37367970f$exports = {};
$13f552a37367970f$exports = JSON.parse('{"deckActionCardDraw":{"cards":[{"name":"Starter_Mining"},{"name":"Starter_Fishing"},{"name":"Starter_ZenithOrders"},{"name":"Starter_Chopping"}]},"deckActionCardDiscard":{"cards":[]},"deckActionDrawLeft":{"cards":[{"name":"Season3Action_Kingfisher"},{"name":"Season3Action_Completist"},{"name":"Season3Action_MasterFarmer"},{"name":"Season2Action_ProjectDabbler"},{"name":"Season2Action_Excavator"},{"name":"Season2Action_CovernGrower"},{"name":"Season2Action_ExpertFisher"},{"name":"Season1Action_AxeMiner"},{"name":"Season1Action_NoviceFisher"},{"name":"Season1Action_NoviceForager"},{"name":"Season1Action_FarmClearer"}]},"deckActionDrawRight":{"cards":[{"name":"Season3Action_LakeFisher"},{"name":"Season3Action_MarketDelver"},{"name":"Season3Action_CompleteBuilder"},{"name":"Season2Action_LumberjackFisher"},{"name":"Season2Action_LureMaster"},{"name":"Season2Action_WoodCleaner"},{"name":"Season2Action_FarmForester"},{"name":"Season1Action_RiverDredger"},{"name":"Season1Action_NatureCollector"},{"name":"Season1Action_EnergyEnthusiast"},{"name":"Season1Action_Grower"}]},"deckActionCardActive":{"cards":[{"name":"Starter_Mining_2"},{"name":"Starter_Tending_2"},{"name":"Starter_Tending"},{"name":"Starter_Fishing_2"},{"name":"Starter_Chopping_2"}]},"objectiveOne":{"name":"Objective_S1_BigGuy"},"objectiveTwo":{"name":"Objective_S2_Cruncher"},"objectiveThree":{"name":"Objective_S3_Lefty"},"randomSeed":{"seed":17}}');


var $3b9093cea216daf0$exports = {};
$3b9093cea216daf0$exports = JSON.parse('{"deckActionCardDraw":{"cards":[{"name":"Starter_Tending"},{"name":"Starter_Fishing_2"},{"name":"Starter_Chopping_2"},{"name":"Starter_ZenithOrders"}]},"deckActionCardDiscard":{"cards":[]},"deckActionDrawLeft":{"cards":[{"name":"Season3Action_AntiAntiSocial"},{"name":"Season3Action_Woodsman"},{"name":"Season3Action_FreshFarmer"},{"name":"Season2Action_SecretMineFisher"},{"name":"Season2Action_ExpertFisher"},{"name":"Season2Action_FarmForester"},{"name":"Season2Action_ProjectDabbler"},{"name":"Season1Action_NoviceCollector"},{"name":"Season1Action_ShinyCollector"},{"name":"Season1Action_CaveFisher"},{"name":"Season1Action_FarmClearer"}]},"deckActionDrawRight":{"cards":[{"name":"Season3Action_MarketDelver"},{"name":"Season3Action_Kingfisher"},{"name":"Season3Action_WoodsExplorer"},{"name":"Season2Action_WoodCleaner"},{"name":"Season2Action_Excavator"},{"name":"Season2Action_AmateurFarmer"},{"name":"Season2Action_LumberjackFisher"},{"name":"Season1Action_FarmMiner"},{"name":"Season1Action_WoodScrapper"},{"name":"Season1Action_Gatherer"},{"name":"Season1Action_NoviceFisher"}]},"deckActionCardActive":{"cards":[{"name":"Starter_Mining"},{"name":"Starter_Mining_2"},{"name":"Starter_Fishing"},{"name":"Starter_Tending_2"},{"name":"Starter_Chopping"}]},"objectiveOne":{"name":"Objective_S1_Loner"},"objectiveTwo":{"name":"Objective_S2_Explorer"},"objectiveThree":{"name":"Objective_S3_Assembler"},"randomSeed":{"seed":97}}');


var $c092f29ba770ab15$exports = {};
$c092f29ba770ab15$exports = JSON.parse('{"deckActionCardDraw":{"cards":[{"name":"Starter_Fishing_2"},{"name":"Starter_Chopping"},{"name":"Starter_Mining"},{"name":"Starter_Chopping_2"}]},"deckActionCardDiscard":{"cards":[]},"deckActionDrawLeft":{"cards":[{"name":"Season3Action_Geologist"},{"name":"Season3Action_AntiAntiSocial"},{"name":"Season3Action_LakeFisher"},{"name":"Season2Action_JackOfAllTrades"},{"name":"Season2Action_GeneralistMedalEarner"},{"name":"Season2Action_Excavator"},{"name":"Season2Action_AmateurFarmer"},{"name":"Season1Action_FarmClearer"},{"name":"Season1Action_RiverFisher"},{"name":"Season1Action_FarmFisher"},{"name":"Season1Action_FarmMiner"}]},"deckActionDrawRight":{"cards":[{"name":"Season3Action_Delver"},{"name":"Season3Action_Kingfisher"},{"name":"Season3Action_Completist"},{"name":"Season2Action_LumberjackFisher"},{"name":"Season2Action_ProjectDabbler"},{"name":"Season2Action_Collector"},{"name":"Season2Action_SecretMineFisher"},{"name":"Season1Action_NoviceForager"},{"name":"Season1Action_WoodScrapper"},{"name":"Season1Action_EnergyEnthusiast"},{"name":"Season1Action_Grower"}]},"deckActionCardActive":{"cards":[{"name":"Starter_Tending"},{"name":"Starter_Fishing"},{"name":"Starter_Tending_2"},{"name":"Starter_ZenithOrders"},{"name":"Starter_Mining_2"}]},"objectiveOne":{"name":"Objective_S1_Clearer"},"objectiveTwo":{"name":"Objective_S2_Upgrader"},"objectiveThree":{"name":"Objective_S3_Assembler"},"randomSeed":{"seed":27}}');


const $e254242a4638c77e$export$9ec3ea001a156deb = [
    ...(0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).deckActionCardDraw.cards.map((card)=>card.name),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).deckActionDrawLeft.cards.map((card)=>card.name),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).deckActionDrawRight.cards.map((card)=>card.name),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).deckActionCardActive.cards.map((card)=>card.name),
    (0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).objectiveOne.name,
    (0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).objectiveTwo.name,
    (0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports))).objectiveThree.name
];
const $e254242a4638c77e$export$55703ba7f9aa06c9 = (0, (/*@__PURE__*/$parcel$interopDefault($41348c35dfeff093$exports)));
const $e254242a4638c77e$export$f442ad5c88b70907 = (0, (/*@__PURE__*/$parcel$interopDefault($13f552a37367970f$exports)));
const $e254242a4638c77e$export$99f5556f475c8bb = (0, (/*@__PURE__*/$parcel$interopDefault($3b9093cea216daf0$exports)));
const $e254242a4638c77e$export$536d34c889380d1b = (0, (/*@__PURE__*/$parcel$interopDefault($c092f29ba770ab15$exports)));
function $e254242a4638c77e$export$1be594f4d8b52ed2(gameData) {
    console.log("Processing deckActionCardDraw:");
    gameData.deckActionCardDraw.cards.forEach((card)=>console.log(card.name));
    console.log("Processing deckActionDrawLeft:");
    gameData.deckActionDrawLeft.cards.forEach((card)=>console.log(card.name));
    console.log("Processing deckActionDrawRight:");
    gameData.deckActionDrawRight.cards.forEach((card)=>console.log(card.name));
    console.log("Processing deckActionCardActive:");
    gameData.deckActionCardActive.cards.forEach((card)=>console.log(card.name));
    // You can also access objectives or the random seed
    console.log("Objective One:", gameData.objectiveOne.name);
    console.log("Objective Two:", gameData.objectiveTwo.name);
    console.log("Objective Three:", gameData.objectiveThree.name);
    console.log("Random Seed:", gameData.randomSeed.seed);
}


class $2a5aca95b098c3c4$export$a92776769f460054 {
    constructor(seedInput){
        this.m = 0x80000000 // 2^31
        ;
        this.a = 1103515245;
        this.c = 12345;
        this.savedGame = false;
        this.stringSeed = null;
        if (seedInput == null) {
            const randomName = $2a5aca95b098c3c4$export$a92776769f460054.generateSeedName();
            this.seed = 1 / this.hashString(randomName) % this.m;
            this.stringSeed = randomName;
            console.log("result =  " + randomName);
        } else if (typeof seedInput === "string") {
            seedInput = seedInput.toLocaleLowerCase();
            if (seedInput == "dice-tower-1") {
                console.log("loading Dice Tower save!");
                this.stringSeed = "dice-tower-1";
                const savedSeed = (0, $e254242a4638c77e$export$536d34c889380d1b).randomSeed;
                this.savedGame = true;
                this.savedGameFile = (0, $e254242a4638c77e$export$536d34c889380d1b);
                if (typeof savedSeed === "number") this.seed = savedSeed % this.m;
                else this.seed = 27 % this.m;
            } else {
                // OLD SEEDS DIDN'T USE THIS
                this.seed = 1 / this.hashString(seedInput) % this.m;
                this.stringSeed = seedInput;
                console.log("result =  " + this.seed);
            }
        } else this.seed = seedInput % this.m;
        this.startingSeed = this.seed;
        console.log("seed input: " + seedInput);
    }
    static generateSeedName() {
        return (0, $5a81d9be4d45fe0a$export$cbc7f705af9d46b6)({
            dictionaries: [
                (0, $5a81d9be4d45fe0a$export$91076e975f93bb),
                (0, $5a81d9be4d45fe0a$export$8f45430ccf837300)
            ],
            separator: "-",
            length: 2
        });
    }
    next() {
        this.seed = (this.a * this.seed + this.c) % this.m;
        return this.seed / this.m;
    }
    random() {
        return this.next();
    }
    hashString(str) {
        let hash = 0;
        for(let i = 0; i < str.length; i++){
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char; // hash * 31 + char, assuming 31 can be replaced with a bit-shift and subtract
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    getCurrentSeed() {
        if (this.stringSeed != null) return this.stringSeed;
        else return this.seed.toString();
    }
    restartGame() {
        this.seed = this.startingSeed;
    }
    advance(steps) {
        for(let index = 0; index < steps; index++)this.next();
    }
}




class $6537155b5d7e8949$export$b1ab05a75170c847 {
    constructor(){
        this.roundTimes = [
            5,
            5,
            5,
            6,
            6,
            6,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8
        ];
        this.scoringMinutes = 4;
        this.scoringTime = false;
        this.gameOver = false;
        this.timerEnabled = false;
        this.getDeckSetupOptions = ()=>({});
        this.onStateChange = null;
        this.onGameFinished = null;
        this.round = 1;
        this.roundElement = document.getElementById("round");
        this.previousRoundButton = document.getElementById("previousRound");
        this.nextRoundButton = document.getElementById("nextRound");
        this.roundElementContainer = document.getElementById("round-bg");
        this.pauseButton = document.getElementById("pause");
        this.timerDisplay = document.querySelector(".timer-display");
        this.pauseButton.addEventListener("click", ()=>{
            if (this.gameOver || !this.timerEnabled) return;
            if ((0, $b4e14b6b8da86996$export$9dc4ecf953986f04).isRunning) (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).pause();
            else (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).resume();
            this.syncPauseButton();
        });
        this.nextRoundButton.addEventListener("click", ()=>{
            this.nextRound();
        });
        this.previousRoundButton.addEventListener("click", ()=>{
            let targetRound = this.scoringTime ? this.round : this.round - 1;
            targetRound = Math.max(targetRound, 1);
            this.restartGame();
            this.nextRoundButton.style.display = "";
            for(let index = 0; index < targetRound - 1; index++){
                this.round++;
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupNextRound();
                this.scoringTime = false;
                this.setTimerForCurrentRound(true);
                console.log("going to next round");
            }
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowCurrentCards();
            (0, $b4e14b6b8da86996$export$dbf60eeb5e81ac26).showRound(this.round, false);
            this.updateUI();
            this.syncPauseButton();
        });
        this.updateUI();
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).on("finish", ()=>{
            console.log("The timer has finished!");
            this.nextRound();
        // Additional logic when the timer finishes
        });
    }
    isTimerEnabled() {
        return this.timerEnabled;
    }
    setTimerEnabled(isEnabled) {
        this.timerEnabled = isEnabled;
        this.setTimerControlsVisible(this.timerEnabled);
        if (!this.timerEnabled) {
            this.disableTimerControls();
            return;
        }
        if (this.gameOver) {
            this.pauseButton.disabled = true;
            this.setPauseButtonState("Game over", false, true);
            return;
        }
        this.setTimerForCurrentRound(false);
    }
    setDeckSetupOptionsProvider(provider) {
        this.getDeckSetupOptions = provider;
    }
    setStateChangeHandler(handler) {
        this.onStateChange = handler;
    }
    setGameFinishedHandler(handler) {
        this.onGameFinished = handler;
    }
    getState() {
        return {
            round: this.round,
            scoringTime: this.scoringTime,
            gameOver: this.gameOver,
            timerEnabled: this.timerEnabled
        };
    }
    restoreProgress(state) {
        this.restartGame();
        while(this.round !== state.round || this.scoringTime !== state.scoringTime || this.gameOver !== state.gameOver){
            this.advanceForRestore();
            if (this.gameOver && (this.round !== state.round || this.scoringTime !== state.scoringTime || this.gameOver !== state.gameOver)) break;
        }
        if (typeof state.timerEnabled === "boolean") this.timerEnabled = state.timerEnabled;
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).stop();
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).setDuration(this.getCurrentTimerDuration());
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).reset();
        this.nextRoundButton.style.display = this.gameOver ? "none" : "";
        this.pauseButton.disabled = this.gameOver || !this.timerEnabled;
        this.updateUI();
        this.syncPauseButton();
    }
    restartGame() {
        this.gameOver = false;
        this.resetRounds();
        (0, $b4e14b6b8da86996$export$cd94982b18c6332c).restartGame();
        if ((0, $b4e14b6b8da86996$export$cd94982b18c6332c).savedGame == true && (0, $b4e14b6b8da86996$export$cd94982b18c6332c).savedGameFile != null) (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupFixedDecks((0, $b4e14b6b8da86996$export$cd94982b18c6332c).savedGameFile);
        else {
            const options = this.getDeckSetupOptions();
            // Match initial setup when replaying a later game of this event campaign.
            if ((0, $ff80734700dcac50$export$b8db1089c8443214)(options.currentSeed) && options.cellarExpansionEnabled) (0, $b4e14b6b8da86996$export$cd94982b18c6332c).advance(((options.campaignGameNumber ?? 1) - 1) * 100);
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupDecks(options);
        }
        this.notifyStateChange();
    }
    resetRounds() {
        this.round = 1;
        this.scoringTime = false;
        this.gameOver = false;
        this.nextRoundButton.style.display = "";
        this.setTimerForCurrentRound(false);
        this.updateUI();
        this.notifyStateChange();
    }
    // Move to the next round
    nextRound() {
        if (this.gameOver) return;
        console.log("next round");
        if (this.scoringTime) {
            if (this.round == 12) {
                this.finishGame();
                return;
            }
            this.scoringTime = false;
            this.round++;
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupNextRound();
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowCurrentCards();
            (0, $b4e14b6b8da86996$export$dbf60eeb5e81ac26).showRound(this.round, true);
        } else if (this.round == 5 || this.round == 9 || this.round == 12) this.scoringTime = true;
        else {
            this.round++;
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupNextRound();
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowCurrentCards();
            (0, $b4e14b6b8da86996$export$dbf60eeb5e81ac26).showRound(this.round, true);
        }
        this.setTimerForCurrentRound(true);
        this.updateUI();
        this.notifyStateChange();
    }
    finishGame() {
        this.scoringTime = false;
        this.gameOver = true;
        (0, $b4e14b6b8da86996$export$53d0237de85c0eef).HideScoringObjective();
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).stop();
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).setDuration(0);
        this.nextRoundButton.style.display = "none";
        this.setPauseButtonState("Game over", false, true);
        this.pauseButton.disabled = true;
        this.updateUI();
        this.notifyStateChange();
        this.onGameFinished?.();
    }
    getRoundDuration(round) {
        return this.roundTimes[round - 1] ?? this.roundTimes[this.roundTimes.length - 1];
    }
    getCurrentTimerDuration() {
        return (this.scoringTime ? this.scoringMinutes : this.getRoundDuration(this.round)) * 60;
    }
    setTimerForCurrentRound(startTimer) {
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).setDuration(this.getCurrentTimerDuration());
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).reset();
        if (!this.timerEnabled) {
            this.disableTimerControls();
            return;
        }
        this.setTimerControlsVisible(true);
        this.pauseButton.disabled = false;
        if (startTimer) (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).start();
        this.syncPauseButton();
    }
    disableTimerControls() {
        (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).stop();
        this.setTimerControlsVisible(false);
        this.pauseButton.disabled = true;
        this.setPauseButtonState("Start timer", false);
    }
    setTimerControlsVisible(isVisible) {
        this.timerDisplay.classList.toggle("is-hidden", !isVisible);
        this.pauseButton.classList.toggle("is-hidden", !isVisible);
    }
    syncPauseButton() {
        if (!this.timerEnabled) {
            this.disableTimerControls();
            return;
        }
        this.setTimerControlsVisible(true);
        this.pauseButton.disabled = false;
        this.setPauseButtonState((0, $b4e14b6b8da86996$export$9dc4ecf953986f04).isRunning ? "Pause timer" : "Start timer", (0, $b4e14b6b8da86996$export$9dc4ecf953986f04).isRunning);
    }
    setPauseButtonState(label, isRunning, isGameOver = false) {
        this.pauseButton.classList.toggle("is-running", isRunning);
        this.pauseButton.classList.toggle("is-paused", !isRunning);
        this.pauseButton.classList.toggle("is-game-over", isGameOver);
        this.pauseButton.setAttribute("aria-label", label);
        this.pauseButton.setAttribute("title", label);
        const labelElement = this.pauseButton.querySelector(".round-control-label");
        if (labelElement != null) labelElement.textContent = label;
    }
    // Update the UI elements for the round number
    updateUI() {
        console.log("round number = " + this.round);
        if (this.gameOver) {
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).HideScoringObjective();
            this.roundElement.innerText = "Game Over!";
            this.roundElementContainer.style.backgroundColor = "#F18A65";
        } else if (this.scoringTime == false) {
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).HideScoringObjective();
            this.roundElement.innerText = "Round: " + this.round + " / 12";
            if (this.round < 6) this.roundElementContainer.style.backgroundColor = "#ADCD60";
            else if (this.round < 10) this.roundElementContainer.style.backgroundColor = "#FDC742";
            else if (this.round < 15) this.roundElementContainer.style.backgroundColor = "#F18A65";
        } else {
            if (this.round < 6) {
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowScoringObjective(1);
                this.roundElement.innerText = "Season 1 Scoring!";
            } else if (this.round < 10) {
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowScoringObjective(2);
                this.roundElement.innerText = "Season 2 Scoring!";
            } else if (this.round < 13) {
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).ShowScoringObjective(3);
                this.roundElement.innerText = "Season 3 Scoring!";
            } else {
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).HideScoringObjective();
                this.roundElement.innerText = "Game Over!";
            }
        }
    }
    // Get the current round number
    getCurrentRound() {
        return this.round;
    }
    advanceForRestore() {
        if (this.gameOver) return;
        if (this.scoringTime) {
            if (this.round == 12) {
                this.scoringTime = false;
                this.gameOver = true;
                (0, $b4e14b6b8da86996$export$53d0237de85c0eef).HideScoringObjective();
                this.nextRoundButton.style.display = "none";
                return;
            }
            this.scoringTime = false;
            this.round++;
            (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupNextRound();
            return;
        }
        if (this.round == 5 || this.round == 9 || this.round == 12) {
            this.scoringTime = true;
            return;
        }
        this.round++;
        (0, $b4e14b6b8da86996$export$53d0237de85c0eef).SetupNextRound();
    }
    notifyStateChange() {
        this.onStateChange?.();
    }
}


class $5e461ea1a655d7bf$export$c57e9b2d8b9e4de {
    constructor(initialDuration = 300){
        this.timerInterval = null;
        this.isRunning = false;
        this.eventListeners = {};
        this.displayElement = document.getElementById("timer");
        this.duration = initialDuration; // Default to 8 minutes (480 seconds)
        this.remainingTime = this.duration;
        this.updateDisplay();
    }
    updateDisplay() {
        this.displayElement.textContent = this.formatTime(this.remainingTime);
    }
    formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    getCurrentTime() {
        return this.remainingTime;
    }
    setDuration(newDuration) {
        this.duration = newDuration;
        this.remainingTime = this.duration;
        if (this.isRunning) {
            this.reset();
            this.start();
        } else this.updateDisplay();
    }
    start() {
        if (this.isRunning) return;
        this.timerInterval = setInterval(()=>{
            this.remainingTime--;
            this.updateDisplay();
            if (this.remainingTime <= 0) {
                this.stop();
                //alert("Time's up!");
                this.emit("finish");
            }
        }, 1000);
        this.isRunning = true;
    }
    pause() {
        if (!this.isRunning) return;
        if (this.timerInterval !== null) clearInterval(this.timerInterval);
        this.isRunning = false;
    }
    resume() {
        if (this.isRunning) return;
        this.start();
    }
    reset() {
        if (this.isRunning) this.pause();
        this.remainingTime = this.duration;
        this.updateDisplay();
    }
    stop() {
        if (this.timerInterval !== null) clearInterval(this.timerInterval);
        this.isRunning = false;
    }
    getTime() {
        return this.formatTime(this.remainingTime);
    }
    // Event handling methods
    on(event, listener) {
        if (!this.eventListeners[event]) this.eventListeners[event] = [];
        this.eventListeners[event].push(listener);
    }
    emit(event) {
        if (this.eventListeners[event]) this.eventListeners[event].forEach((listener)=>listener());
    }
}




var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};

function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === "string") this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


const $f79613d1242335be$export$19991c4348110bf5 = {
    tend: {
        alt: "Tend",
        className: "tend-text-image",
        src: "https://ucarecdn.com/2d8cfae6-6217-4209-aa15-240451327892/TendLetters.svg"
    },
    zenith: {
        alt: "Zenith",
        className: "zenith-image",
        src: "https://ucarecdn.com/a403fdf5-ba34-42da-b917-ebc0bdf419a9/ZenithWhite.svg"
    }
};
function $f79613d1242335be$var$getLogoConfig(value) {
    if (value !== "tend" && value !== "zenith") return null;
    return $f79613d1242335be$export$19991c4348110bf5[value];
}
function $f79613d1242335be$export$cb6bc6487192e324(root = document) {
    root.querySelectorAll("[data-brand-logo]").forEach((logoSlot)=>{
        const logoConfig = $f79613d1242335be$var$getLogoConfig(logoSlot.dataset.brandLogo);
        if (logoConfig == null) return;
        const logoImage = document.createElement("img");
        logoImage.alt = logoConfig.alt;
        logoImage.className = logoConfig.className;
        logoImage.decoding = "async";
        logoImage.src = logoConfig.src;
        logoSlot.setAttribute("aria-label", logoConfig.alt);
        logoSlot.replaceChildren(logoImage);
    });
}


const $b4e14b6b8da86996$export$9dc4ecf953986f04 = new (0, $5e461ea1a655d7bf$export$c57e9b2d8b9e4de)();
const $b4e14b6b8da86996$export$53d0237de85c0eef = new (0, $559d530d06978d6f$export$8827d7c739e89978)();
const $b4e14b6b8da86996$export$dbf60eeb5e81ac26 = new (0, $2ec4bfea98255610$export$f04aa403a5e6975e)();
const $b4e14b6b8da86996$export$a62be19d50c35c62 = new (0, $6537155b5d7e8949$export$b1ab05a75170c847)();
let $b4e14b6b8da86996$export$cd94982b18c6332c = new (0, $2a5aca95b098c3c4$export$a92776769f460054)(null);
let $b4e14b6b8da86996$export$5fa7964489d65dce = "";
let $b4e14b6b8da86996$var$hiveExpansionEnabled = false;
let $b4e14b6b8da86996$var$cellarExpansionEnabled = false;
let $b4e14b6b8da86996$var$advancedCardsEnabled = false;
let $b4e14b6b8da86996$var$campaignState = null;
let $b4e14b6b8da86996$var$isApplyingState = false;
let $b4e14b6b8da86996$var$seedInputElement = null;
let $b4e14b6b8da86996$var$seedQrCodeElement = null;
let $b4e14b6b8da86996$var$hiveToggleElement = null;
let $b4e14b6b8da86996$var$cellarToggleElement = null;
let $b4e14b6b8da86996$var$advancedCardsToggleElement = null;
let $b4e14b6b8da86996$var$cellarGameDisplayElement = null;
let $b4e14b6b8da86996$var$cellarGameLabelElement = null;
let $b4e14b6b8da86996$var$cellarOverlayElement = null;
let $b4e14b6b8da86996$var$cellarEyebrowElement = null;
let $b4e14b6b8da86996$var$cellarTitleElement = null;
let $b4e14b6b8da86996$var$cellarDescriptionElement = null;
let $b4e14b6b8da86996$var$cellarSummaryElement = null;
let $b4e14b6b8da86996$var$cellarFiltersElement = null;
let $b4e14b6b8da86996$var$cellarCardGridElement = null;
let $b4e14b6b8da86996$var$cellarNextPlayerButton = null;
let $b4e14b6b8da86996$var$cellarDoneButton = null;
let $b4e14b6b8da86996$var$cellarNextGameButton = null;
let $b4e14b6b8da86996$var$cellarCloseButton = null;
const $b4e14b6b8da86996$var$tabletViewportQuery = window.matchMedia("(min-width: 769px) and (max-width: 1366px) and (pointer: coarse)");
const $b4e14b6b8da86996$var$cellarOfferPool = (0, $75cf632b34b11e25$export$ef7b06446d5f677d)();
$b4e14b6b8da86996$export$a62be19d50c35c62.setDeckSetupOptionsProvider(()=>({
        hiveExpansionEnabled: $b4e14b6b8da86996$var$hiveExpansionEnabled,
        cellarExpansionEnabled: $b4e14b6b8da86996$var$cellarExpansionEnabled,
        includeAdvancedCards: $b4e14b6b8da86996$var$advancedCardsEnabled,
        guaranteedActionCardNames: $b4e14b6b8da86996$var$cellarExpansionEnabled ? $b4e14b6b8da86996$var$getCurrentGuaranteedCardNames() : [],
        currentSeed: $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(),
        campaignGameNumber: $b4e14b6b8da86996$var$campaignState?.gameNumber ?? 1
    }));
$b4e14b6b8da86996$export$a62be19d50c35c62.setStateChangeHandler(()=>{
    if ($b4e14b6b8da86996$var$isApplyingState) return;
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.setEnabled($b4e14b6b8da86996$var$hiveExpansionEnabled, $b4e14b6b8da86996$export$a62be19d50c35c62.getCurrentRound());
    $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
});
$b4e14b6b8da86996$export$a62be19d50c35c62.setGameFinishedHandler(()=>{
    if ($b4e14b6b8da86996$var$isApplyingState) return;
    $b4e14b6b8da86996$var$handleGameFinished();
});
$b4e14b6b8da86996$var$syncTabletViewportHeight();
window.addEventListener("resize", $b4e14b6b8da86996$var$syncTabletViewportHeight);
window.addEventListener("orientationchange", $b4e14b6b8da86996$var$syncTabletViewportHeight);
if (typeof $b4e14b6b8da86996$var$tabletViewportQuery.addEventListener === "function") $b4e14b6b8da86996$var$tabletViewportQuery.addEventListener("change", $b4e14b6b8da86996$var$syncTabletViewportHeight);
else $b4e14b6b8da86996$var$tabletViewportQuery.addListener($b4e14b6b8da86996$var$syncTabletViewportHeight);
window.visualViewport?.addEventListener("resize", $b4e14b6b8da86996$var$syncTabletViewportHeight);
window.visualViewport?.addEventListener("scroll", $b4e14b6b8da86996$var$syncTabletViewportHeight);
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $f79613d1242335be$export$cb6bc6487192e324)();
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.initialize();
    $b4e14b6b8da86996$var$seedInputElement = document.getElementById("seed-input");
    $b4e14b6b8da86996$var$seedQrCodeElement = document.getElementById("seed-qr-code");
    $b4e14b6b8da86996$var$hiveToggleElement = document.getElementById("hive-toggle");
    $b4e14b6b8da86996$var$cellarToggleElement = document.getElementById("cellar-toggle");
    $b4e14b6b8da86996$var$advancedCardsToggleElement = document.getElementById("advanced-cards-toggle");
    $b4e14b6b8da86996$var$cellarGameDisplayElement = document.getElementById("cellar-game-display");
    $b4e14b6b8da86996$var$cellarGameLabelElement = document.getElementById("cellar-game-label");
    $b4e14b6b8da86996$var$cellarOverlayElement = document.getElementById("cellar-campaign-overlay");
    $b4e14b6b8da86996$var$cellarEyebrowElement = document.getElementById("cellar-campaign-eyebrow");
    $b4e14b6b8da86996$var$cellarTitleElement = document.getElementById("cellar-campaign-title");
    $b4e14b6b8da86996$var$cellarDescriptionElement = document.getElementById("cellar-campaign-description");
    $b4e14b6b8da86996$var$cellarSummaryElement = document.getElementById("cellar-campaign-summary");
    $b4e14b6b8da86996$var$cellarFiltersElement = document.getElementById("cellar-campaign-filters");
    $b4e14b6b8da86996$var$cellarCardGridElement = document.getElementById("cellar-campaign-card-grid");
    $b4e14b6b8da86996$var$cellarNextPlayerButton = document.getElementById("cellar-next-player-btn");
    $b4e14b6b8da86996$var$cellarDoneButton = document.getElementById("cellar-done-btn");
    $b4e14b6b8da86996$var$cellarNextGameButton = document.getElementById("cellar-next-game-btn");
    $b4e14b6b8da86996$var$cellarCloseButton = document.getElementById("cellar-close-btn");
    $b4e14b6b8da86996$var$initializeSeedAndToggles();
    $b4e14b6b8da86996$var$setupSeedControls();
    $b4e14b6b8da86996$var$setupAppMenu();
    $b4e14b6b8da86996$var$setupCardRowToggles();
    $b4e14b6b8da86996$var$setupCellarCampaignControls();
    $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
});
function $b4e14b6b8da86996$var$initializeSeedAndToggles() {
    const extraPath = window.location.pathname;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const seedFromQuery = urlSearchParams.get("seed");
    const extraPathClean = extraPath.replace("/", "");
    const hasLegacySeedRoute = seedFromQuery != null && seedFromQuery.trim() !== "" || extraPathClean !== "";
    $b4e14b6b8da86996$export$5fa7964489d65dce = extraPathClean;
    const expansions = $b4e14b6b8da86996$var$parseExpansionParam(urlSearchParams);
    $b4e14b6b8da86996$var$hiveExpansionEnabled = expansions.includes("hive");
    $b4e14b6b8da86996$var$cellarExpansionEnabled = expansions.includes("cellar");
    $b4e14b6b8da86996$var$advancedCardsEnabled = $b4e14b6b8da86996$var$parseAdvancedCardsParam(urlSearchParams, hasLegacySeedRoute);
    if (seedFromQuery != null && seedFromQuery.trim() !== "") $b4e14b6b8da86996$export$cd94982b18c6332c = new (0, $2a5aca95b098c3c4$export$a92776769f460054)(seedFromQuery);
    else if ($b4e14b6b8da86996$export$5fa7964489d65dce !== "") $b4e14b6b8da86996$export$cd94982b18c6332c = new (0, $2a5aca95b098c3c4$export$a92776769f460054)($b4e14b6b8da86996$export$5fa7964489d65dce);
    $b4e14b6b8da86996$var$applySeedExpansionRequirements();
    if ($b4e14b6b8da86996$var$cellarExpansionEnabled) $b4e14b6b8da86996$var$campaignState = $b4e14b6b8da86996$var$createCampaignStateFromUrl(urlSearchParams);
    $b4e14b6b8da86996$var$seedInputElement.value = $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString();
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.setSeed($b4e14b6b8da86996$var$seedInputElement.value);
}
function $b4e14b6b8da86996$var$setupSeedControls() {
    const useSeedBtn = document.getElementById("use-seed-btn");
    const randomSeedBtn = document.getElementById("random-seed-btn");
    if ($b4e14b6b8da86996$var$seedInputElement == null || useSeedBtn == null) return;
    $b4e14b6b8da86996$var$seedInputElement.value = $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString();
    const applySeed = (seed)=>{
        const enteredSeed = seed.trim();
        if (!enteredSeed) {
            console.error("No seed entered");
            return;
        }
        $b4e14b6b8da86996$var$seedInputElement.value = enteredSeed;
        $b4e14b6b8da86996$export$cd94982b18c6332c = new (0, $2a5aca95b098c3c4$export$a92776769f460054)(enteredSeed);
        $b4e14b6b8da86996$export$dbf60eeb5e81ac26.setSeed($b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString());
        $b4e14b6b8da86996$var$applySeedExpansionRequirements();
        $b4e14b6b8da86996$var$campaignState = $b4e14b6b8da86996$var$cellarExpansionEnabled ? $b4e14b6b8da86996$var$createInitialCampaignState() : null;
        $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
    };
    useSeedBtn.addEventListener("click", ()=>{
        applySeed($b4e14b6b8da86996$var$seedInputElement.value);
    });
    randomSeedBtn?.addEventListener("click", ()=>{
        applySeed((0, $2a5aca95b098c3c4$export$a92776769f460054).generateSeedName());
    });
}
function $b4e14b6b8da86996$var$setupAppMenu() {
    const menuCell = document.querySelector(".menu-cell");
    const menuButton = document.getElementById("menu-button");
    const appMenu = document.getElementById("app-menu");
    const timerToggle = document.getElementById("timer-toggle");
    if (menuCell == null || menuButton == null || appMenu == null) return;
    const setSwitchState = (toggle, isOn)=>{
        if (toggle == null) return;
        toggle.classList.toggle("is-on", isOn);
        toggle.setAttribute("aria-checked", isOn.toString());
    };
    const setMenuOpen = (isOpen)=>{
        menuCell.classList.toggle("is-open", isOpen);
        menuButton.setAttribute("aria-expanded", isOpen.toString());
        menuButton.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
        appMenu.setAttribute("aria-hidden", (!isOpen).toString());
    };
    menuButton.addEventListener("click", (event)=>{
        event.stopPropagation();
        setMenuOpen(!menuCell.classList.contains("is-open"));
    });
    appMenu.addEventListener("click", (event)=>{
        event.stopPropagation();
    });
    document.addEventListener("click", ()=>{
        setMenuOpen(false);
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") setMenuOpen(false);
    });
    setSwitchState(timerToggle, $b4e14b6b8da86996$export$a62be19d50c35c62.isTimerEnabled());
    setSwitchState($b4e14b6b8da86996$var$hiveToggleElement, $b4e14b6b8da86996$var$hiveExpansionEnabled);
    setSwitchState($b4e14b6b8da86996$var$cellarToggleElement, $b4e14b6b8da86996$var$cellarExpansionEnabled);
    setSwitchState($b4e14b6b8da86996$var$advancedCardsToggleElement, $b4e14b6b8da86996$var$advancedCardsEnabled);
    timerToggle?.addEventListener("click", ()=>{
        const isOn = !timerToggle.classList.contains("is-on");
        $b4e14b6b8da86996$export$a62be19d50c35c62.setTimerEnabled(isOn);
        setSwitchState(timerToggle, $b4e14b6b8da86996$export$a62be19d50c35c62.isTimerEnabled());
        $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
    });
    $b4e14b6b8da86996$var$hiveToggleElement?.addEventListener("click", ()=>{
        $b4e14b6b8da86996$var$hiveExpansionEnabled = !$b4e14b6b8da86996$var$hiveExpansionEnabled;
        if ($b4e14b6b8da86996$var$hiveExpansionEnabled) {
            $b4e14b6b8da86996$var$cellarExpansionEnabled = false;
            $b4e14b6b8da86996$var$campaignState = null;
        }
        setSwitchState($b4e14b6b8da86996$var$hiveToggleElement, $b4e14b6b8da86996$var$hiveExpansionEnabled);
        setSwitchState($b4e14b6b8da86996$var$cellarToggleElement, $b4e14b6b8da86996$var$cellarExpansionEnabled);
        $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
    });
    $b4e14b6b8da86996$var$cellarToggleElement?.addEventListener("click", ()=>{
        $b4e14b6b8da86996$var$cellarExpansionEnabled = !$b4e14b6b8da86996$var$cellarExpansionEnabled;
        if ($b4e14b6b8da86996$var$cellarExpansionEnabled) {
            $b4e14b6b8da86996$var$hiveExpansionEnabled = false;
            $b4e14b6b8da86996$var$campaignState = $b4e14b6b8da86996$var$createInitialCampaignState();
        } else {
            $b4e14b6b8da86996$var$campaignState = null;
            $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
        }
        setSwitchState($b4e14b6b8da86996$var$cellarToggleElement, $b4e14b6b8da86996$var$cellarExpansionEnabled);
        setSwitchState($b4e14b6b8da86996$var$hiveToggleElement, $b4e14b6b8da86996$var$hiveExpansionEnabled);
        $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
    });
    $b4e14b6b8da86996$var$advancedCardsToggleElement?.addEventListener("click", ()=>{
        $b4e14b6b8da86996$var$advancedCardsEnabled = !$b4e14b6b8da86996$var$advancedCardsEnabled;
        setSwitchState($b4e14b6b8da86996$var$advancedCardsToggleElement, $b4e14b6b8da86996$var$advancedCardsEnabled);
        $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
    });
}
function $b4e14b6b8da86996$var$setupCardRowToggles() {
    const mobileLayoutQuery = window.matchMedia("(max-width: 768px)");
    const toggles = Array.from(document.querySelectorAll(".row-toggle"));
    const cardRows = Array.from(document.querySelectorAll(".card-row"));
    const cardContainer = document.querySelector(".card-container");
    const topRows = document.querySelector(".top-rows");
    const bottomRow = document.querySelector(".bottom-row");
    const areRowsCollapsed = (container)=>{
        const rows = Array.from(container?.querySelectorAll(".card-row:not(.is-hidden)") ?? []);
        return rows.length > 0 && rows.every((row)=>row.classList.contains("is-collapsed"));
    };
    const updateLayoutState = ()=>{
        const topSectionsCollapsed = areRowsCollapsed(topRows);
        const bottomSectionCollapsed = areRowsCollapsed(bottomRow);
        topRows?.classList.toggle("is-fully-collapsed", topSectionsCollapsed);
        bottomRow?.classList.toggle("is-fully-collapsed", bottomSectionCollapsed);
        cardContainer?.classList.toggle("top-sections-collapsed", topSectionsCollapsed);
        cardContainer?.classList.toggle("has-collapsed-rows", cardRows.some((row)=>!row.classList.contains("is-hidden") && row.classList.contains("is-collapsed")));
    };
    const setCollapsed = (toggle, cardRow, sectionName, isCollapsed)=>{
        cardRow.classList.toggle("is-collapsed", isCollapsed);
        toggle.textContent = isCollapsed ? "+" : "-";
        toggle.setAttribute("aria-expanded", (!isCollapsed).toString());
        toggle.setAttribute("aria-label", `${isCollapsed ? "Show" : "Minimize"} ${sectionName}`);
        updateLayoutState();
    };
    const syncToggleAvailability = ()=>{
        toggles.forEach((toggle)=>{
            const cardRow = toggle.closest(".card-row");
            const sectionName = toggle.dataset.sectionName ?? "section";
            toggle.disabled = !mobileLayoutQuery.matches;
            if (cardRow != null && !mobileLayoutQuery.matches) setCollapsed(toggle, cardRow, sectionName, false);
        });
    };
    toggles.forEach((toggle)=>{
        const cardRow = toggle.closest(".card-row");
        const sectionName = toggle.dataset.sectionName ?? "section";
        if (cardRow == null) return;
        setCollapsed(toggle, cardRow, sectionName, false);
        toggle.addEventListener("click", (event)=>{
            event.stopPropagation();
            if (!mobileLayoutQuery.matches) {
                setCollapsed(toggle, cardRow, sectionName, false);
                return;
            }
            setCollapsed(toggle, cardRow, sectionName, !cardRow.classList.contains("is-collapsed"));
        });
    });
    syncToggleAvailability();
    window.addEventListener("resize", syncToggleAvailability);
    window.addEventListener("orientationchange", syncToggleAvailability);
    window.addEventListener("card-row-visibility-change", updateLayoutState);
}
function $b4e14b6b8da86996$var$setupCellarCampaignControls() {
    $b4e14b6b8da86996$var$cellarNextPlayerButton?.addEventListener("click", ()=>{
        if ($b4e14b6b8da86996$var$campaignState == null) return;
        if ($b4e14b6b8da86996$var$campaignState.phase === "opening-draft") {
            $b4e14b6b8da86996$var$finalizeOpeningDraftPick();
            $b4e14b6b8da86996$var$campaignState.openingCurrentOfferNames = $b4e14b6b8da86996$var$generateCellarOffer($b4e14b6b8da86996$var$campaignState.openingChosenNames);
            $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
            $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
            return;
        }
        if ($b4e14b6b8da86996$var$campaignState.phase === "carryover-draft") {
            $b4e14b6b8da86996$var$finalizeCarryoverDraftPick();
            $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
            $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
        }
    });
    $b4e14b6b8da86996$var$cellarDoneButton?.addEventListener("click", ()=>{
        if ($b4e14b6b8da86996$var$campaignState == null) return;
        if ($b4e14b6b8da86996$var$campaignState.phase === "opening-draft") {
            if ($b4e14b6b8da86996$var$campaignState.openingCurrentPickName != null || $b4e14b6b8da86996$var$campaignState.openingChosenNames.length === 0) return;
            $b4e14b6b8da86996$var$campaignState.currentGuaranteedNames = $b4e14b6b8da86996$var$campaignState.openingChosenNames.slice();
            $b4e14b6b8da86996$var$campaignState.phase = "in-game";
            $b4e14b6b8da86996$var$campaignState.openingCurrentOfferNames = [];
            $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
            return;
        }
        if ($b4e14b6b8da86996$var$campaignState.phase === "carryover-draft") {
            if ($b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName != null || $b4e14b6b8da86996$var$campaignState.carryoverChosenNames.length === 0) return;
            $b4e14b6b8da86996$var$campaignState.gameNumber = Math.min(3, $b4e14b6b8da86996$var$campaignState.gameNumber + 1);
            $b4e14b6b8da86996$var$campaignState.currentGuaranteedNames = $b4e14b6b8da86996$var$campaignState.carryoverChosenNames.slice();
            $b4e14b6b8da86996$var$campaignState.carryoverChosenNames = [];
            $b4e14b6b8da86996$var$campaignState.carryoverAvailableNames = [];
            $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName = null;
            $b4e14b6b8da86996$var$campaignState.draftFilter = "all";
            $b4e14b6b8da86996$var$campaignState.phase = "between-games";
            $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
            $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
        }
    });
    $b4e14b6b8da86996$var$cellarNextGameButton?.addEventListener("click", ()=>{
        if ($b4e14b6b8da86996$var$campaignState == null || $b4e14b6b8da86996$var$campaignState.phase !== "between-games") return;
        $b4e14b6b8da86996$var$campaignState.phase = "in-game";
        $b4e14b6b8da86996$var$startFlowForCurrentSettings(true);
    });
    $b4e14b6b8da86996$var$cellarCloseButton?.addEventListener("click", ()=>{
        if ($b4e14b6b8da86996$var$campaignState?.phase === "complete") $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
    });
}
function $b4e14b6b8da86996$var$createInitialCampaignState() {
    return {
        gameNumber: 1,
        phase: "opening-draft",
        currentGuaranteedNames: [],
        openingChosenNames: [],
        openingCurrentOfferNames: $b4e14b6b8da86996$var$generateCellarOffer([]),
        openingCurrentPickName: null,
        carryoverChosenNames: [],
        carryoverAvailableNames: [],
        carryoverCurrentPickName: null,
        draftFilter: "all"
    };
}
function $b4e14b6b8da86996$var$createCampaignStateFromUrl(searchParams) {
    const rawGameNumber = Number.parseInt(searchParams.get("cg") ?? "1", 10);
    const gameNumber = rawGameNumber === 2 || rawGameNumber === 3 ? rawGameNumber : 1;
    const guaranteedNames = (0, $75cf632b34b11e25$export$aa3f93a482aeb601)(searchParams.get("cc") ?? "");
    return {
        gameNumber: gameNumber,
        phase: guaranteedNames.length > 0 || gameNumber > 1 ? "in-game" : "opening-draft",
        currentGuaranteedNames: guaranteedNames.slice(),
        openingChosenNames: gameNumber === 1 ? guaranteedNames.slice() : [],
        openingCurrentOfferNames: gameNumber === 1 && guaranteedNames.length === 0 ? $b4e14b6b8da86996$var$generateCellarOffer([]) : [],
        openingCurrentPickName: null,
        carryoverChosenNames: [],
        carryoverAvailableNames: [],
        carryoverCurrentPickName: null,
        draftFilter: "all"
    };
}
function $b4e14b6b8da86996$var$applySeedExpansionRequirements() {
    const requiresCellar = (0, $ff80734700dcac50$export$b8db1089c8443214)($b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed());
    const requiresHive = (0, $ff80734700dcac50$export$42726379da0917dc)($b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed());
    if (requiresCellar) {
        $b4e14b6b8da86996$var$cellarExpansionEnabled = true;
        $b4e14b6b8da86996$var$hiveExpansionEnabled = false;
    }
    if (requiresHive) {
        $b4e14b6b8da86996$var$hiveExpansionEnabled = true;
        $b4e14b6b8da86996$var$cellarExpansionEnabled = false;
        $b4e14b6b8da86996$var$campaignState = null;
    }
    // Event seeds select their required expansion; other seeds unlock the controls.
    if ($b4e14b6b8da86996$var$cellarToggleElement != null) $b4e14b6b8da86996$var$cellarToggleElement.disabled = requiresCellar || requiresHive;
    if ($b4e14b6b8da86996$var$hiveToggleElement != null) $b4e14b6b8da86996$var$hiveToggleElement.disabled = requiresCellar || requiresHive;
}
function $b4e14b6b8da86996$var$startFlowForCurrentSettings(resetRoundManager) {
    $b4e14b6b8da86996$var$isApplyingState = true;
    $b4e14b6b8da86996$var$applySeedExpansionRequirements();
    $b4e14b6b8da86996$var$syncToggleVisualState();
    if ($b4e14b6b8da86996$var$seedInputElement != null) $b4e14b6b8da86996$var$seedInputElement.value = $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString();
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.setSeed($b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString());
    $b4e14b6b8da86996$var$syncCellarGameDisplay();
    if ($b4e14b6b8da86996$var$cellarExpansionEnabled) {
        if ($b4e14b6b8da86996$var$campaignState == null) $b4e14b6b8da86996$var$campaignState = $b4e14b6b8da86996$var$createInitialCampaignState();
        if ($b4e14b6b8da86996$var$campaignState.phase === "opening-draft" || $b4e14b6b8da86996$var$campaignState.phase === "carryover-draft" || $b4e14b6b8da86996$var$campaignState.phase === "between-games" || $b4e14b6b8da86996$var$campaignState.phase === "complete") {
            if ($b4e14b6b8da86996$var$campaignState.phase === "opening-draft" && $b4e14b6b8da86996$var$campaignState.openingCurrentOfferNames.length === 0) $b4e14b6b8da86996$var$campaignState.openingCurrentOfferNames = $b4e14b6b8da86996$var$generateCellarOffer($b4e14b6b8da86996$var$campaignState.openingChosenNames);
            $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
        } else $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
    } else {
        $b4e14b6b8da86996$var$campaignState = null;
        $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
    }
    if (!$b4e14b6b8da86996$var$cellarExpansionEnabled || $b4e14b6b8da86996$var$campaignState?.phase === "in-game" || $b4e14b6b8da86996$var$campaignState?.phase === "carryover-draft" || $b4e14b6b8da86996$var$campaignState?.phase === "between-games" || $b4e14b6b8da86996$var$campaignState?.phase === "complete") $b4e14b6b8da86996$var$setupBoardForCurrentGame(resetRoundManager);
    $b4e14b6b8da86996$var$isApplyingState = false;
    $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
}
function $b4e14b6b8da86996$var$syncCellarGameDisplay() {
    if ($b4e14b6b8da86996$var$cellarGameDisplayElement == null || $b4e14b6b8da86996$var$cellarGameLabelElement == null) return;
    const showCellarGame = $b4e14b6b8da86996$var$cellarExpansionEnabled && $b4e14b6b8da86996$var$campaignState != null;
    $b4e14b6b8da86996$var$cellarGameDisplayElement.classList.toggle("is-hidden", !showCellarGame);
    if (!showCellarGame) return;
    $b4e14b6b8da86996$var$cellarGameLabelElement.textContent = `Cellar Game ${$b4e14b6b8da86996$var$campaignState.gameNumber}`;
}
function $b4e14b6b8da86996$var$setupBoardForCurrentGame(resetRoundManager) {
    if (resetRoundManager) {
        $b4e14b6b8da86996$export$a62be19d50c35c62.resetRounds();
        $b4e14b6b8da86996$export$cd94982b18c6332c.restartGame();
        if ($b4e14b6b8da86996$var$cellarExpansionEnabled && $b4e14b6b8da86996$var$campaignState != null && $b4e14b6b8da86996$var$campaignState.gameNumber > 1) $b4e14b6b8da86996$export$cd94982b18c6332c.advance(($b4e14b6b8da86996$var$campaignState.gameNumber - 1) * 100);
    }
    if ($b4e14b6b8da86996$export$cd94982b18c6332c.savedGame === true && $b4e14b6b8da86996$export$cd94982b18c6332c.savedGameFile != null) $b4e14b6b8da86996$export$53d0237de85c0eef.SetupFixedDecks($b4e14b6b8da86996$export$cd94982b18c6332c.savedGameFile);
    else $b4e14b6b8da86996$export$53d0237de85c0eef.SetupDecks({
        hiveExpansionEnabled: $b4e14b6b8da86996$var$hiveExpansionEnabled,
        cellarExpansionEnabled: $b4e14b6b8da86996$var$cellarExpansionEnabled,
        includeAdvancedCards: $b4e14b6b8da86996$var$advancedCardsEnabled,
        guaranteedActionCardNames: $b4e14b6b8da86996$var$getCurrentGuaranteedCardNames(),
        currentSeed: $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(),
        campaignGameNumber: $b4e14b6b8da86996$var$campaignState?.gameNumber ?? 1
    });
    $b4e14b6b8da86996$export$53d0237de85c0eef.ShowCurrentCards();
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.setEnabled($b4e14b6b8da86996$var$hiveExpansionEnabled, $b4e14b6b8da86996$export$a62be19d50c35c62.getCurrentRound());
    $b4e14b6b8da86996$export$dbf60eeb5e81ac26.showRound($b4e14b6b8da86996$export$a62be19d50c35c62.getCurrentRound(), false);
}
function $b4e14b6b8da86996$var$syncToggleVisualState() {
    const applyState = (toggle, isOn)=>{
        if (toggle == null) return;
        toggle.classList.toggle("is-on", isOn);
        toggle.setAttribute("aria-checked", isOn.toString());
    };
    applyState($b4e14b6b8da86996$var$hiveToggleElement, $b4e14b6b8da86996$var$hiveExpansionEnabled);
    applyState($b4e14b6b8da86996$var$cellarToggleElement, $b4e14b6b8da86996$var$cellarExpansionEnabled);
    applyState($b4e14b6b8da86996$var$advancedCardsToggleElement, $b4e14b6b8da86996$var$advancedCardsEnabled);
}
function $b4e14b6b8da86996$var$getCurrentGuaranteedCardNames() {
    if (!$b4e14b6b8da86996$var$cellarExpansionEnabled || $b4e14b6b8da86996$var$campaignState == null) return [];
    return $b4e14b6b8da86996$var$campaignState.currentGuaranteedNames.slice();
}
function $b4e14b6b8da86996$var$handleGameFinished() {
    if (!$b4e14b6b8da86996$var$cellarExpansionEnabled || $b4e14b6b8da86996$var$campaignState == null) {
        $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
        return;
    }
    if ($b4e14b6b8da86996$var$campaignState.gameNumber >= 3) {
        $b4e14b6b8da86996$var$campaignState.phase = "complete";
        $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
        $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
        return;
    }
    $b4e14b6b8da86996$var$campaignState.phase = "carryover-draft";
    $b4e14b6b8da86996$var$campaignState.carryoverChosenNames = [];
    $b4e14b6b8da86996$var$campaignState.carryoverAvailableNames = $b4e14b6b8da86996$export$53d0237de85c0eef.getCurrentGameActionCardNames({
        excludeStarterCards: true
    });
    $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName = null;
    $b4e14b6b8da86996$var$campaignState.draftFilter = "all";
    $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
    $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
}
function $b4e14b6b8da86996$var$finalizeOpeningDraftPick() {
    if ($b4e14b6b8da86996$var$campaignState == null || $b4e14b6b8da86996$var$campaignState.openingCurrentPickName == null) return;
    if (!$b4e14b6b8da86996$var$campaignState.openingChosenNames.includes($b4e14b6b8da86996$var$campaignState.openingCurrentPickName)) $b4e14b6b8da86996$var$campaignState.openingChosenNames.push($b4e14b6b8da86996$var$campaignState.openingCurrentPickName);
    $b4e14b6b8da86996$var$campaignState.openingCurrentPickName = null;
}
function $b4e14b6b8da86996$var$finalizeCarryoverDraftPick() {
    if ($b4e14b6b8da86996$var$campaignState == null || $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName == null) return;
    if (!$b4e14b6b8da86996$var$campaignState.carryoverChosenNames.includes($b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName)) $b4e14b6b8da86996$var$campaignState.carryoverChosenNames.push($b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName);
    $b4e14b6b8da86996$var$campaignState.carryoverAvailableNames = $b4e14b6b8da86996$var$campaignState.carryoverAvailableNames.filter((cardName)=>cardName !== $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName);
    $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName = null;
}
function $b4e14b6b8da86996$var$generateCellarOffer(excludedNames) {
    const excluded = new Set(excludedNames);
    const offer = [];
    const cellarSeed = `${$b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed()}|cellar|game-${$b4e14b6b8da86996$var$campaignState?.gameNumber ?? 1}|picked-${excludedNames.slice().sort().join(",")}`;
    for (const season of [
        1,
        2,
        3
    ]){
        const seasonCards = $b4e14b6b8da86996$var$cellarOfferPool.filter((card)=>card.season === season && !excluded.has(card.name));
        if (seasonCards.length === 0) continue;
        const selectedCard = seasonCards[$b4e14b6b8da86996$var$getDeterministicCellarIndex(`${cellarSeed}|season-${season}`, seasonCards.length)];
        offer.push(selectedCard.name);
    }
    return offer;
}
function $b4e14b6b8da86996$var$getDeterministicCellarIndex(seed, length) {
    if (length <= 1) return 0;
    const hash = $b4e14b6b8da86996$var$hashCellarSeed(seed);
    return Math.abs(hash) % length;
}
function $b4e14b6b8da86996$var$hashCellarSeed(value) {
    let hash = 0;
    for(let index = 0; index < value.length; index++){
        hash = (hash << 5) - hash + value.charCodeAt(index);
        hash |= 0;
    }
    return hash;
}
function $b4e14b6b8da86996$var$renderCellarCampaignOverlay() {
    if ($b4e14b6b8da86996$var$cellarOverlayElement == null || $b4e14b6b8da86996$var$campaignState == null || !$b4e14b6b8da86996$var$cellarExpansionEnabled) {
        $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
        return;
    }
    if ($b4e14b6b8da86996$var$campaignState.phase === "in-game") {
        $b4e14b6b8da86996$var$hideCellarCampaignOverlay();
        return;
    }
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.toggle("is-opening-draft", $b4e14b6b8da86996$var$campaignState.phase === "opening-draft");
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.toggle("is-carryover-draft", $b4e14b6b8da86996$var$campaignState.phase === "carryover-draft");
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.toggle("is-between-games", $b4e14b6b8da86996$var$campaignState.phase === "between-games");
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.toggle("is-complete", $b4e14b6b8da86996$var$campaignState.phase === "complete");
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.add("show");
    $b4e14b6b8da86996$var$cellarOverlayElement.setAttribute("aria-hidden", "false");
    document.body.classList.add("cellar-campaign-active");
    if ($b4e14b6b8da86996$var$campaignState.phase === "opening-draft") {
        $b4e14b6b8da86996$var$renderOpeningDraftOverlay();
        return;
    }
    if ($b4e14b6b8da86996$var$campaignState.phase === "carryover-draft") {
        $b4e14b6b8da86996$var$renderCarryoverDraftOverlay();
        return;
    }
    if ($b4e14b6b8da86996$var$campaignState.phase === "between-games") {
        $b4e14b6b8da86996$var$renderBetweenGamesOverlay();
        return;
    }
    $b4e14b6b8da86996$var$renderCampaignCompleteOverlay();
}
function $b4e14b6b8da86996$var$renderOpeningDraftOverlay() {
    if ($b4e14b6b8da86996$var$campaignState == null) return;
    $b4e14b6b8da86996$var$setCampaignOverlayText("", "Choose a Cellar Card", "");
    $b4e14b6b8da86996$var$setSummaryHtml("Have each player choose a card for this first game.");
    $b4e14b6b8da86996$var$renderFilters([]);
    const offerCards = $b4e14b6b8da86996$var$campaignState.openingCurrentOfferNames.map((cardName)=>(0, $75cf632b34b11e25$export$350f35cc8fe14249)(cardName)).filter((card)=>card != null);
    $b4e14b6b8da86996$var$renderCardChoices(offerCards, $b4e14b6b8da86996$var$campaignState.openingCurrentPickName, new Set(), (card)=>{
        if ($b4e14b6b8da86996$var$campaignState == null) return;
        $b4e14b6b8da86996$var$campaignState.openingCurrentPickName = $b4e14b6b8da86996$var$campaignState.openingCurrentPickName === card.name ? null : card.name;
        $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
        $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
    });
    if ($b4e14b6b8da86996$var$cellarNextPlayerButton != null) $b4e14b6b8da86996$var$cellarNextPlayerButton.textContent = "Select";
    if ($b4e14b6b8da86996$var$cellarDoneButton != null) $b4e14b6b8da86996$var$cellarDoneButton.textContent = "Done";
    $b4e14b6b8da86996$var$setCampaignButtons({
        nextPlayerVisible: true,
        doneVisible: true,
        nextGameVisible: false,
        closeVisible: false,
        nextPlayerDisabled: $b4e14b6b8da86996$var$campaignState.openingCurrentPickName == null,
        doneDisabled: $b4e14b6b8da86996$var$campaignState.openingCurrentPickName != null || $b4e14b6b8da86996$var$campaignState.openingChosenNames.length === 0
    });
}
function $b4e14b6b8da86996$var$renderCarryoverDraftOverlay() {
    if ($b4e14b6b8da86996$var$campaignState == null) return;
    $b4e14b6b8da86996$var$setCampaignOverlayText("", "Draft Cards for Next Game", "");
    $b4e14b6b8da86996$var$setSummaryHtml(`
        All players should choose one card to carry over to the next game. Draft in order from most points to least.
    `);
    $b4e14b6b8da86996$var$renderFilters([]);
    const unavailableCards = new Set($b4e14b6b8da86996$var$campaignState.carryoverChosenNames);
    const visibleCards = $b4e14b6b8da86996$var$campaignState.carryoverAvailableNames.map((cardName)=>(0, $75cf632b34b11e25$export$350f35cc8fe14249)(cardName)).filter((card)=>card != null).filter((card)=>$b4e14b6b8da86996$var$campaignState.carryoverAvailableNames.includes(card.name));
    $b4e14b6b8da86996$var$renderCardChoices(visibleCards, $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName, unavailableCards, (card)=>{
        if ($b4e14b6b8da86996$var$campaignState == null) return;
        $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName = $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName === card.name ? null : card.name;
        $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
        $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
    });
    if ($b4e14b6b8da86996$var$cellarNextPlayerButton != null) $b4e14b6b8da86996$var$cellarNextPlayerButton.textContent = "Select";
    if ($b4e14b6b8da86996$var$cellarDoneButton != null) $b4e14b6b8da86996$var$cellarDoneButton.textContent = "Done";
    $b4e14b6b8da86996$var$setCampaignButtons({
        nextPlayerVisible: true,
        doneVisible: true,
        nextGameVisible: false,
        closeVisible: false,
        nextPlayerDisabled: $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName == null,
        doneDisabled: $b4e14b6b8da86996$var$campaignState.carryoverCurrentPickName != null || $b4e14b6b8da86996$var$campaignState.carryoverChosenNames.length === 0
    });
}
function $b4e14b6b8da86996$var$renderBetweenGamesOverlay() {
    if ($b4e14b6b8da86996$var$campaignState == null) return;
    $b4e14b6b8da86996$var$setCampaignOverlayText("", `Ready for Game ${$b4e14b6b8da86996$var$campaignState.gameNumber}`, "");
    $b4e14b6b8da86996$var$setSummaryHtml(`Screenshot this QR code to use for Game ${$b4e14b6b8da86996$var$campaignState.gameNumber}.`);
    $b4e14b6b8da86996$var$renderFilters([]);
    $b4e14b6b8da86996$var$renderCampaignQrCode($b4e14b6b8da86996$var$buildSeedShareUrl($b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString()).toString());
    $b4e14b6b8da86996$var$setCampaignButtons({
        nextPlayerVisible: false,
        doneVisible: false,
        nextGameVisible: true,
        closeVisible: false,
        nextPlayerDisabled: true,
        doneDisabled: true
    });
}
function $b4e14b6b8da86996$var$renderCampaignCompleteOverlay() {
    if ($b4e14b6b8da86996$var$campaignState == null) return;
    $b4e14b6b8da86996$var$setCampaignOverlayText("", "Game 3 is finished", "");
    $b4e14b6b8da86996$var$setSummaryHtml(`
        <strong>Final guaranteed cards used this game:</strong> ${$b4e14b6b8da86996$var$formatCardList($b4e14b6b8da86996$var$campaignState.currentGuaranteedNames) || "None"}
    `);
    $b4e14b6b8da86996$var$renderFilters([]);
    $b4e14b6b8da86996$var$renderCardChoices([], null, new Set(), ()=>undefined);
    $b4e14b6b8da86996$var$setCampaignButtons({
        nextPlayerVisible: false,
        doneVisible: false,
        nextGameVisible: false,
        closeVisible: true,
        nextPlayerDisabled: true,
        doneDisabled: true
    });
}
function $b4e14b6b8da86996$var$setCampaignOverlayText(eyebrow, title, description) {
    if ($b4e14b6b8da86996$var$cellarEyebrowElement != null) $b4e14b6b8da86996$var$cellarEyebrowElement.textContent = eyebrow;
    if ($b4e14b6b8da86996$var$cellarTitleElement != null) $b4e14b6b8da86996$var$cellarTitleElement.textContent = title;
    if ($b4e14b6b8da86996$var$cellarDescriptionElement != null) $b4e14b6b8da86996$var$cellarDescriptionElement.textContent = description;
}
function $b4e14b6b8da86996$var$setSummaryHtml(summaryHtml) {
    if ($b4e14b6b8da86996$var$cellarSummaryElement != null) $b4e14b6b8da86996$var$cellarSummaryElement.innerHTML = summaryHtml;
}
function $b4e14b6b8da86996$var$renderFilters(filters) {
    if ($b4e14b6b8da86996$var$cellarFiltersElement == null) return;
    $b4e14b6b8da86996$var$cellarFiltersElement.innerHTML = "";
    $b4e14b6b8da86996$var$cellarFiltersElement.style.display = filters.length === 0 ? "none" : "flex";
    for (const filter of filters){
        const button = document.createElement("button");
        button.type = "button";
        button.className = "cellar-filter-chip";
        button.textContent = filter.label;
        button.classList.toggle("is-active", $b4e14b6b8da86996$var$campaignState?.draftFilter === filter.value);
        button.addEventListener("click", ()=>{
            if ($b4e14b6b8da86996$var$campaignState == null) return;
            $b4e14b6b8da86996$var$campaignState.draftFilter = filter.value;
            $b4e14b6b8da86996$var$renderCellarCampaignOverlay();
            $b4e14b6b8da86996$var$syncSeedShare($b4e14b6b8da86996$var$seedQrCodeElement, $b4e14b6b8da86996$export$cd94982b18c6332c.getCurrentSeed().toString(), true);
        });
        $b4e14b6b8da86996$var$cellarFiltersElement.appendChild(button);
    }
}
function $b4e14b6b8da86996$var$renderCardChoices(cards, selectedName, unavailableNames, onSelect) {
    if ($b4e14b6b8da86996$var$cellarCardGridElement == null) return;
    $b4e14b6b8da86996$var$cellarCardGridElement.classList.remove("is-qr-mode");
    $b4e14b6b8da86996$var$cellarCardGridElement.innerHTML = "";
    if (cards.length === 0) return;
    for (const card of cards){
        const button = document.createElement("button");
        button.type = "button";
        button.className = "cellar-choice-card";
        button.classList.toggle("is-selected", selectedName === card.name);
        button.classList.toggle("is-disabled", unavailableNames.has(card.name));
        button.disabled = unavailableNames.has(card.name);
        button.addEventListener("click", ()=>{
            if (button.disabled) return;
            onSelect(card);
        });
        const preview = document.createElement("div");
        preview.className = "cellar-choice-preview";
        preview.style.backgroundImage = `url(${card.imageUrl})`;
        button.setAttribute("aria-label", card.name);
        button.title = card.name;
        button.appendChild(preview);
        $b4e14b6b8da86996$var$cellarCardGridElement.appendChild(button);
    }
}
function $b4e14b6b8da86996$var$renderCampaignQrCode(url) {
    if ($b4e14b6b8da86996$var$cellarCardGridElement == null) return;
    $b4e14b6b8da86996$var$cellarCardGridElement.classList.add("is-qr-mode");
    $b4e14b6b8da86996$var$cellarCardGridElement.innerHTML = "";
    const qrCanvas = document.createElement("canvas");
    qrCanvas.className = "cellar-campaign-qr-code";
    qrCanvas.setAttribute("aria-label", "QR code for the next game");
    const qrFrame = document.createElement("div");
    qrFrame.className = "cellar-campaign-qr-frame";
    const qrSize = Math.max(132, Math.min(280, Math.floor(window.innerHeight * 0.28)));
    qrFrame.style.width = `${qrSize}px`;
    qrFrame.style.height = `${qrSize}px`;
    qrCanvas.style.width = `${qrSize}px`;
    qrCanvas.style.height = `${qrSize}px`;
    qrFrame.appendChild(qrCanvas);
    $b4e14b6b8da86996$var$cellarCardGridElement.appendChild(qrFrame);
    (0, $092c7e998bebe629$export$f87f6982d1fd4f81)(qrCanvas, url, {
        errorCorrectionLevel: "M",
        margin: 1,
        width: qrSize,
        color: {
            dark: "#0f1618",
            light: "#ffffff"
        }
    }).catch((error)=>{
        console.error("Failed to render campaign QR code", error);
    });
}
function $b4e14b6b8da86996$var$setCampaignButtons(options) {
    if ($b4e14b6b8da86996$var$cellarNextPlayerButton != null) {
        $b4e14b6b8da86996$var$cellarNextPlayerButton.style.display = options.nextPlayerVisible ? "" : "none";
        $b4e14b6b8da86996$var$cellarNextPlayerButton.disabled = options.nextPlayerDisabled;
    }
    if ($b4e14b6b8da86996$var$cellarDoneButton != null) {
        $b4e14b6b8da86996$var$cellarDoneButton.style.display = options.doneVisible ? "" : "none";
        $b4e14b6b8da86996$var$cellarDoneButton.disabled = options.doneDisabled;
    }
    if ($b4e14b6b8da86996$var$cellarNextGameButton != null) $b4e14b6b8da86996$var$cellarNextGameButton.style.display = options.nextGameVisible ? "" : "none";
    if ($b4e14b6b8da86996$var$cellarCloseButton != null) $b4e14b6b8da86996$var$cellarCloseButton.style.display = options.closeVisible ? "" : "none";
}
function $b4e14b6b8da86996$var$hideCellarCampaignOverlay() {
    if ($b4e14b6b8da86996$var$cellarOverlayElement == null) return;
    $b4e14b6b8da86996$var$cellarOverlayElement.classList.remove("show");
    $b4e14b6b8da86996$var$cellarOverlayElement.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cellar-campaign-active");
}
function $b4e14b6b8da86996$var$matchesCampaignFilter(card, filter) {
    if (filter === "all") return true;
    if (filter === "season-1") return card.season === 1;
    if (filter === "season-2") return card.season === 2;
    if (filter === "season-3") return card.season === 3;
    return card.source === filter;
}
function $b4e14b6b8da86996$var$formatSeason(card) {
    return card.season == null ? "Starter" : `Season ${card.season}`;
}
function $b4e14b6b8da86996$var$formatCardList(cardNames) {
    return cardNames.join(", ");
}
function $b4e14b6b8da86996$var$syncTabletViewportHeight() {
    const root = document.documentElement;
    if (!$b4e14b6b8da86996$var$tabletViewportQuery.matches) {
        root.classList.remove("has-tablet-visual-viewport");
        root.style.removeProperty("--tablet-visible-height");
        return;
    }
    const visibleHeight = Math.floor(window.visualViewport?.height ?? window.innerHeight);
    if (visibleHeight <= 0) return;
    root.classList.add("has-tablet-visual-viewport");
    root.style.setProperty("--tablet-visible-height", `${visibleHeight}px`);
}
function $b4e14b6b8da86996$var$parseExpansionParam(searchParams) {
    return (searchParams.get("expansions") ?? "").split(",").map((expansion)=>expansion.trim().toLocaleLowerCase()).filter((expansion)=>expansion.length > 0);
}
function $b4e14b6b8da86996$var$parseAdvancedCardsParam(searchParams, legacyDefault) {
    const cardMode = (searchParams.get("cards") ?? searchParams.get("advanced") ?? "").trim().toLocaleLowerCase();
    if ([
        "advanced",
        "true",
        "1",
        "on"
    ].includes(cardMode)) return true;
    if ([
        "base",
        "basic",
        "not-advanced",
        "not_advanced",
        "false",
        "0",
        "off"
    ].includes(cardMode)) return false;
    return legacyDefault;
}
function $b4e14b6b8da86996$var$buildSeedShareUrl(seed) {
    const seedUrl = new URL(window.location.href);
    seedUrl.pathname = "/";
    seedUrl.search = "";
    seedUrl.hash = "";
    seedUrl.searchParams.set("seed", seed);
    seedUrl.searchParams.set("cards", $b4e14b6b8da86996$var$advancedCardsEnabled ? "advanced" : "base");
    const expansions = [];
    if ($b4e14b6b8da86996$var$hiveExpansionEnabled) expansions.push("hive");
    if ($b4e14b6b8da86996$var$cellarExpansionEnabled) expansions.push("cellar");
    if (expansions.length > 0) seedUrl.searchParams.set("expansions", expansions.join(","));
    if ($b4e14b6b8da86996$var$cellarExpansionEnabled) {
        const campaignGameNumber = $b4e14b6b8da86996$var$campaignState?.gameNumber ?? 1;
        const encodedGuaranteedCards = (0, $75cf632b34b11e25$export$f191e8e7d2a429d1)($b4e14b6b8da86996$var$campaignState?.currentGuaranteedNames ?? []);
        seedUrl.searchParams.set("cg", campaignGameNumber.toString());
        if (encodedGuaranteedCards.length > 0) seedUrl.searchParams.set("cc", encodedGuaranteedCards);
    }
    return seedUrl;
}
function $b4e14b6b8da86996$var$syncSeedShare(canvas, seed, updateAddressBar) {
    const seedUrl = $b4e14b6b8da86996$var$buildSeedShareUrl(seed);
    $b4e14b6b8da86996$var$updateSeedQrCode(canvas, seedUrl.toString());
    if (updateAddressBar) window.history.replaceState(null, "", `${seedUrl.pathname}${seedUrl.search}`);
}
function $b4e14b6b8da86996$var$updateSeedQrCode(canvas, seedUrl) {
    if (canvas == null) return;
    canvas.title = seedUrl;
    (0, $092c7e998bebe629$export$f87f6982d1fd4f81)(canvas, seedUrl, {
        errorCorrectionLevel: "M",
        margin: 1,
        width: 132,
        color: {
            dark: "#0f1618ff",
            light: "#ffffffff"
        }
    }).catch((error)=>{
        console.error("Failed to render seed QR code", error);
    });
}


//# sourceMappingURL=index.c73a36df.js.map
